import SvgIcon from '@material-ui/core/SvgIcon';

export const ShareIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M12 3a1 1 0 1 1 0 2H6c-.552 0-1 .449-1 1v12c0 .551.448 1 1 1h12c.552 0 1-.449 1-1v-6a1 1 0 1 1 2 0v6c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3zm4.005 0 3.997.02a1 1 0 0 1 .995.999L21 7.999a1 1 0 1 1-2 .002V6.415l-6.293 6.292a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6.285-6.285L15.995 5A1 1 0 0 1 16 3h.005z" />
    </SvgIcon>
  );
};

export const OutsandingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8,7c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S8,8.1,8,7z M10,13c-3.9,0-7,3.1-7,7c0,0.6,0.4,1,1,1s1-0.4,1-1
	c0-2.8,2.2-5,5-5s5,2.2,5,5c0,0.6,0.4,1,1,1s1-0.4,1-1C17,16.1,13.9,13,10,13z M6,7c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S6,9.2,6,7
	z M8,7c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2S8,5.9,8,7z M18.5,11.8c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7
	S18.9,11.8,18.5,11.8z M18.5,2.8c-1.5,0-2.7,1.2-2.7,2.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7c0-0.7,0.6-1.3,1.3-1.3
	s1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3l-0.1,0c-0.3,0-0.6,0.3-0.6,0.6v1l0,0.1l0,0.1C18,9,18.2,9.2,18.5,9.2l0.1,0l0.1,0
	C19,9,19.2,8.8,19.2,8.5V8.1l0,0L19.4,8c1.1-0.4,1.8-1.4,1.8-2.5C21.2,4,20,2.8,18.5,2.8z"
      />
    </SvgIcon>
  );
};

export const Support = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.2,8.7h-0.4C19.1,5,15.9,2.1,12,2.1C8.1,2.1,4.9,5,4.2,8.7H3.8c0,0,0,0,0,0c-0.9,0-1.8,0.4-2.5,1
	c-0.7,0.7-1,1.5-1,2.5v0.4c0,1.9,1.6,3.5,3.5,3.5h1c0.4,0,0.8-0.3,0.8-0.8v-2.9v-2.3c0-3.6,2.9-6.5,6.4-6.5c3.5,0,6.4,2.9,6.4,6.5
	v2.3v0.7v1.6c0,1.2-0.6,2.4-1.7,3.2c0,0-0.1,0.1-0.1,0.1c-0.4-0.8-1.2-1.3-2.1-1.3H14c-1.3,0-2.4,1.2-2.4,2.6s1.1,2.6,2.4,2.6h0.5
	c1.3,0,2.3-1.1,2.4-2.4c0.2-0.1,0.5-0.3,0.7-0.4c1.1-0.8,1.8-1.8,2.1-3h0.5c0,0,0,0,0,0c1.9,0,3.5-1.6,3.5-3.5v-0.4
	C23.7,10.3,22.1,8.7,20.2,8.7z M4.1,14.6H3.8c-1.1,0-2-0.9-2-2v-0.4c0-0.5,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6h0.3v2.2V14.6z
	 M14.5,20.4H14c-0.5,0-0.9-0.5-0.9-1.1c0-0.6,0.4-1.1,0.9-1.1h0.5c0.5,0,0.9,0.5,0.9,1.1S15,20.4,14.5,20.4z M22.2,12.6
	c0,1.1-0.9,2-2,2h-0.3v-1.5v-0.7v-2.2h0.3c1.1,0,2,0.9,2,2V12.6z"
      />
    </SvgIcon>
  );
};

export const Broom = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.6,10.4l-6,4.2c-0.3,0.2-0.3,0.6-0.1,0.9c0,0,0,0.1,0.1,0.1l4.6,4.6l2.4-3.6c0.2-0.3,0.6-0.4,0.9-0.2  c0.3,0.2,0.4,0.6,0.2,0.9L7,21.1l1.4,1.4c0.2,0.2,0.6,0.2,0.9,0c0,0,0.1-0.1,0.1-0.1l4-6.1L7.6,10.4z M22.5,1.5  c-0.2-0.2-0.6-0.2-0.9,0l-8.2,8.2C12,8.6,10,8.6,8.6,9.7l5.5,5.5c1-1.3,1.1-3.2,0.2-4.6l8.2-8.2C22.7,2.2,22.7,1.8,22.5,1.5  C22.5,1.5,22.5,1.5,22.5,1.5z" />
    </SvgIcon>
  );
};

export const ShowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,13.8c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S12.8,13.8,12,13.8 M12,8.8
	c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S13.9,8.8,12,8.8 M12.2,17.3c-4.3,0.1-7.1-3.6-8-5c1-1.6,3.6-4.9,7.6-5
	c4.3-0.1,7.1,3.6,8,5C18.8,13.9,16.2,17.2,12.2,17.3 M21.9,11.8c-0.6-1.1-4.2-6.7-10.1-6.5c-5.5,0.1-8.7,5-9.6,6.5
	c-0.2,0.3-0.2,0.7,0,1c0.6,1.1,4,6.5,9.9,6.5l0.2,0c5.5-0.1,8.7-5,9.6-6.5C22,12.5,22,12.1,21.9,11.8"
      />
    </SvgIcon>
  );
};

export const EyeHideIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.9,12.5c-0.9,1.5-1.9,2.8-3.2,4L18.1,15c1-0.9,1.8-1.9,2.5-3c-1-1.6-4.1-5.6-8.8-5.5
        c-0.7,0-1.3,0.1-1.9,0.3L8.2,5c1.1-0.5,2.3-0.7,3.6-0.7c6.6-0.2,10.4,5.9,11.1,7.1C23,11.8,23,12.2,22.9,12.5L22.9,12.5z M14.1,17.2
        l1.7,1.7c-1.2,0.5-2.5,0.7-3.8,0.7c-6.4,0-10.2-5.9-10.9-7.1c-0.2-0.3-0.2-0.8,0-1.1C2,10,3.1,8.6,4.4,7.5L5.9,9
        c-1,0.9-1.8,1.9-2.5,3c1,1.6,4.1,5.6,8.8,5.5C12.9,17.5,13.5,17.4,14.1,17.2z M12,13.6c-0.9,0-1.6-0.7-1.6-1.6c0,0,0-0.1,0-0.1
        L12,13.6C12.1,13.6,12,13.6,12,13.6z M4,2.4C3.5,2,2.8,2,2.4,2.4C2,2.9,2,3.5,2.4,4l6.2,6.2c-0.3,0.6-0.5,1.2-0.5,1.8
        c0,2.1,1.7,3.8,3.8,3.8c0.6,0,1.3-0.2,1.8-0.5l6.2,6.2c0.2,0.2,0.5,0.3,0.8,0.3c0.6,0,1.1-0.5,1.1-1.1c0-0.3-0.1-0.6-0.3-0.8L4,2.4
        L4,2.4z"
      />
    </SvgIcon>
  );
};

export const PinIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.4,10.1L14,1.6c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7l0.8,0.8L8.9,8.4c-1.4,1.4-3.7,1.4-5.1,0
        l-1.7,1.7l5.1,5.1l-5.9,5.9v1.7h1.7l5.9-5.9l5.1,5.1l1.7-1.7c-1.4-1.4-1.4-3.7,0-5.1l4.2-4.2l0.8,0.8c0.5,0.5,1.2,0.5,1.7,0
        S22.9,10.5,22.4,10.1"
      />
    </SvgIcon>
  );
};

export const broomDouble = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M11.5,14l4.2,4.3l-2.9,4.5c0,0,0,0.1-0.1,0.1c-0.2,0.2-0.5,0.2-0.6,0l-1-1l1.8-2.8c0.1-0.2,0.1-0.5-0.1-0.6  c0,0,0,0,0,0c-0.2-0.1-0.5-0.1-0.6,0.1l-1.7,2.6l-3.3-3.4c0,0,0,0,0-0.1c-0.2-0.2-0.1-0.5,0.1-0.7L11.5,14z M22.4,7.4L22.4,7.4  c-0.2-0.2-0.5-0.2-0.6,0c0,0,0,0,0,0l-6,6.1c-1-0.8-2.5-0.8-3.5,0l4,4.1c0.7-1,0.8-2.4,0.1-3.4l6-6.1C22.5,7.9,22.5,7.6,22.4,7.4z   M16.9,6.9c0.2-0.2,0.3-0.4,0.1-0.7c0,0,0,0,0-0.1l-3.3-3.4l-1.7,2.6c-0.1,0.2-0.4,0.3-0.6,0.1c0,0,0,0,0,0  c-0.2-0.1-0.3-0.4-0.1-0.6l1.8-2.8l-1-1c-0.2-0.2-0.5-0.2-0.6,0c0,0,0,0.1-0.1,0.1L8.3,5.7l4.2,4.3L16.9,6.9z M11.8,10.6l-4-4.1  C7,7.5,7,8.8,7.6,9.9l-6,6.1c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.6,0c0,0,0,0,0,0l6-6.1C9.3,11.4,10.7,11.4,11.8,10.6z" />
    </SvgIcon>
  );
};
export const PinBorderIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.8,10L14,1.2c-0.5-0.5-1.3-0.5-1.8,0s-0.5,1.3,0,1.8l0.9,0.9L8.7,8.2c-1.5,1.5-3.8,1.5-5.3,0
        L1.7,10L7,15.3l-6.2,6.2v1.8h1.8L8.7,17l5.3,5.3l1.8-1.8c-1.5-1.5-1.5-3.8,0-5.3l4.4-4.4l0.9,0.9c0.5,0.5,1.3,0.5,1.8,0
        C23.3,11.3,23.3,10.5,22.8,10 M18.4,9.1L14,13.5c-1,1-1.6,2.2-1.8,3.5L7,11.8c1.3-0.2,2.6-0.8,3.5-1.8l4.4-4.4L18.4,9.1"
      />
    </SvgIcon>
  );
};

export const UnPinIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M18.2,12.5l1.8-1.9l0.9,0.9c0.5,0.5,1.3,0.4,1.8,0c0.5-0.5,0.4-1.3-0.1-1.8l-9.1-8.6c-0.5-0.5-1.3-0.4-1.8,0.1
        c-0.5,0.5-0.4,1.3,0,1.8l0.9,0.9L11,5.5C11,5.5,18.2,12.5,18.2,12.5z M14.9,16.3L7.5,9C6.1,9.8,4.3,9.6,3.1,8.4l-1.7,1.8l5.4,5.1
        l-6,6.4l0.1,1.8l1.8-0.1l6-6.4l5.5,5.2l1.7-1.8C14.7,19.4,14.3,17.7,14.9,16.3 M2.7,2.6l18.4,18.1l1.7-1.8L4.5,0.8L2.7,2.6z"
      />
    </SvgIcon>
  );
};

export const PublishIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.7,10.3l-8.1-7c-0.2-0.2-0.6-0.3-0.9-0.1c-0.3,0.1-0.5,0.4-0.5,0.7v3.4c-2.1,0.1-3.9,0.6-5.6,1.4
	c-1.6,0.8-3,1.9-4,3.3c-2,2.5-2.7,5.4-2.7,7.4c0,0.4,0.4,0.8,0.8,0.8c0.3,0,0.6-0.2,0.7-0.4c1.7-3,4.3-4.7,8.4-5
	c0.4,0,0.8-0.4,0.7-0.9c0,0,0,0,0,0c0-0.4-0.4-0.8-0.9-0.7c0,0,0,0,0,0c-2,0.2-3.7,0.7-5.2,1.4c-0.9,0.4-1.7,1-2.3,1.7
	C3.6,15.1,4.1,14,4.9,13c2.1-2.6,5.2-4,9.1-4c0.4,0,0.8-0.4,0.8-0.8V5.7l6.1,5.2l-6.1,5.2v-2.4c0-0.4-0.4-0.8-0.8-0.8
	c-0.4,0-0.8,0.4-0.8,0.8v4.2c0,0.3,0.2,0.6,0.5,0.7c0.3,0.1,0.6,0.1,0.9-0.1l8.1-7C23.1,11.3,23.1,10.7,22.7,10.3
	C22.8,10.4,22.7,10.3,22.7,10.3z"
      />
    </SvgIcon>
  );
};

export const NotifyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M4.7,16.5l1.3-1.3c0.4-0.4,0.7-1,0.7-1.6V8.3c0-1.5,0.7-3,1.8-4c1.2-1,2.6-1.5,4.2-1.3
        c2.6,0.3,4.6,2.7,4.6,5.5v5c0,0.6,0.2,1.2,0.7,1.6l1.3,1.3H4.7z M14.2,19.1c0,1-1,1.9-2.2,1.9s-2.2-0.9-2.2-1.9v-0.4h4.5V19.1z
         M21.5,15.6l-2-2v-5c0-3.9-2.8-7.2-6.5-7.7c-2.2-0.3-4.3,0.4-6,1.8C5.4,4.1,4.5,6.2,4.5,8.3l0,5.2l-2,2c-0.5,0.5-0.7,1.3-0.4,2
        c0.3,0.7,0.9,1.1,1.7,1.1h3.8v0.4c0,2.3,2,4.1,4.5,4.1s4.5-1.8,4.5-4.1v-0.4h3.8c0.7,0,1.4-0.4,1.7-1.1
        C22.2,16.9,22.1,16.1,21.5,15.6L21.5,15.6z"
      />
    </SvgIcon>
  );
};

export const ResetIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.9,13.7c-0.6-0.2-1.3,0.1-1.5,0.8c-1.1,3.5-4.4,5.9-8.2,5.9c-4.7,0-8.6-3.7-8.6-8.4
        s3.8-8.4,8.6-8.4c2.1,0,4,0.7,5.5,2l-2.6-0.4c-0.6-0.1-1.3,0.3-1.4,1c0,0,0,0,0,0c-0.1,0.6,0.3,1.3,1,1.4c0,0,0,0,0,0l5.1,0.8
        c0.2,0,0.4,0,0.6-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1C21,8,21,7.9,21.1,7.8c0-0.1,0-0.1,0.1-0.2
        c0-0.1,0.1-0.1,0.1-0.2l0.9-4.8c0.1-0.6-0.3-1.3-1-1.4c-0.6-0.1-1.3,0.3-1.4,1L19.5,4c-2-1.7-4.6-2.7-7.2-2.7c-6,0-11,4.8-11,10.7
        s4.9,10.7,11,10.7c4.8,0,9-3,10.5-7.5C22.9,14.6,22.5,13.9,21.9,13.7"
      />
    </SvgIcon>
  );
};

export const HomeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.2,11.7L12.9,1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.1-0.6-0.1-0.8,0c-0.1,0.1-0.3,0.1-0.4,0.3L0.9,11.8
	c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.5,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.5-0.1,0.8-0.3L2.7,13v9.3c0,0.3,0.1,0.5,0.3,0.8
	c0.2,0.2,0.5,0.3,0.8,0.3h4.8c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8l0-6.5h4.7v6.5c0,0.3,0.1,0.6,0.3,0.8
	c0.2,0.2,0.5,0.3,0.8,0.3h4.8c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V13l0.2,0.2c0.1,0.1,0.2,0.2,0.4,0.3
	c0.3,0.1,0.6,0.1,0.8,0c0.1,0,0.2-0.1,0.4-0.2c0.2-0.2,0.3-0.5,0.3-0.7C23.5,12.2,23.4,12,23.2,11.7z M16.2,14
	c-0.2-0.2-0.5-0.3-0.8-0.3H8.6c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8l0,6.5H4.9V10.8c0,0,0,0,0,0l7.2-7.5l7.1,7.5v10.5
	h-2.6v-6.5C16.6,14.5,16.4,14.2,16.2,14z M12.3,1.1C12.3,1.1,12.3,1.1,12.3,1.1L12.3,1.1L12.3,1.1z M22.1,13.1
	C22.1,13.1,22.1,13.1,22.1,13.1L22.1,13.1L22.1,13.1z"
      />
    </SvgIcon>
  );
};

export const EHandoverIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.2,1.4c-0.4-0.4-1-0.7-1.6-0.7H5.8c-0.6,0-1,0.2-1.3,0.5C4.3,1.6,4.2,2,4.2,2.4v2.5H3.7C3.4,4.9,3.2,5,3,5.2
	C2.8,5.4,2.8,5.6,2.8,5.8c0,0.3,0.1,0.5,0.3,0.6s0.4,0.3,0.6,0.3h0.5V9H3.7C3.5,9,3.3,9.1,3.1,9.3S2.8,9.7,2.8,9.9s0.1,0.5,0.3,0.6
	s0.4,0.3,0.6,0.3h0.4v2.3H3.7c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7C3.3,14.9,3.5,15,3.7,15h0.5
	v2.2H3.7c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.6,0.3h0.5v2.5
	c0,0.7,0.2,1.1,0.6,1.3c0.4,0.2,0.7,0.3,1,0.3h13.7c0.6,0,1.2-0.2,1.6-0.7c0.4-0.4,0.7-1,0.7-1.6V3.1C21.9,2.4,21.6,1.9,21.2,1.4z
	 M19.5,21.4h-1.1V2.6h1.1c0.1,0,0.2,0,0.3,0.1C19.9,2.8,20,2.9,20,3.1v17.8l-0.2,0.4C19.7,21.3,19.6,21.4,19.5,21.4z M6,19.1h0.5
	c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3H6V15h0.5c0.3,0,0.5-0.1,0.7-0.3
	c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3H6v-2.3h0.5c0.3,0,0.5-0.1,0.6-0.3s0.3-0.4,0.3-0.6
	S7.3,9.5,7.2,9.3S6.8,9,6.5,9H6V6.7h0.4c0.3,0,0.5-0.1,0.6-0.3s0.3-0.4,0.3-0.6c0-0.3-0.1-0.5-0.3-0.7C6.9,5,6.7,4.9,6.5,4.9H6V2.6
	h10.5v18.8H6V19.1z"
      />
    </SvgIcon>
  );
};

export const BedStatusIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M2.1,9.5c0.5,0,0.8,0.3,0.9,0.8l0,0.1v6.9h6v-4.8c0-0.5,0.3-0.8,0.8-0.9l0.1,0h9.4
	c2.2,0,4,1.9,4,4.2l0,0v6.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.8-0.3-0.9-0.8l0-0.1v-3.3H9.9c0,0,0,0,0,0l-6.9,0v3.3
	c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.8-0.3-0.9-0.8l0-0.1v-12C1.2,9.9,1.6,9.5,2.1,9.5z M19.3,13.4h-8.5l0,3.9h10.7v-1.5
	c0-1.2-0.8-2.2-1.9-2.3l-0.2,0L19.3,13.4z M6.3,11.6c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5
	S4.9,11.6,6.3,11.6z M6.3,13.4c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7S6.6,13.4,6.3,13.4z M13.8,0.7
	c0.5,0,0.9,0.4,0.9,0.9l0,0l0,1.4h1.4c0.5,0,0.8,0.3,0.9,0.8l0,0l0,0.1V7c0,0.5-0.4,0.9-0.9,0.9l0,0h-1.4l0,1.4
	c0,0.5-0.3,0.8-0.8,0.9l0,0l-0.1,0h-3.1c-0.5,0-0.9-0.4-0.9-0.9l0,0l0-1.4H8.3C7.9,8,7.5,7.6,7.4,7.2l0,0l0-0.1V3.9
	C7.4,3.4,7.8,3,8.3,3l0,0h1.4l0-1.4c0-0.5,0.3-0.8,0.8-0.9l0,0l0.1,0H13.8z M12.9,2.5h-1.3l0,1.4c0,0.5-0.3,0.8-0.8,0.9l0,0l-0.1,0
	H9.3v1.3h1.4c0.5,0,0.8,0.3,0.9,0.8l0,0l0,0.1l0,1.4h1.3l0-1.4c0-0.5,0.3-0.8,0.8-0.9l0,0l0.1,0h1.4V4.8h-1.4
	c-0.5,0-0.8-0.3-0.9-0.8l0,0l0-0.1L12.9,2.5z"
      />
    </SvgIcon>
  );
};

export const DutyAssignIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.1,20.1c0,0.7-0.5,1.2-1.2,1.2H5.1c-0.7,0-1.2-0.5-1.2-1.2V7.4c0-0.7,0.5-1.2,1.2-1.2v1.2
	c0,1.3,1,2.3,2.3,2.3h9.3c1.3,0,2.3-1,2.3-2.3V6.2c0.7,0,1.2,0.5,1.2,1.2V20.1z M7.4,2.7h9.3v1.2v3.5H7.4V3.9V2.7z M18.9,2.7
	c0-1.3-1-2.3-2.3-2.3H7.4c-1.3,0-2.3,1-2.3,2.3v1.2c-2,0-3.5,1.5-3.5,3.5v12.7c0,2,1.5,3.5,3.5,3.5h13.9c2,0,3.5-1.5,3.5-3.5V7.4
	c0-2-1.5-3.5-3.5-3.5V2.7z"
      />
    </SvgIcon>
  );
};

export const EquipmentIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.51,7.11L20.51,7.11l-6.91,0V2.56c0-0.42-0.34-0.77-0.76-0.77H2.72c-0.42,0-0.76,0.34-0.76,0.77v7.48
      c0,0.42,0.34,0.77,0.76,0.77h2.94v2.14H3.64c-0.84,0-1.52,0.69-1.52,1.55v8.13c0,0.42,0.34,0.77,0.76,0.77s0.76-0.34,0.76-0.77
      V14.5c0-0.01,0-0.01,0-0.01h8.26c0,0,0,0.01,0,0.01v8.13c0,0.42,0.34,0.77,0.76,0.77c0.42,0,0.76-0.34,0.76-0.77V14.5
      c0-0.85-0.68-1.55-1.52-1.55H9.9v-2.14h2.94c0.42,0,0.76-0.34,0.76-0.77V8.64h6.9c0,0,0.01,0.01,0.01,0.03v4.05
      c0,0.16-0.12,0.29-0.27,0.29h-0.44c-0.36-0.83-1.18-1.41-2.12-1.41c-1.28,0-2.32,1.06-2.32,2.37v8.57c0,0.42,0.34,0.77,0.76,0.77
      s0.76-0.34,0.76-0.77v-8.57c0-0.46,0.36-0.83,0.79-0.83c0.44,0,0.79,0.37,0.79,0.83v3.41c-0.37,0.49-0.61,1.31-0.61,2.25
      c0,1.5,0.62,2.71,1.38,2.71c0.76,0,1.38-1.21,1.38-2.71c0-0.94-0.24-1.77-0.61-2.25v-2.83h0.25c0.99,0,1.8-0.82,1.8-1.83V8.67
      C22.05,7.81,21.36,7.11,20.51,7.11z M3.48,3.33h8.59v0v1.74H9.59c-0.25,0-0.49,0.13-0.63,0.34l-0.7,1.04L7.38,4.35
      c-0.16-0.39-0.61-0.57-1-0.41C6.24,4.01,6.12,4.11,6.03,4.24L4.9,6.01H3.48V3.33z M8.37,12.95H7.18v-2.14h1.19V12.95z M12.07,9.28
      L12.07,9.28H9.2c-0.04,0-0.09,0-0.13,0H6.48c-0.04,0-0.09,0-0.13,0H3.48V7.54h1.83c0.26,0,0.5-0.13,0.64-0.35l0.58-0.9L7.4,8.34
      c0.16,0.39,0.61,0.57,1,0.41c0.14-0.06,0.25-0.15,0.34-0.28L10,6.6h2.08V9.28z"
      />
    </SvgIcon>
  );
};

export const SettingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,7c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S14.8,7,12,7z M12,15.2c-1.8,0-3.2-1.4-3.2-3.2
	c0-1.8,1.4-3.2,3.2-3.2l0.2,0c1.7,0.1,3,1.5,3,3.2C15.2,13.8,13.8,15.2,12,15.2z M20.9,9h-0.3c-0.1-0.4-0.3-0.7-0.4-1l0.2-0.2
	c0.4-0.4,0.7-1,0.7-1.6c0-0.6-0.2-1.2-0.7-1.6l-1-1C19,3.2,18.4,3,17.8,3c0,0,0,0,0,0c-0.6,0-1.2,0.2-1.6,0.7L16,3.8
	c-0.3-0.2-0.7-0.3-1-0.4V3.1c0-1.3-1-2.3-2.3-2.3h-1.4c-1.3,0-2.3,1-2.3,2.3v0.3C8.7,3.5,8.3,3.6,8,3.8L7.8,3.6
	c-0.9-0.9-2.4-0.9-3.2,0l-1,1C3.2,5,3,5.6,3,6.2c0,0.6,0.2,1.2,0.7,1.6L3.8,8C3.6,8.3,3.5,8.7,3.4,9H3.1c-1.3,0-2.3,1-2.3,2.3v1.4
	c0,1.3,1,2.3,2.3,2.3h0.3c0.1,0.4,0.3,0.7,0.4,1l-0.2,0.2c-0.4,0.4-0.7,1-0.7,1.6c0,0.6,0.2,1.2,0.7,1.6l1,1C5,20.8,5.6,21,6.2,21
	c0.6,0,1.2-0.2,1.6-0.7L8,20.2c0.3,0.2,0.7,0.3,1,0.4v0.3c0,1.3,1,2.3,2.3,2.3h1.4c1.3,0,2.3-1,2.3-2.3v-0.3c0.4-0.1,0.7-0.3,1-0.4
	l0.2,0.2c0.9,0.9,2.4,0.9,3.2,0l1-1c0.4-0.4,0.7-1,0.7-1.6c0-0.6-0.2-1.2-0.7-1.6L20.2,16c0.2-0.3,0.3-0.7,0.4-1h0.3
	c1.3,0,2.3-1,2.3-2.3v-1.4C23.2,10.1,22.1,9,20.9,9z M21.3,12.7c0,0.3-0.2,0.5-0.5,0.5h-0.9c-0.4,0-0.8,0.3-0.9,0.7
	c-0.2,0.7-0.4,1.3-0.8,1.9c-0.2,0.4-0.2,0.8,0.1,1.1l0.7,0.7c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3l-1,1
	c-0.1,0.1-0.2,0.1-0.3,0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.3-0.1l-0.7-0.7c-0.3-0.3-0.8-0.4-1.1-0.1c-0.6,0.3-1.2,0.6-1.9,0.8
	c-0.4,0.1-0.7,0.5-0.7,0.9v0.9c0,0.3-0.2,0.5-0.5,0.5h-1.4c-0.3,0-0.5-0.2-0.5-0.5v-0.9c0-0.4-0.3-0.8-0.7-0.9
	c-0.7-0.2-1.3-0.4-1.9-0.8c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.5,0.1-0.6,0.3l-0.7,0.7c-0.2,0.2-0.5,0.2-0.6,0l-1-1
	c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3l0.7-0.7c0.3-0.3,0.4-0.8,0.1-1.1c-0.3-0.6-0.6-1.2-0.8-1.9c-0.1-0.4-0.5-0.7-0.9-0.7
	H3.1c-0.3,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.5-0.5h0.9c0.4,0,0.8-0.3,0.9-0.7c0.2-0.7,0.4-1.3,0.8-1.9
	c0.2-0.4,0.2-0.8-0.1-1.1L4.9,6.5C4.8,6.4,4.8,6.3,4.8,6.2c0-0.1,0-0.2,0.1-0.3l1-1C6,4.8,6.1,4.8,6.2,4.8c0,0,0,0,0,0
	c0.1,0,0.2,0,0.3,0.1l0.7,0.7c0.3,0.3,0.7,0.4,1.1,0.1c0.6-0.3,1.2-0.6,1.9-0.8c0.4-0.1,0.7-0.5,0.7-0.9V3.1c0-0.3,0.2-0.5,0.5-0.5
	h1.4c0.3,0,0.5,0.2,0.5,0.5v0.9c0,0.4,0.3,0.8,0.7,0.9c0.7,0.2,1.3,0.4,1.9,0.8c0.4,0.2,0.8,0.2,1.1-0.1l0.7-0.7
	c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1l1,1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3l-0.7,0.7c-0.3,0.3-0.4,0.8-0.1,1.1
	c0.3,0.6,0.6,1.2,0.8,1.9c0.1,0.4,0.5,0.7,0.9,0.7h0.9c0.3,0,0.5,0.2,0.5,0.5V12.7z"
      />
    </SvgIcon>
  );
};
export const DateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.4,15.4c0.6,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2S6.8,15.4,7.4,15.4z
 M16.6,15.4c0.6,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2l0,0H12c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2l0,0
C12,15.4,16.6,15.4,16.6,15.4z M18.9,21.2H5.1c-0.6,0-1.2-0.5-1.2-1.2v-6.9h16.1v6.9C20.1,20.7,19.5,21.2,18.9,21.2 M5.1,5.1h1.2
v1.2c0,0.6,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V5.1h6.9v1.2c0,0.6,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V5.1H19c0.6,0,1.2,0.5,1.2,1.2v4.6
H3.9V6.3C3.9,5.7,4.5,5.1,5.1,5.1 M18.9,2.8h-1.2V1.6c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2v1.2H8.6V1.6
c0-0.6-0.5-1.2-1.2-1.2S6.3,1,6.3,1.6v1.2H5.1c-1.9,0-3.4,1.6-3.4,3.4V20c0,1.9,1.6,3.4,3.4,3.4h13.8c1.9,0,3.4-1.6,3.4-3.4V6.2
C22.4,4.4,20.8,2.8,18.9,2.8"
      />
    </SvgIcon>
  );
};
export const newDateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M16 2c.55 0 1 .45 1 1v1h1c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h1V3c0-.55.45-1 1-1s1 .45 1 1v1h6V3c0-.55.45-1 1-1zm3 11H5v6c0 .551.449 1 1 1h12c.551 0 1-.449 1-1v-6zM8 15c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm8 0c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1z" />
    </SvgIcon>
  );
};

export const ExportIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,1c0.7,0,1.2,0.5,1.2,1.2S12.7,3.5,12,3.5l0,0H4.7c-0.7,0-1.2,0.5-1.2,1.2l0,0v14.6
	c0,0.7,0.5,1.2,1.2,1.2l0,0h14.6c0.7,0,1.2-0.5,1.2-1.2l0,0V12c0-0.7,0.5-1.2,1.2-1.2S23,11.3,23,12l0,0v7.3c0,2.1-1.6,3.7-3.7,3.7
	l0,0H4.7C2.6,23,1,21.4,1,19.3l0,0V4.7C1,2.6,2.6,1,4.7,1l0,0H12z M16.9,1h4.9C22.4,1,23,1.5,23,2.2l0,0v4.9c0,0.7-0.5,1.2-1.2,1.2
	l0,0c-0.7,0-1.2-0.5-1.2-1.2l0,0v-2l-7.7,7.7c-0.2,0.2-0.5,0.4-0.9,0.4s-0.6-0.1-0.9-0.4c-0.5-0.5-0.5-1.2,0-1.7l0,0l7.7-7.7h-2
	c-0.7,0-1.2-0.6-1.2-1.2C15.7,1.5,16.3,1,16.9,1L16.9,1L16.9,1z"
      />
    </SvgIcon>
  );
};

export const DropDownIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M0.5,7.9c0-0.4,0.1-0.7,0.4-1.1C1.5,6.1,2.5,6,3.2,6.6L12,14l8.8-7.1c0.7-0.6,1.7-0.5,2.3,0.2
	c0.6,0.7,0.5,1.7-0.2,2.3L13,17.4c-0.6,0.5-1.5,0.5-2.1,0L1.1,9.2C0.7,8.8,0.5,8.4,0.5,7.9"
      />
    </SvgIcon>
  );
};

export const SearchIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.2,1.1c4.5,0,8.1,3.6,8.1,8.1c0,1.9-0.7,3.9-1.9,5.2l0,0l0.3,0.3h1l6.3,6.3L21,22.9
	l-6.3-6.3v-1l-0.3-0.3c-1.5,1.2-3.3,1.9-5.2,1.9c-4.5,0-8.1-3.6-8.1-8.1C1.1,4.7,4.7,1.1,9.2,1.1z M9.2,3.6C6,3.6,3.5,6.2,3.5,9.3
	S6,15,9.2,15s5.7-2.5,5.7-5.7S12.3,3.6,9.2,3.6z"
      />
    </SvgIcon>
  );
};

export const AssignIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M5.4,16.3l3.3-0.3L15,9.8l-3-3L5.7,13L5.4,16.3z M13.5,5.3l3,3l2.2-2.2l-3-3L13.5,5.3z
		 M3.4,18.4c-0.2-0.2-0.3-0.6-0.3-0.9l0.4-4.7c0-0.5,0.3-1,0.6-1.3l10-10c0.8-0.8,2.2-0.8,3,0.1l3.1,3.1l0,0c0.8,0.8,0.9,2.2,0.1,3
		l-10,10.1C9.9,18,9.5,18.2,9,18.3l-4.7,0.4c0,0-0.1,0-0.1,0C3.9,18.7,3.6,18.6,3.4,18.4L3.4,18.4z M20.9,22c0,0.6-0.5,1.1-1.1,1.1
		H4.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h15.6C20.4,20.9,20.9,21.4,20.9,22L20.9,22z"
      />
    </SvgIcon>
  );
};

export const WardIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.4,1.1c1.2,0,2.2,1,2.2,2.2l0,0v1.1c1.9,0,3.3,1.4,3.3,3.3l0,0v12c0,1.9-1.4,3.3-3.3,3.3l0,0
	H5.4c-1.9,0-3.3-1.4-3.3-3.3l0,0v-12c0-1.9,1.4-3.3,3.3-3.3l0,0V3.3c0-1.2,1-2.2,2.2-2.2l0,0H16.4z M18.6,6.5v1.1
	c0,1.2-1,2.2-2.2,2.2l0,0H7.6c-1.2,0-2.2-1-2.2-2.2l0,0V6.5C4.8,6.5,4.4,7,4.4,7.6l0,0v12c0,0.7,0.4,1.1,1.1,1.1l0,0h13.1
	c0.7,0,1.1-0.4,1.1-1.1l0,0v-12C19.6,7,19.2,6.5,18.6,6.5L18.6,6.5z M12,10.4c0.5,0,1,0.4,1.1,1v0.1v2.2h2.2c0.7,0,1.1,0.4,1.1,1.1
	c0,0.5-0.4,1-1,1.1h-0.1h-2.2V18c0,0.7-0.4,1.1-1.1,1.1c-0.5,0-1-0.4-1.1-1V18v-2.2H8.7c-0.7,0-1.1-0.4-1.1-1.1c0-0.5,0.4-1,1-1.1
	h0.1h2.2v-2.2C10.9,10.8,11.3,10.4,12,10.4z M7.6,3.3v4.4h8.7V3.3H7.6z"
      />
    </SvgIcon>
  );
};

export const OccupiedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M19,13.8c-0.3,0-0.5,0.1-0.8,0.1c-3,0-5.5-2-6.3-4.8H8.7C7.1,9.1,6,10.3,6,11.9v0.5H4.8V7.9c0-0.3,0.2-0.4,0.4-0.4h6.4V7.3
	c0-0.5,0.1-1.1,0.2-1.6H5.3c-1.2,0-2.2,1-2.2,2.1v4.7c-1.2,0.3-2,1.5-2,2.8V19c0,0.4,0.3,0.7,0.7,0.7h1.3v1c0,0.4,0.3,0.7,0.7,0.7
	c0.4,0,0.7-0.3,0.7-0.7v-1h11v1c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1h1.3c0.4,0,0.7-0.3,0.7-0.7v-3.6
	C19.3,14.8,19.2,14.2,19,13.8z M7.7,11.8c0-0.6,0.5-1.2,1.2-1.2h3.1c0.7,0,1.3,0.5,1.3,1.2v0.5H7.7V11.8z M17.8,18.1H2.8v-2.8
	c0-0.6,0.5-1.3,1.3-1.3h12.5c0.6,0,1.3,0.5,1.3,1.3V18.1z M18.2,2.7c-2.7,0-4.8,2-4.8,4.7s2.1,4.7,4.8,4.7s4.8-2,4.8-4.7
	S20.8,2.7,18.2,2.7z M18.2,10.4c-1.8,0-3.3-1.4-3.3-3.3c0-0.6,0.1-1.2,0.4-1.7l4.5,4.3C19.2,10.3,18.7,10.4,18.2,10.4z M20.9,8.9
	l-4.6-4.3C16.8,4.1,17.4,4,18,4c1.9,0,3.4,1.4,3.4,3.2C21.3,7.9,21.2,8.4,20.9,8.9z"
      />
    </SvgIcon>
  );
};

export const DischgIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M5.2,2.4c0.7,0,1.2,0.5,1.2,1.2S5.8,4.8,5.2,4.8l0,0H4v14.5h1.2c0.7,0,1.2,0.5,1.2,1.2
		s-0.5,1.2-1.2,1.2l0,0H2.7c-0.7,0-1.2-0.5-1.2-1.2l0,0V3.6c0-0.7,0.5-1.2,1.2-1.2l0,0C2.7,2.4,5.2,2.4,5.2,2.4z M17.1,6.2
		c0.5-0.4,1.3-0.3,1.7,0.3l0,0l3.4,4.9c0.3,0.4,0.3,1.1,0,1.4l0,0l-3.7,4.9c-0.3,0.3-0.7,0.5-1.1,0.5c-0.3,0-0.5-0.1-0.8-0.3
		c-0.5-0.4-0.7-1.2-0.3-1.7l0,0l2.2-2.9H8.8c-0.7-0.1-1.2-0.7-1.2-1.3s0.5-1.2,1.2-1.2l0,0h9.9h0.1l0,0l-2.1-2.9
		C16.4,7.3,16.5,6.6,17.1,6.2z"
      />
    </SvgIcon>
  );
};

export const CompletedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.2,5.4c0.4-0.5,1.2-0.6,1.7-0.2s0.6,1.2,0.2,1.7l0,0L7.9,18.6c-0.2,0.4-0.6,0.5-0.9,0.5l0,0
	c-0.4,0-0.7-0.1-0.9-0.5l0,0l-5-6.2c-0.4-0.5-0.4-1.2,0.2-1.7c0.5-0.4,1.3-0.4,1.7,0.2l0,0l4,5L15.2,5.4z M21.1,5.4
	c0.4-0.5,1.2-0.6,1.7-0.2s0.6,1.2,0.2,1.7l0,0l-9.2,11.8c-0.2,0.4-0.6,0.5-0.9,0.5l0,0c-0.4,0-0.7-0.1-0.9-0.5l0,0L10.6,17l1.5-1.9
	l0.7,0.8L21.1,5.4z M7.2,10.8c0.5-0.4,1.3-0.4,1.7,0.2l0,0L9,11.3l-1.5,1.9l-0.6-0.7C6.6,12,6.6,11.3,7.2,10.8z"
      />
    </SvgIcon>
  );
};

export const BedAvailableIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21,10.4v-5c0-1.6-1.3-2.8-2.9-2.8H6.1c-1.6,0-2.9,1.2-2.9,2.8v5c-1.3,0.6-2.3,2-2.3,3.4V18
	c0,0.7,0.6,1.3,1.3,1.3h1v0.7c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-0.6H18v0.6c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-0.6
	h1c0.7,0,1.3-0.6,1.3-1.3V14C23.4,12.4,22.4,11,21,10.4z M20.6,13.8v2.8H3.7v-2.8c0-0.6,0.5-1,1.1-1h14.7
	C20.1,12.9,20.6,13.3,20.6,13.8z M9.3,9.9c0-0.5,0.5-0.9,1-0.9H14c0.5,0,1,0.4,1,0.9V10H9.3V9.9z M18.2,5.4v4.8h-0.5V9.9
	c0-2-1.7-3.7-3.8-3.7h-3.7c-2.1,0-3.8,1.6-3.8,3.7V10H6V5.4c0,0,0-0.1,0.1-0.1L18.2,5.4C18.2,5.3,18.2,5.4,18.2,5.4z"
      />
    </SvgIcon>
  );
};

export const AvgIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.7,9.5v1.7H7.9c-0.6,0-1,0.4-1,1v2.6c0,0.5,0.5,1,1,1h1.8v1.7c0,0.5,0.5,1,1,1h2.6c0.6,0,1-0.4,1-1v-1.7h1.8
	c0.6,0,1-0.4,1-1v-2.6c0-0.5-0.5-1-1-1h-1.8V9.5c0-0.5-0.5-1-1-1h-2.6C10.1,8.5,9.7,8.9,9.7,9.5z M11.7,12.2v-1.7h0.6v1.7
	c0,0.5,0.5,1,1,1h1.8v0.6h-1.8c-0.6,0-1,0.4-1,1v1.7h-0.6v-1.7c0-0.5-0.5-1-1-1H8.9v-0.6h1.8C11.3,13.2,11.7,12.8,11.7,12.2z
	 M23.3,11.5l-9.6-9.1c-1-0.9-2.5-0.9-3.5,0l-9.6,9.1c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.4,0.4,1,0.4,1.4,0l0.2-0.2
	v6.5c0,1.7,1.4,3.1,3.2,3.1h13.1c1.8,0,3.2-1.4,3.2-3.1v-6.5l0.2,0.2c0.4,0.4,1,0.4,1.4,0c0.2-0.2,0.3-0.4,0.3-0.7
	C23.6,11.9,23.5,11.7,23.3,11.5z M19.7,19.2c0,0.6-0.5,1.2-1.2,1.2h-13c-0.7,0-1.2-0.5-1.2-1.2v-8.4l7.4-7.1c0,0,0.1-0.1,0.2-0.1
	c0.2-0.1,0.3,0,0.4,0.1l0,0l7.4,7.1V19.2z"
      />
    </SvgIcon>
  );
};
export const ArrowRightLongIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M0.6,11.1h19.7l-2.1-2c-0.4-0.4-0.4-1-0.1-1.4c0.2-0.2,0.5-0.4,0.7-0.4c0.1,0,0.4,0,0.5,0.1
	c0,0,0.1,0.1,0.2,0.2l3.4,3.3c0.4,0.2,0.5,0.6,0.4,1c0,0.4-0.2,0.6-0.4,0.9l-3.4,3.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4
	l2.2-2H0.6C0.6,13,0.6,11.1,0.6,11.1z"
      />
    </SvgIcon>
  );
};

export const ArrowLeftLongIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.3,12.9H3.9l2.1,1.9c0.4,0.4,0.4,1,0.1,1.3c-0.2,0.2-0.5,0.4-0.7,0.4c-0.1,0-0.4,0-0.5-0.1
	c0,0-0.1-0.1-0.2-0.2l-3.4-3.3c-0.4-0.2-0.5-0.6-0.4-1c0-0.4,0.2-0.6,0.4-0.8l3.4-3.3c0.4-0.4,1-0.4,1.3,0c0.4,0.4,0.4,1,0,1.3
	L3.7,11h19.5C23.3,11,23.3,12.9,23.3,12.9z"
      />
    </SvgIcon>
  );
};

export const ArrowLeftIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.6,10.6H5.3l4.9-6c0.5-0.5,0.4-1.5-0.1-1.9C9.5,2.3,8.7,2.3,8.2,2.9l-6.9,8.2
	c0,0-0.1,0.1-0.1,0.3L1,11.6c0,0.1,0,0.3,0,0.4l0,0l0,0c0,0.1,0,0.3,0.1,0.5c0,0,0,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.3l6.9,8.2
	c0.1,0.3,0.5,0.4,1,0.4c0.3,0,0.7-0.1,0.8-0.3c0.5-0.5,0.7-1.4,0.1-1.9l-4.9-6h16.3c0.8,0,1.4-0.5,1.4-1.4
	C23,11.2,22.4,10.6,21.6,10.6"
      />
    </SvgIcon>
  );
};

export const AdmIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22,1.8c0.7,0,1.3,0.6,1.3,1.3l0,0V21c0,0.7-0.6,1.3-1.3,1.3l0,0h-2.7c-0.7,0-1.3-0.6-1.3-1.3
	s0.6-1.3,1.3-1.3l0,0h1.3V4.3h-1.3C18.6,4.3,18,3.7,18,3s0.6-1.3,1.3-1.3l0,0C19.3,1.8,22,1.8,22,1.8z M10.6,5.8
	c0.6-0.4,1.4-0.3,1.8,0.3l0,0l3.9,5.2c0.3,0.4,0.4,1.1,0,1.5l0,0l-3.6,5c-0.3,0.4-0.7,0.6-1.1,0.6c-0.3,0-0.6-0.1-0.7-0.3
	c-0.6-0.4-0.7-1.3-0.3-1.8l0,0l2.2-3.1h-0.1l0,0H2.1c-0.7,0-1.4-0.6-1.4-1.3s0.6-1.3,1.3-1.3l0,0h10.8l-2.4-3.1
	C9.9,7.1,9.9,6.3,10.6,5.8z"
      />
    </SvgIcon>
  );
};

export const TimeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.3,10.9h-3.2V7.7c0-0.6-0.4-1.1-1.1-1.1S10.9,7,10.9,7.7V12c0,0.6,0.4,1.1,1.1,1.1h4.3
	c0.6,0,1.1-0.4,1.1-1.1S17,10.9,16.3,10.9 M12,20.6c-4.7,0-8.6-3.9-8.6-8.6S7.3,3.4,12,3.4s8.6,3.9,8.6,8.6S16.7,20.6,12,20.6
	 M12,1.2C6.1,1.2,1.2,6.1,1.2,12S6.1,22.8,12,22.8S22.8,17.9,22.8,12S17.9,1.2,12,1.2"
      />
    </SvgIcon>
  );
};

export const PhotoIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,15.9c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S12.9,15.9,12,15.9 M12,10.3
	c-2.1,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9S14.1,10.3,12,10.3 M21,18.8c0,0.7-0.5,1.1-1.1,1.1H4.1
	c-0.7,0-1.1-0.5-1.1-1.1v-9c0-0.7,0.5-1.1,1.1-1.1h15.8c0.7,0,1.1,0.5,1.1,1.1V18.8z M9.7,4.7c0-0.3,0.2-0.6,0.6-0.6h3.4
	c0.3,0,0.6,0.2,0.6,0.6v1.7H9.7V4.7z M19.9,6.4h-3.4V4.7c0-1.6-1.2-2.8-2.8-2.8h-3.4c-1.6,0-2.8,1.2-2.8,2.8v1.7H4.1
	c-1.9,0-3.4,1.5-3.4,3.4v9c0,1.9,1.5,3.4,3.4,3.4h15.8c1.9,0,3.4-1.5,3.4-3.4v-9C23.3,7.8,21.8,6.4,19.9,6.4L19.9,6.4z"
      />
    </SvgIcon>
  );
};

export const NotiIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.1,16.5l-1.7-0.9c-0.4-0.2-0.9,0-1.1,0.3V5.2c0.1,0.3,0.4,0.4,0.8,0.4c0.1,0,0.2,0,0.3-0.1l1.7-0.9
	c0.4-0.2,0.5-0.7,0.3-1.1c-0.2-0.4-0.7-0.5-1.1-0.3l-1.7,0.9c-0.1,0.1-0.2,0.2-0.3,0.3V2.3c0-0.7-0.3-1.2-1-1.4
	c-0.5-0.2-1.2,0-1.6,0.4c-1.1,1.5-3.4,3.8-6.2,3.8H5.9c-2.7,0-5,2.3-5,5v0.8c0,2,1.1,3.6,2.6,4.5C3.6,16.3,3.8,18.5,4,20
	c0.1,1.2,0.5,2.1,1.2,2.6c0.4,0.3,1.1,0.5,1.7,0.5c0.1,0,0.2,0,0.4,0c0.8-0.1,1.3-0.3,1.7-0.9c0.5-0.8,0.5-1.9,0.3-2.6
	c-0.2-0.5-0.5-2.4-0.8-3.6h1.6c2.8,0,5.1,2.4,6.3,3.8c0.3,0.3,0.7,0.5,1.1,0.5c0.1,0,0.3,0,0.5-0.1c0.5-0.2,1-0.8,1-1.4v-2.2
	c0.1,0.1,0.2,0.3,0.3,0.3l1.6,1c0.1,0.1,0.2,0.1,0.3,0.1c0.3,0,0.5-0.1,0.8-0.4C22.6,17.3,22.5,16.7,22.1,16.5z M2.5,10.3
	c0-1.9,1.5-3.4,3.4-3.4h3.1v7.7H5.9c-1.9,0-3.4-1.5-3.4-3.4C2.5,11.1,2.5,10.3,2.5,10.3z M7.8,20c0.1,0.9,0,1.2-0.1,1.3
	c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8,0-1-0.2c-0.3-0.2-0.5-0.8-0.5-1.5c-0.1-1.2-0.3-2.8-0.4-3.8c0.2,0,0.4,0.1,0.7,0.1h1.2
	C7.3,17.1,7.7,19.3,7.8,20z M17.7,18.3c-1.6-1.9-4-3.9-7.1-3.9V6.8c3.1-0.1,5.5-2.1,7.1-3.9V18.3z M23.3,10.6c0,0.4-0.3,0.9-0.9,0.9
	h-2c-0.4,0-0.9-0.3-0.9-0.9c0-0.5,0.3-0.9,0.9-0.9h2C22.8,9.8,23.3,10.1,23.3,10.6z"
      />
    </SvgIcon>
  );
};

export const LinkIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9,6c0.6,0,1,0.4,1,1S9.6,8,9,8l0,0H7c-2.3,0-4.2,2-4,4.4C3.2,14.5,5.1,16,7.2,16l0,0H9
		c0.6,0,1,0.4,1,1s-0.4,1-1,1l0,0H7c-3.6,0-6.4-3.1-5.9-6.8C1.4,8.2,4.2,6,7.2,6l0,0H9z M16.8,6c3.1,0,5.8,2.2,6.2,5.2
		c0.4,3.6-2.4,6.8-6,6.8l0,0h-2c-0.6,0-1-0.4-1-1s0.4-1,1-1l0,0h2c2.3,0,4.2-2,4-4.4C20.8,9.5,18.9,8,16.8,8l0,0H15
		c-0.6,0-1-0.4-1-1s0.4-1,1.2-1l0,0H16.8z M15,11c0.6,0,1,0.4,1,1s-0.4,1-1,1l0,0H9c-0.6,0-1-0.4-1-1s0.4-1,1-1l0,0H15z"
      />
    </SvgIcon>
  );
};

export const HospitalIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.5,13.5c0,0.8-0.7,1.5-1.5,1.5h-1.4v1.4c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5V15H9.2
	c-0.8,0-1.5-0.7-1.5-1.5S8.4,12,9.2,12h1.4v-1.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5V12H15C15.8,12,16.5,12.6,16.5,13.5z
	 M23.1,9.3v8.9c0,1.8-1.5,3.3-3.3,3.3H4.2c-1.8,0-3.3-1.5-3.3-3.3V9.3C0.9,7.5,2.4,6,4.2,6h3.3V4.3c0-1.5,1.2-2.8,2.8-2.8h3.3
	c1.5,0,2.8,1.2,2.8,2.8V6h3.3C21.6,5.9,23.1,7.4,23.1,9.3z M10.4,5.7h4.2V4.1c0-0.3-0.2-0.5-0.5-0.5h-3.2c-0.3,0-0.5,0.2-0.5,0.5
	V5.7z M21,9c0-0.6-0.5-1.2-1.1-1.2H4.1C3.5,7.8,3,8.3,3,9v9.3c0,0.6,0.5,1.2,1.1,1.2h15.7c0.6,0,1.1-0.5,1.1-1.2V9H21z"
      />
    </SvgIcon>
  );
};

export const FileIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.8,23.2L8.8,23.2c-2,0-3.8-0.8-5.2-2.2c-2.8-2.8-3-7.3-0.4-10.1L12,2.2
		c0.9-0.9,2.1-1.4,3.5-1.4s2.7,0.6,3.8,1.5c2,2,2.1,5.3,0.1,7.2l-8.8,8.8c-0.6,0.6-1.3,0.8-2.1,0.8l0,0c-0.8,0-1.7-0.4-2.4-0.9
		c-1.3-1.3-1.3-3.3-0.1-4.5l8-8.2c0.5-0.5,1.2-0.5,1.7,0c0.5,0.5,0.5,1.2,0,1.7l-7.9,8.4c-0.2,0.2-0.2,0.8,0.1,1.2
		C8.1,16.8,8.3,17,8.6,17l0,0c0.1,0,0.4,0,0.5-0.2L17.8,8c1.1-1.1,0.9-2.8-0.1-3.9C16.6,3,14.8,2.9,13.8,4L5,12.6
		c-1.8,1.8-1.7,4.7,0.2,6.7c0.9,0.9,2.2,1.5,3.5,1.5c1.2,0,2.2-0.5,3.1-1.3l8.8-8.8c0.5-0.5,1.2-0.5,1.7,0s0.5,1.2,0,1.7l-8.8,8.8
		C12.4,22.5,10.6,23.2,8.8,23.2"
      />
    </SvgIcon>
  );
};

export const CommentIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M10,7.7c0.5,0,0.9,0.4,0.9,0.9S10.5,9.5,10,9.5S9.1,9.2,9.1,8.7S9.5,7.7,10,7.7z M13.7,7.7
	c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9C12.8,8.2,13.2,7.7,13.7,7.7z M6.3,7.7c0.5,0,0.9,0.4,0.9,0.9
	S6.8,9.5,6.3,9.5S5.4,9.2,5.4,8.7S5.8,7.7,6.3,7.7z M17.3,13.2c0,0.5-0.4,0.9-0.9,0.9H6.8c-0.5,0-1,0.1-1.4,0.4l-2.8,1.7V4.1
	c0-0.5,0.4-0.9,0.9-0.9h12.8c0.5,0,0.9,0.4,0.9,0.9v9.1H17.3z M16.4,1.3H3.6c-1.5,0-2.8,1.2-2.8,2.8v13.8c0,0.3,0.2,0.6,0.5,0.8
	c0.1,0.1,0.3,0.1,0.5,0.1s0.3,0,0.5-0.1l4.1-2.5C6.5,16,6.7,16,6.8,16h9.6c1.5,0,2.8-1.2,2.8-2.8V4.1C19.2,2.6,17.9,1.3,16.4,1.3
	L16.4,1.3z"
      />
    </SvgIcon>
  );
};

export const ArrowRightIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.1,12.1L23.1,12.1c0,0.2-0.1,0.4-0.1,0.5c0,0.1-0.1,0.1-0.1,0.1
	c-0.1,0.1-0.1,0.2-0.2,0.4c-0.1,0.1-0.1,0.1-0.2,0.1l-4.7,7c-0.7,0.9-1.8,1.1-2.8,0.7c-0.4-0.1-0.8-0.5-1-1c-0.1-0.4-0.1-1,0.2-1.4
	l3.2-4.7H2.8c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8h14.6l-3.2-4.7C13.8,5,13.8,4.5,13.9,4c0.1-0.5,0.5-0.8,1-1
	c1-0.5,2.1-0.2,2.8,0.7l4.7,7l0.1,0.1c0.1,0.1,0.3,0.3,0.4,0.4l0,0c0.1,0.2,0.2,0.4,0.2,0.7l0,0v0.1v0.1
	C23.1,12,23.1,12.1,23.1,12.1C23.1,12.1,23.1,12.1,23.1,12.1L23.1,12.1z"
      />
    </SvgIcon>
  );
};

export const OutstandingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.4 12.2a1 1 0 1 1 1.2 1.6L7 15h13a1 1 0 1 1 0 2H6.918l1.558 1.21a1 1 0 0 1-1.227 1.58l-3.862-3A1 1 0 0 1 3.4 15.2zm7.948-8.813a1 1 0 0 1 1.403-.177l3.862 3A1 1 0 0 1 20.6 7.8l-4 3a.998.998 0 0 1-1.4-.2 1 1 0 0 1 .2-1.4L17 8H4a1 1 0 1 1 0-2h13.082l-1.558-1.21a1 1 0 0 1-.176-1.403z" />
    </SvgIcon>
  );
};

export const PWIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,16.5c-0.7,0-1.1-0.4-1.1-1.1s0.4-1.1,1.1-1.1s1.1,0.4,1.1,1.1S12.7,16.5,12,16.5 M12,12
	c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4S13.9,12,12,12 M18.7,19.9c0,0.7-0.4,1.1-1.1,1.1H6.4
	c-0.7,0-1.1-0.4-1.1-1.1v-9c0-0.7,0.4-1.1,1.1-1.1h1.1h2.2h4.5h2.2h1.1c0.7,0,1.1,0.4,1.1,1.1V19.9z M9.8,5.4C9.8,4,10.8,3,12,3
	s2.2,1,2.2,2.4v2.1H9.8V5.4z M17.6,7.5h-1.1V5.4c0-2.6-2-4.6-4.5-4.6s-4.5,2-4.5,4.6v2.1H6.4C4.5,7.5,3,9,3,10.9v9
	c0,1.9,1.5,3.4,3.4,3.4h11.2c1.9,0,3.4-1.5,3.4-3.4v-9C21,9,19.5,7.5,17.6,7.5L17.6,7.5z"
      />
    </SvgIcon>
  );
};

export const UserIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.3,21.8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-3.4-2.6-6.2-6-6.2s-6,2.8-6,6.2
	c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-4.7,3.7-8.6,8.3-8.6S20.3,17.1,20.3,21.8 M12,3.4c1.3,0,2.3,1.1,2.3,2.4S13.2,8.3,12,8.3
	S9.7,7.1,9.7,5.8S10.7,3.4,12,3.4 M12,10.8c2.6,0,4.7-2.2,4.7-4.9S14.7,1,12,1S7.3,3.2,7.3,5.8S9.4,10.8,12,10.8"
      />
    </SvgIcon>
  );
};

export const CloseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.4,19.6c0.6,0.6,0.6,1.6,0,2.3c-0.6,0.6-1.6,0.6-2.3,0L12,13.8l-8.1,8.1c-0.3,0.3-0.7,0.5-1.1,0.5S2,22.2,1.6,21.9
	c-0.6-0.6-0.6-1.6,0-2.3l8.1-8.1L1.6,3.5C1,2.8,1,1.8,1.6,1.2s1.6-0.6,2.3,0L12,9.3l8.1-8.1c0.6-0.6,1.6-0.6,2.3,0
	c0.6,0.6,0.6,1.6,0,2.3l-8.1,8.1L22.4,19.6z"
      />
    </SvgIcon>
  );
};

export const EditIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.5,10.2l-3.7-3.7l2.7-2.7l3.7,3.7L17.5,10.2z M8,19.7l-4.1,0.4L4.3,16L12,8.3l3.7,3.7L8,19.7
	z M22.2,5.6L22.2,5.6l-3.8-3.8c-1-1-2.8-1.1-3.7-0.1L2.3,14.1c-0.4,0.4-0.7,1-0.8,1.7L1,21.5c0,0.4,0.1,0.8,0.4,1.1
	C1.7,22.9,2,23,2.4,23c0,0,0.1,0,0.1,0l5.7-0.5c0.6-0.1,1.2-0.3,1.7-0.8L22.3,9.3C23.3,8.3,23.2,6.6,22.2,5.6L22.2,5.6z"
      />
    </SvgIcon>
  );
};

export const AddIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,0.7c0.7,0,1.3,0.6,1.3,1.3l0,8.8h8.8c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3h-8.8l0,8.8
	c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3l0-8.8H1.9c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3h8.8l0-8.8C10.7,1.3,11.3,0.7,12,0.7z"
      />
    </SvgIcon>
  );
};
export const BookmarkIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M19.9,0.5H4.1C3.8,0.5,3.5,0.7,3.5,1v22c0,0.3,0.3,0.5,0.6,0.5c0.2,0,0.3-0.1,0.4-0.1L12,17l7.5,6.4
	c0.2,0.2,0.6,0.2,0.8,0c0.1-0.1,0.2-0.2,0.2-0.3V1C20.5,0.7,20.2,0.5,19.9,0.5z M17.3,7.4l-2.5,1.7l1,2.8c0,0.1,0,0.3-0.1,0.4
	c-0.2,0.2-0.5,0.2-0.7,0.1l-2.5-1.7L10,12.4c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2-0.1-0.4-0.3-0.3-0.6l1-2.8L7.7,7.4
	C7.6,7.3,7.5,7.2,7.5,7c0-0.2,0.2-0.5,0.5-0.5h3.1l1-2.8c0-0.1,0.1-0.2,0.3-0.2c0.2-0.1,0.5,0,0.7,0.2l1,2.8H17
	c0.2,0,0.4,0.1,0.5,0.3C17.5,7.1,17.5,7.3,17.3,7.4z"
      />
    </SvgIcon>
  );
};
export const CheckListIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,0.8c0.9,0,1.8,0.1,2.7,0.3c0.6,0.1,1,0.8,0.8,1.4c-0.1,0.6-0.8,1-1.4,0.8
	C13.4,3.1,12.7,3,12,3C9.6,3,7.3,4,5.6,5.7C3.9,7.4,3,9.6,3,12s0.9,4.6,2.6,6.3C7.4,20,9.6,21,12,21l0,0h0c2.4,0,4.6-0.9,6.3-2.6
	c1.7-1.7,2.6-4,2.6-6.4c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1c0,3-1.2,5.8-3.3,7.9C17.8,22,15,23.2,12,23.2l0,0h0
	c-3,0-5.8-1.2-7.9-3.3C2,17.8,0.8,15,0.8,12c0-3,1.2-5.8,3.3-7.9C6.2,2,9,0.8,12,0.8z M19,5.7c0.4-0.5,1.1-0.5,1.6-0.1
	c0.5,0.4,0.5,1.1,0.1,1.6l0,0l-7.9,9c-0.2,0.2-0.5,0.4-0.8,0.4l0,0h0c-0.3,0-0.6-0.1-0.8-0.3l0,0l-3.4-3.4c-0.4-0.4-0.4-1.1,0-1.6
	c0.4-0.4,1.1-0.4,1.6,0l0,0l2.5,2.5L19,5.7z"
      />
    </SvgIcon>
  );
};
export const CheckIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.4,4.3c-0.6-0.7-1.7-0.7-2.3,0l-11,11.7L3.9,11c-0.4-0.4-1.1-0.6-1.6-0.4c-0.6,0.2-1,0.7-1.1,1.3
	C1,12.4,1.2,13,1.6,13.4L8,19.7c0.3,0.3,0.7,0.5,1.1,0.5c0,0,0,0,0,0c0.4,0,0.8-0.2,1.1-0.5L22.4,6.7C23,6.1,23,5,22.4,4.3z"
      />
    </SvgIcon>
  );
};
export const CircleAddIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,0.8C6,0.8,1.2,5.6,1.2,11.6S6,22.5,12,22.5s10.8-4.9,10.8-10.8S18,0.8,12,0.8z M17.1,12.3h-4.3v4.3
	c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-4.3H6.9c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h4.3V6.6c0-0.4,0.3-0.7,0.7-0.7
	s0.7,0.3,0.7,0.7v4.3h4.3c0.4,0,0.7,0.3,0.7,0.7C17.8,12,17.5,12.3,17.1,12.3z"
      />
    </SvgIcon>
  );
};
export const CircleCloseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M4.3,4c-4.2,4.2-4.2,11.1,0,15.3s11.1,4.2,15.3,0s4.2-11.1,0-15.3S8.6-0.3,4.3,4z M16.1,8.6L13,11.6l3.1,3.1
	c0.3,0.3,0.3,0.7,0,1s-0.7,0.3-1,0L12,12.6l-3.1,3.1c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1l3.1-3.1L7.9,8.6c-0.3-0.3-0.3-0.7,0-1
	c0.3-0.3,0.7-0.3,1,0l3.1,3.1l3.1-3.1c0.3-0.3,0.7-0.3,1,0C16.4,7.8,16.4,8.3,16.1,8.6z"
      />
    </SvgIcon>
  );
};
export const DeleteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.6,10.9c0.6,0,1.1,0.5,1.1,1.1l0,0v4.5c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1l0,0V12
	C7.5,11.4,8,10.9,8.6,10.9z M15.4,10.9c0.6,0,1.1,0.5,1.1,1.1l0,0v4.5c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1l0,0V12
	C14.3,11.4,14.8,10.9,15.4,10.9z M18.8,19.9c0,0.6-0.5,1.1-1.1,1.1H6.4c-0.6,0-1.1-0.5-1.1-1.1V7.5h13.5V19.9z M9.7,3.4
	C9.7,3.2,10,3,10.3,3h3.4c0.3,0,0.6,0.2,0.6,0.4v1.9H9.7V3.4z M22.1,5.2H21h-4.5V3.4c0-1.4-1.3-2.6-2.8-2.6h-3.4
	c-1.6,0-2.8,1.2-2.8,2.6v1.9H3H1.9c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1H3v12.4c0,1.9,1.5,3.4,3.4,3.4h11.3
	c1.9,0,3.4-1.5,3.4-3.4V7.5h1.1c0.6,0,1.1-0.5,1.1-1.1S22.8,5.2,22.1,5.2L22.1,5.2z"
      />
    </SvgIcon>
  );
};
export const DragIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.3,11.2l-3.5-3.5c-0.5-0.5-1.2-0.5-1.6,0c-0.5,0.5-0.5,1.2,0,1.6l1.5,1.5h-6.5V4.4l1.5,1.5
	c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.5-0.5,0.5-1.2,0-1.6l-3.5-3.5c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3
	L7.7,4.2c-0.5,0.5-0.5,1.2,0,1.6c0.5,0.5,1.2,0.5,1.6,0l1.5-1.5v6.5H4.4l1.5-1.5c0.5-0.5,0.5-1.2,0-1.6c-0.5-0.5-1.2-0.5-1.6,0
	l-3.5,3.5c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.6,0.3,0.8l3.5,3.5c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3
	c0.5-0.5,0.5-1.2,0-1.6l-1.5-1.5h6.5v6.5l-1.5-1.5c-0.5-0.5-1.2-0.5-1.6,0c-0.5,0.5-0.5,1.2,0,1.6l3.5,3.5c0.2,0.2,0.5,0.3,0.8,0.3
	h0c0.3,0,0.6-0.1,0.8-0.3l3.5-3.5c0.5-0.5,0.5-1.2,0-1.6c-0.5-0.5-1.2-0.5-1.6,0l-1.5,1.5v-6.5h6.5l-1.5,1.5c-0.5,0.5-0.5,1.2,0,1.6
	c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l3.5-3.5c0.2-0.2,0.3-0.5,0.3-0.8C23.6,11.7,23.5,11.4,23.3,11.2"
      />
    </SvgIcon>
  );
};
export const DropUpIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.5,16.1c0,0.4-0.1,0.7-0.4,1.1c-0.6,0.7-1.6,0.8-2.3,0.2L12,10l-8.8,7.1
	c-0.7,0.6-1.7,0.5-2.3-0.2c-0.6-0.7-0.5-1.7,0.2-2.3l9.9-8c0.6-0.5,1.5-0.5,2.1,0l9.8,8.2C23.3,15.2,23.5,15.6,23.5,16.1"
      />
    </SvgIcon>
  );
};
export const FilterIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,5.2c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S12.6,5.2,12,5.2 M15.4,4
	c0-1.9-1.5-3.4-3.4-3.4S8.6,2.2,8.6,4c0,1.5,1,2.7,2.3,3.2v15c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-15C14.5,6.8,15.4,5.5,15.4,4
	 M5.2,18.8c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S5.8,18.8,5.2,18.8 M6.3,14.5V1.8c0-0.6-0.5-1.1-1.1-1.1
	S4,1.1,4,1.8v12.7c-1.3,0.5-2.3,1.7-2.3,3.2c0,1.5,1,2.7,2.3,3.2v1.3c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-1.3
	c1.3-0.5,2.3-1.7,2.3-3.2C8.6,16.2,7.6,15,6.3,14.5 M18.8,14.3c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1
	C20,13.8,19.4,14.3,18.8,14.3 M22.2,13.1c0-1.5-1-2.7-2.3-3.2V1.8c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1v8.2
	c-1.3,0.5-2.3,1.7-2.3,3.2s1,2.7,2.3,3.2v5.9c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-5.9C21.3,15.9,22.2,14.6,22.2,13.1"
      />
    </SvgIcon>
  );
};
export const MoreIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,18.1c1.3,0,2.5,1.1,2.5,2.5c0,1.3-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5
	C9.5,19.2,10.7,18.1,12,18.1z M12,9.5c1.3,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5S9.5,13.3,9.5,12S10.7,9.5,12,9.5z M12,1
	c1.3,0,2.5,1.1,2.5,2.5S13.3,5.9,12,5.9S9.5,4.8,9.5,3.4S10.7,1,12,1z"
      />
    </SvgIcon>
  );
};
export const PostDayIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.4,10.7c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S20.7,10.7,17.4,10.7z M19.4,19.5l-2.6-2.6v-3.8H18v3.3
	l2.2,2.2L19.4,19.5z M3,12.5v4.2l6.5-2.7C9.2,14.8,9,15.7,9,16.7v0.1l-8.4,3.5V1.1l17.1,7.2c-0.1,0-0.2,0-0.3,0
	c-1.4,0-2.6,0.3-3.8,0.9L3,4.7v4.2l7.2,1.8L3,12.5z"
      />
    </SvgIcon>
  );
};
export const RemarksIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,6.4c0.6,0,1.1,0.5,1.1,1.1S12.6,8.6,12,8.6s-1.1-0.5-1.1-1.1S11.4,6.4,12,6.4z M12,9.8
        c0.6,0,1.1,0.5,1.1,1.1V7.5v9c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1v-3.4v-2.2C10.9,10.3,11.4,9.8,12,9.8z M12,21c-4.9,0-9-4-9-9
        s4-9,9-9s9,4,9,9S16.9,21,12,21 M12,0.8C5.8,0.8,0.8,5.8,0.8,12s5,11.2,11.2,11.2s11.2-5,11.2-11.2S18.2,0.8,12,0.8"
      />
    </SvgIcon>
  );
};
export const TagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M18.6,6.3l-5.2-5.2c-0.8-0.8-2.2-0.8-3,0L5.3,6.3C4.8,6.7,4.6,7.2,4.6,7.8v13.4c0,0.5,0.2,1.1,0.6,1.5
	c0.4,0.4,0.9,0.6,1.5,0.6h10.4c0.5,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-1,0.6-1.5V7.7C19.3,7.2,19.1,6.7,18.6,6.3z M17.2,21.1l-10.4,0
	l0-13.4L12,2.5l5.2,5.2l0,0V21.1z M10.8,7.4c-0.6-0.6-0.6-1.6,0-2.2c0.6-0.6,1.6-0.6,2.2,0c0.6,0.6,0.6,1.6,0,2.2
	C12.5,8,11.5,8,10.8,7.4z M15.8,12.6c0,0.5-0.4,0.9-0.9,0.9H9.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h5.7
	C15.4,11.7,15.8,12.1,15.8,12.6z M15.8,16.2c0,0.5-0.4,0.9-0.9,0.9H9.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h5.7
	C15.4,15.3,15.8,15.7,15.8,16.2z"
      />
    </SvgIcon>
  );
};
export const UnavailableIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.7,3.6C19.9,3.2,19.1,3,16.9,3H7.1C4.9,3,4,3.2,3.2,3.7c-0.8,0.5-1.5,1.1-2,2c-0.5,0.9-0.7,1.7-0.7,4v4
	c0,2.3,0.2,3.1,0.7,4c0.5,0.8,1.1,1.5,2,2c0.9,0.5,1.7,0.7,4,0.7h9.7c2.2,0,3-0.2,3.9-0.6l0.2-0.1l0.4-0.3c0.6-0.4,1.1-1,1.4-1.6
	c0.5-0.9,0.7-1.7,0.7-4v-4c0-2.3-0.2-3.1-0.7-4C22.5,5,22,4.4,21.4,4 M7.1,4.2h9.7c1.5,0,2.3,0.1,2.9,0.3l-7.5,6.1L4.7,4.3
	C5.2,4.2,6,4.2,7.1,4.2z M3,18c-0.3-0.3-0.6-0.6-0.8-1c-0.4-0.7-0.6-1.4-0.6-3.4v-4c0-2,0.2-2.7,0.6-3.4c0.2-0.4,0.5-0.7,0.8-1
	l7.9,6.4L3,18z M16.9,19.1H7.1c-1.2,0-1.9-0.1-2.4-0.2l7.6-6.2l7.5,6.1C19.2,19,18.4,19.1,16.9,19.1z M22.3,13.6
	c0,2-0.2,2.7-0.6,3.4c-0.1,0.3-0.3,0.5-0.5,0.7l-7.6-6.2l7.6-6.2c0.2,0.2,0.4,0.5,0.5,0.7c0.4,0.7,0.6,1.4,0.6,3.4V13.6z"
      />
    </SvgIcon>
  );
};

export const BedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.3,10.9v-3c0-0.7,0-1.1-0.3-1.5c-0.2-0.3-0.4-0.6-0.7-0.7c-0.4-0.2-0.8-0.3-1.5-0.3H8.2c-0.7,0-1.1,0-1.5,0.3
	C6.4,5.9,6.2,6.1,6,6.4C5.8,6.9,5.8,7.2,5.8,7.9v3H0v1.3h24v-1.3H17.3z M7,7.9c0-0.6,0-0.8,0.1-0.9c0-0.1,0.1-0.2,0.2-0.2
	c0.1-0.1,0.2-0.1,0.9-0.1h6.6c0.6,0,0.8,0,0.9,0.1c0.1,0,0.2,0.1,0.2,0.2C16,7.2,16,7.3,16,7.9v2.7H7V7.9z"
      />
    </SvgIcon>
  );
};
export const MenIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.5,7.8c-4.3,0-7.7,3.4-7.7,7.7s3.4,7.7,7.7,7.7s7.7-3.4,7.7-7.7c0-1.6-0.5-3.1-1.4-4.4l5.6-5.5
	v3.6h2.8V0.8h-8.4v2.8h3.6l-5.6,5.6C11.6,8.3,10.1,7.8,8.5,7.8 M8.5,10.6c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9s-4.9-2.2-4.9-4.9
	S5.8,10.6,8.5,10.6"
      />
    </SvgIcon>
  );
};
export const FemaleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.5,8.1c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5s-2,4.5-4.5,4.5S7.5,10.6,7.5,8.1 M19.1,8.1
	C19.1,4.2,15.9,1,12,1S4.9,4.2,4.9,8.1c0,3.5,2.5,6.4,5.8,7v2.7H8.1v2.6h2.6V23h2.6v-2.6h2.6v-2.6h-2.6v-2.7
	C16.6,14.5,19.1,11.6,19.1,8.1"
      />
    </SvgIcon>
  );
};
export const DateTimeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.7,12.7c-1-1.1-2.3-1.8-3.7-2.1V4.2V4c-0.1-0.5-0.3-0.9-0.7-1.3c-0.4-0.4-0.9-0.6-1.5-0.6h-2.3l-0.7-1.4
	h-0.2h-0.1c-0.2,0-0.3,0.1-0.5,0.3s-0.3,0.4-0.3,0.7v0.5H7L6.3,0.8H6.1C5.9,0.8,5.7,0.9,5.5,1C5.3,1.2,5.2,1.5,5.2,1.7v0.5H2.8H2.6
	C2.1,2.3,1.7,2.5,1.3,2.9C1,3.3,0.8,3.9,0.8,4.5v11.3V16c0.1,0.5,0.3,0.9,0.7,1.3c0.4,0.4,0.9,0.6,1.5,0.6l8,0.2v0.2
	c0.3,1.3,1,2.5,2,3.4c1.1,1,2.5,1.5,4,1.5c1.7,0,3.2-0.7,4.4-1.9c1.2-1.2,1.8-2.8,1.8-4.5C23.3,15.4,22.7,13.9,21.7,12.7z M2.6,6.8
	V4.7l2.6-0.5v0.4c0,0.3,0.1,0.5,0.3,0.7c0.8,0.2,1,0.2,1.3,0C7,5.1,7.1,4.9,7.1,4.7V4.1h4.5v0.5c0,0.3,0.1,0.5,0.3,0.7
	c0.8,0.2,1,0.2,1.3,0c0.1-0.1,0.2-0.3,0.3-0.5V4.2h2.1l0.5,2.7H2.6V6.8z M10.9,15.6v0.2H3.2L2.7,8.6h13.4v2
	c-1.3,0.3-2.5,0.9-3.5,1.8C11.7,13.3,11.2,14.4,10.9,15.6z M20.1,20c-0.8,0.8-1.9,1.3-3.1,1.3s-2.2-0.5-3.1-1.3
	c-0.8-0.8-1.3-2-1.3-3.1c0-1.2,0.5-2.3,1.3-3.1c0.8-0.8,1.9-1.3,3.1-1.3s2.2,0.5,3.1,1.3c0.9,0.8,1.3,1.9,1.3,3.1
	C21.4,18.1,20.9,19.2,20.1,20z M20,17v0.2L16.9,18l-0.8-3.5c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.3-0.3,0.5-0.3H17h0.2v0.1l0.7,2.4H19
	c0.3,0,0.5,0.1,0.7,0.4C19.9,16.5,20,16.8,20,17z"
      />
    </SvgIcon>
  );
};

export const RemarksBgIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M11.8,0.9c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9S17.9,0.9,11.8,0.9z
	 M14.1,17.8c-0.6,0.2-1,0.4-1.3,0.5c-0.3,0.1-0.7,0.2-1.2,0.2c-0.7,0-1.2-0.2-1.6-0.5c-0.4-0.3-0.6-0.8-0.6-1.3c0-0.2,0-0.4,0-0.6
	c0-0.2,0.1-0.4,0.1-0.7l0.7-2.5c0.1-0.2,0.1-0.5,0.2-0.7c0-0.2,0.1-0.4,0.1-0.6c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.1-0.4-0.2-0.8-0.2
	c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.1-0.5,0.2l0.2-0.8c0.5-0.2,0.9-0.3,1.3-0.5c0.4-0.1,0.8-0.2,1.2-0.2c0.7,0,1.2,0.2,1.6,0.5
	c0.4,0.3,0.5,0.7,0.5,1.3c0,0.1,0,0.3,0,0.6c0,0.3-0.1,0.5-0.1,0.7l-0.7,2.5c-0.1,0.2-0.1,0.4-0.2,0.7c0,0.3-0.1,0.4-0.1,0.6
	c0,0.3,0.1,0.6,0.2,0.7c0.1,0.1,0.4,0.2,0.8,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.1,0.5-0.2L14.1,17.8z M14,7.8
	c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.5,1.2-0.5
	c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.1C14.5,7.1,14.3,7.5,14,7.8z"
      />
    </SvgIcon>
  );
};

export const HignLightIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M18.4,12.8c-0.8,0.5-1.8,0.3-2.3-0.4c-0.5-0.8-0.3-1.8,0.4-2.3c0.8-0.5,1.8-0.3,2.3,0.4
	C19.4,11.3,19.2,12.3,18.4,12.8z M8.4,17.3c-0.8,0.5-1.8,0.2-2.3-0.6c-0.5-0.8-0.2-1.8,0.6-2.3C7.6,14,8.6,14.2,9,15
	C9.5,15.8,9.2,16.8,8.4,17.3z M17.8,16.7c-0.5,0.8-1.5,1.1-2.3,0.6c-0.8-0.5-1.1-1.5-0.6-2.3c0.5-0.8,1.5-1.1,2.3-0.6
	C18,14.9,18.3,15.9,17.8,16.7z M12,19.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7s1.7,0.7,1.7,1.7C13.7,19,12.9,19.7,12,19.7z
	 M7.7,8.7h1.8c1.5,0,2.8-1.2,2.8-2.8c0-0.7-0.2-1.3-0.7-1.8c-0.1-0.2-0.2-0.3-0.1-0.5c0.1-0.2,0.3-0.4,0.7-0.4
	c2.5,0,4.9,1.1,6.6,3.1c1.7,1.9,2.4,4.4,2.1,7c-0.6,4.2-4.4,7.6-8.7,7.6H12c-2.6,0-5-1-6.7-2.7c-1.4-1.5-2.2-3.3-2.1-5.3
	C3.3,10.6,5.4,8.7,7.7,8.7 M3.7,19.6c2.1,2.2,5.2,3.4,8.4,3.4h0c5.5,0,10.1-4.1,10.8-9.5c0.4-3.2-0.5-6.3-2.6-8.7
	c-2.1-2.4-5-3.8-8.2-3.8h0c-1.3,0-2.5,0.9-2.8,2.1C9.1,4,9.3,4.9,10,5.6c0.1,0.1,0.1,0.2,0.1,0.4c0,0.3-0.2,0.6-0.6,0.6H7.7
	c-3.5,0-6.6,2.9-6.7,6.3C0.9,15.3,1.8,17.7,3.7,19.6"
      />
    </SvgIcon>
  );
};

export const CustomizeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M19.7,5.8l-7.8,7.8c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.3-0.5-0.5-0.9-0.7l7.9-7.8
	c0.4-0.4,1.1-0.4,1.5,0C19.9,4.5,20,4.8,20,5.1C20,5.4,19.9,5.6,19.7,5.8 M7,19.9L4,20L4,17c0-1.7,1.4-3.1,3.1-3.1c0,0,0,0,0.1,0
	c0.8,0,1.5,0.3,2,0.8c0.6,0.6,0.8,1.3,0.8,2.1C10.1,18.5,8.7,19.9,7,19.9 M22.7,5.1c0-1-0.4-2-1.1-2.7c-1.4-1.4-3.9-1.4-5.3,0
	l-8.8,8.8c-0.1,0-0.2,0-0.3,0C4,11.3,1.4,13.8,1.4,17l-0.1,4.4c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,0.9,0.4h0L7,22.6
	c3.1-0.1,5.7-2.6,5.8-5.8c0-0.1,0-0.2,0-0.3l8.8-8.8C22.3,7,22.7,6.1,22.7,5.1"
      />
    </SvgIcon>
  );
};

export const DropLeftIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.1,0.5c0.4,0,0.7,0.1,1.1,0.4c0.7,0.6,0.8,1.6,0.2,2.3L10,12l7.1,8.8
	c0.6,0.7,0.5,1.7-0.2,2.3c-0.7,0.6-1.7,0.5-2.3-0.2l-8-9.9c-0.5-0.6-0.5-1.5,0-2.1l8.2-9.8C15.2,0.7,15.6,0.5,16.1,0.5"
      />
    </SvgIcon>
  );
};

export const DropRightIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.9,23.5c-0.4,0-0.7-0.1-1.1-0.4c-0.7-0.6-0.8-1.6-0.2-2.3L14,12L6.9,3.2
	C6.3,2.5,6.4,1.5,7.1,0.9c0.7-0.6,1.7-0.5,2.3,0.2l8,9.9c0.5,0.6,0.5,1.5,0,2.1l-8.2,9.8C8.8,23.3,8.4,23.5,7.9,23.5"
      />
    </SvgIcon>
  );
};

export const DocIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M18.2,21H5.8c-0.3,0-0.6-0.3-0.6-0.6V3.5C5.2,3.2,5.5,3,5.8,3h5v4.7c0,1.8,1.4,3.2,3.1,3.2h4.8
	v9.6C18.8,20.8,18.5,21,18.2,21L18.2,21z M18.4,8.6h-4.4c-0.4,0-0.8-0.4-0.8-1V3h0.1L18.4,8.6z M20.7,7.9l-6.2-6.8
	c-0.2-0.2-0.5-0.4-0.8-0.4H5.8C4.3,0.7,3,2,3,3.5v16.9c0,1.6,1.3,2.8,2.9,2.8h12.3c1.6,0,2.9-1.3,2.9-2.8V8.6
	C21,8.3,20.9,8.1,20.7,7.9L20.7,7.9z"
      />
    </SvgIcon>
  );
};

export const ReNameIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.6,1.3H2.4c-0.7,0-1.3,0.6-1.3,1.4v5C1.1,8.4,1.7,9,2.4,9s1.3-0.6,1.3-1.4V4.1h6.9v16.4H8.2
	c-0.7,0-1.3,0.6-1.3,1.4c0,0.8,0.6,1.4,1.3,1.4h7.7c0.7,0,1.3-0.6,1.3-1.4c0-0.8-0.6-1.4-1.3-1.4h-2.5V4.1h6.9v3.6
	c0,0.8,0.6,1.4,1.3,1.4s1.3-0.6,1.3-1.4v-5C22.9,1.9,22.3,1.3,21.6,1.3z"
      />
    </SvgIcon>
  );
};

export const SetHeightIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M14.2,5.3c-0.6,0-1.1-0.5-1.1-1.1S13.6,3,14.2,3h2.2c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H14.2z
	 M6,20.7c-0.4,0.4-1.1,0.4-1.6,0l-3.4-3.4c-0.4-0.4-0.4-1.2,0-1.6c0.4-0.4,1.1-0.4,1.6,0l1.5,1.5V6.8L2.7,8.2
	c-0.4,0.4-1.2,0.4-1.6,0C0.7,7.7,0.7,7,1.1,6.6l3.4-3.3c0.4-0.4,1.1-0.4,1.6,0l3.4,3.4c0.4,0.4,0.4,1.1,0,1.6C9,8.7,8.3,8.7,7.8,8.3
	L6.4,6.9v10.4l1.5-1.4c0.4-0.4,1.2-0.4,1.6,0c0.4,0.4,0.4,1.2,0,1.6L6,20.7z M14.2,13.1c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h4.5
	c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H14.2z M14.2,21c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h7.9c0.6,0,1.1,0.5,1.1,1.1
	S22.7,21,22.1,21H14.2z"
      />
    </SvgIcon>
  );
};

export const MissingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.5,11.1c2.8,0,5-2.3,5-5s-2.3-5-5-5c-2.8,0-5,2.3-5,5S6.7,11.1,9.5,11.1z M9.5,4c1.2,0,2.1,1,2.1,2.1s-1,2.1-2.1,2.1
	s-2.1-1-2.1-2.1S8.3,4,9.5,4z M23.1,4.3c0,1.5-0.9,2.8-2.3,3.2l-0.1,0v0.3c0,0.4-0.3,0.8-0.7,1l-0.3,0h0c-0.5,0-0.8-0.3-1-0.7
	l-0.1-0.3l0-1.2c0-0.5,0.4-0.9,0.9-1l0.1,0c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4c0,0.6-0.5,1-1,1s-1-0.5-1-1
	c0-1.9,1.5-3.4,3.4-3.4S23.1,2.4,23.1,4.3z M20.7,12.7c0,0.6-0.5,1-1,1s-1-0.5-1-1c0-0.6,0.5-1,1-1S20.7,12.1,20.7,12.7z M18.1,21.7
	c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-3.2-2.6-5.7-5.7-5.7c-3.2,0-5.7,2.6-5.7,5.7c0,0.8-0.6,1.4-1.4,1.4
	s-1.4-0.6-1.4-1.4c0-4.8,3.9-8.6,8.6-8.6S18.1,16.9,18.1,21.7z"
      />
    </SvgIcon>
  );
};

export const SaveIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7,3.2v6.3c0,0.7,0.6,1.3,1.3,1.3h5c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3H9.5v-5h4
      c0.3,0,0.7,0.1,0.9,0.4l6.1,6.1c0.2,0.2,0.4,0.6,0.4,0.9v9c0,0.7-0.6,1.3-1.3,1.3H17V17c0-0.7-0.6-1.3-1.3-1.3H8.2
      C7.5,15.8,7,16.3,7,17v3.8H4.5c-0.7,0-1.3-0.6-1.3-1.3V4.5c0-0.7,0.6-1.3,1.3-1.3H7z M14.5,18.3v2.5h-5v-2.5H14.5z M22.2,7.9
      l-6.1-6.1c-0.7-0.7-1.7-1.1-2.7-1.1h-9c-2.1,0-3.8,1.7-3.8,3.8v15.1c0,2.1,1.7,3.8,3.8,3.8h3.8h7.5h3.8c2.1,0,3.8-1.7,3.8-3.8v-9
      C23.3,9.5,22.9,8.6,22.2,7.9L22.2,7.9z"
      />
    </SvgIcon>
  );
};

export const ScanIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.8,5.9v2H21v-2c0-0.8-0.1-1.4-0.4-1.7c-0.3-0.3-0.9-0.4-1.7-0.4h-2V1.9h2C21.5,1.9,22.8,3.2,22.8,5.9z
	 M4.9,19.8c-0.3-0.3-0.4-0.9-0.4-1.7v-2H2.6v2c0,2.7,1.3,4,4,4h2v-1.8h-2C5.8,20.2,5.2,20.1,4.9,19.8z M4.5,5.9
	c0-0.8,0.1-1.4,0.4-1.7c0.3-0.3,0.9-0.4,1.7-0.4h2V1.9h-2c-2.7,0-4,1.3-4,4v2h1.8V5.9z M21,18.1c0,0.8-0.1,1.4-0.4,1.7
	c-0.3,0.3-0.9,0.4-1.7,0.4h-2v1.8h2c2.7,0,4-1.3,4-4v-2H21V18.1z M5.4,16.6h1.8V7.4H5.4V16.6z M20.1,7.4h-1.4v9.2h1.4V7.4z
	 M8.1,16.6h0.9V7.4H8.1V16.6z M13.2,16.6h1.4V7.4h-1.4V16.6z M10,16.6h2.3V7.4H10V16.6z M17.8,7.4h-2.3v9.2h2.3V7.4z"
      />
    </SvgIcon>
  );
};

export const ArrowBottomIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.02,17.85c0.53-0.37,0.65-1.1,0.28-1.63c-0.37-0.53-1.1-0.65-1.63-0.28l0,0l-2.85,2.01
        c0-0.03,0.02-0.07,0.02-0.1v-14c0-0.64-0.52-1.17-1.17-1.17s-1.17,0.52-1.17,1.17l0,0v14l-2.8-2.1c-0.52-0.39-1.25-0.28-1.63,0.23
        c-0.39,0.52-0.28,1.25,0.23,1.63l0,0l4.67,3.5c0.4,0.3,0.96,0.31,1.37,0.02C12.35,21.13,17.02,17.85,17.02,17.85z"
      />
    </SvgIcon>
  );
};

export const GraphIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.92,13.72h10.19c-0.23,2.1-1.16,4.05-2.66,5.54c-1.73,1.74-4.09,2.71-6.54,2.71c-2.46,0-4.81-0.97-6.54-2.71
       c-1.74-1.73-2.71-4.09-2.71-6.54c0-2.44,0.96-4.78,2.68-6.51C5.8,4.71,7.74,3.77,9.82,3.53L9.92,13.72z M21.6,10.44
       c-0.23-2.1-1.17-4.06-2.68-5.55c-1.51-1.5-3.49-2.43-5.61-2.65l0.07,8.2H21.6z"
      />
    </SvgIcon>
  );
};

export const UpdateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M21.66 12a9 9 0 0 0-9-9 8.978 8.978 0 0 0-6.9 3.226l1.6 1.6a6.733 6.733 0 0 1 5.3-2.576A6.749 6.749 0 0 1 19.41 12h-2.25l3.374 3.375L23.91 12h-2.25zm-9 6.75A6.752 6.752 0 0 1 5.91 12h2.25L4.783 8.625 1.41 12h2.25c0 4.969 4.031 9 9 9a8.981 8.981 0 0 0 6.9-3.225l-1.601-1.601a6.735 6.735 0 0 1-5.299 2.576z" />
    </SvgIcon>
  );
};

export const OffIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.2,12.3c0,5.4-4.4,9.7-9.7,9.7s-9.7-4.4-9.7-9.7c0-3.5,1.8-6.7,4.8-8.4c0,0,0,0,0,0c0.5-0.2,1-0.1,1.3,0.3
	C9.2,4.7,9,5.3,8.6,5.6v0c-2.4,1.4-3.9,3.9-3.9,6.7c0,4.3,3.5,7.8,7.8,7.8c4.3,0,7.8-3.5,7.8-7.8c0-2.8-1.5-5.3-3.9-6.7
	c-0.5-0.3-0.6-0.9-0.4-1.3c0.3-0.5,0.9-0.6,1.3-0.4l0,0C20.3,5.6,22.2,8.8,22.2,12.3z M12.4,13.3c0.5,0,1-0.4,1-1V3c0-0.5-0.4-1-1-1
	c-0.5,0-1,0.4-1,1v9.3C11.5,12.8,11.9,13.3,12.4,13.3z"
      />
    </SvgIcon>
  );
};

export const SortIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.2,13.9c0,0,0,0.1,0,0.1l-4.2,3.6c0,0-0.1,0-0.1,0l-4.6-3.6c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.1L16.2,13.9
       C16.2,13.9,16.2,13.9,16.2,13.9z M7.4,10.2h8.8c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1l-4.6-3.6c0,0-0.1,0-0.1,0L7.3,10
       C7.3,10.1,7.3,10.1,7.4,10.2C7.3,10.2,7.4,10.2,7.4,10.2z"
      />
    </SvgIcon>
  );
};

export const DownloadIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.31,14.87c-0.44-0.33-0.53-0.96-0.2-1.4s0.96-0.53,1.4-0.2l2.4,1.8v-12c0-0.55,0.45-1,1-1s1,0.45,1,1v12
        c0,0.03-0.02,0.06-0.02,0.09l2.44-1.72c0.01-0.01,0.02-0.01,0.03-0.02c0.46-0.31,1.08-0.19,1.39,0.27c0.31,0.46,0.19,1.08-0.27,1.39
        l-4,2.81c-0.35,0.25-0.83,0.24-1.17-0.02L7.31,14.87z M20.58,20.07h-17c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h17c0.55,0,1-0.45,1-1
        C21.58,20.51,21.13,20.07,20.58,20.07z"
      />
    </SvgIcon>
  );
};

export const MinusIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M19.5,13.8h-13c-0.6,0-1-0.4-1-1s0.4-1,1-1h13c0.6,0,1,0.4,1,1S20.1,13.8,19.5,13.8z" />
    </SvgIcon>
  );
};

export const MinusGrayIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,3c0.6,0,1,0.4,1,1v7h7c0.6,0,1,0.4,1,1s-0.4,1-1,1h-7v7c0,0.6-0.4,1-1,1s-1-0.4-1-1
       v-7H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h7V4C11,3.4,11.4,3,12,3z"
      />
    </SvgIcon>
  );
};

export const PlusIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M12 3a1 1 0 0 1 1 1l-.001 7H20a1 1 0 0 1 0 2h-7.001L13 20a1 1 0 0 1-2 0l-.001-7H4a1 1 0 0 1 0-2h6.999L11 4a1 1 0 0 1 1-1z" />
    </SvgIcon>
  );
};

export const TeleVisitIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.8,17.6H1.2V3.3h5.2c0.4,0,0.8,0.3,0.8,0.8S6.8,4.8,6.4,4.8H2.7v11.3h18.6V4.8h-3.8c-0.4,0-0.8-0.3-0.8-0.8
	s0.3-0.8,0.8-0.8h5.3V17.6z"
      />
      <path
        d="M1.9,23.3c-0.4,0-0.8-0.3-0.8-0.8v-3.3l6.3,0c0.4,0,0.7,0.3,0.7,0.8s-0.3,0.7-0.8,0.7c0,0,0,0,0,0l-4.8,0v1.8
	C2.7,23,2.4,23.3,1.9,23.3z M22.1,23.3c-0.4,0-0.8-0.3-0.8-0.8v-1.8l-4.3,0h0c-0.4,0-0.7-0.3-0.8-0.7s0.3-0.8,0.7-0.8l5.8,0v3.3
	C22.8,23,22.5,23.3,22.1,23.3z M5.4,17.6c0,0-0.1,0-0.1,0c-0.4-0.1-0.7-0.4-0.6-0.8c0.6-4.1,3.6-7.1,7.3-7.1c3.7,0,6.7,3,7.3,7.1
	c0.1,0.4-0.2,0.8-0.6,0.8c-0.4,0.1-0.8-0.2-0.8-0.6c-0.5-3.4-2.9-5.8-5.8-5.8c-2.9,0-5.4,2.5-5.8,5.8C6.1,17.3,5.8,17.6,5.4,17.6z
	 M12,9.1c-2.3,0-4.2-1.9-4.2-4.2S9.7,0.7,12,0.7c2.3,0,4.2,1.9,4.2,4.2S14.3,9.1,12,9.1z M12,2.2c-1.5,0-2.7,1.2-2.7,2.7
	s1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7S13.5,2.2,12,2.2z"
      />
      <path d="M17.1,21.8H6.9v-5.7h10.3V21.8z M8.4,20.3h7.3v-2.7H8.4V20.3z" />
    </SvgIcon>
  );
};

export const WardDriveIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M24.8,3.8h-7.9l-1.3-1.8c-0.2-0.3-0.7-0.6-1.1-0.6H9c-0.7,0-1.3,0.6-1.3,1.3v1.6H6.1C5.4,4.4,4.8,5,4.8,5.8v1.6
	H3.2C2.4,7.4,1.8,8,1.8,8.7v12c0,0.7,0.6,1.3,1.3,1.3H19h0c0.7,0,1.3-0.6,1.3-1.3v-1.6h1.6c0.7,0,1.3-0.6,1.3-1.3v-1.6h1.6
	c0.7,0,1.3-0.6,1.3-1.3V5.2C26.2,4.4,25.6,3.8,24.8,3.8z M18.8,20.5H3.3V8.9h5.3l1.3,1.7c0.3,0.3,0.7,0.6,1.1,0.6h7.8V20.5z
	 M21.7,17.6h-1.4V11c0-0.7-0.6-1.3-1.3-1.3H11L9.8,7.9C9.5,7.6,9.1,7.4,8.7,7.4H6.3V5.9h5.3l1.3,1.8c0.3,0.3,0.7,0.6,1.1,0.6h7.8
	V17.6z M24.7,14.7h-1.4V8.1c0-0.7-0.6-1.3-1.3-1.3H14L12.7,5c-0.3-0.3-0.7-0.6-1.1-0.6H9.2V3h5.3l1.3,1.8c0.3,0.3,0.7,0.5,1.1,0.5
	h7.8V14.7z M15.8,18c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S15.8,18.6,15.8,18z M13,18c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1
	S13,18.6,13,18z"
      />
    </SvgIcon>
  );
};
export const HomeLeaveIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        className="st0"
        d="M17.3,10.7c0.1,0.1,0.2,0.3,0.2,0.4v7.5c0,0.2-0.1,0.3-0.3,0.3h-5c-0.2,0-0.3-0.1-0.3-0.3v-5.2
	c0-0.2-0.1-0.3-0.3-0.3H8.4c-0.2,0-0.3,0.1-0.3,0.3v5.2c0,0.2-0.1,0.3-0.3,0.3h-5c-0.2,0-0.3-0.1-0.3-0.3v-7.5
	c0-0.2,0.1-0.3,0.2-0.4l7.1-5.7c0.1-0.1,0.3-0.1,0.4,0L17.3,10.7z M19.6,8.2L19.6,8.2l-3.4-2.9V1.8c0-0.2-0.1-0.3-0.3-0.3
	c0,0,0,0,0,0H14c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0V3l-3-2.6l0,0c-0.1-0.1-0.3-0.2-0.4-0.3C10.2,0,9.8,0,9.6,0.1L9.2,0.5l0,0
	L0.4,8.2C0,8.5-0.1,9.2,0.2,9.6c0.3,0.5,0.9,0.5,1.3,0.2l8.2-7.1c0.2-0.1,0.4-0.1,0.6,0l8.2,7.1c0.2,0.1,0.4,0.2,0.6,0.2
	c0.3,0,0.5-0.1,0.7-0.4C20.1,9.2,20,8.5,19.6,8.2z"
      />
    </SvgIcon>
  );
};
export const PendingFYAIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M14.8,13.5c0,0.5-0.4,0.8-0.9,0.8h-3.4c-0.5,0-0.8-0.4-0.8-0.8v-3.4c0,0,0,0,0,0c0-0.5,0.4-0.8,0.9-0.8s0.8,0.4,0.8,0.9v2.6
	h2.6c0,0,0,0,0,0C14.4,12.7,14.8,13,14.8,13.5z M19,13.5c0,4.7-3.8,8.5-8.5,8.5S2,18.2,2,13.5S5.8,5,10.5,5S19,8.8,19,13.5z
	 M17.3,13.5c0-3.8-3-6.8-6.8-6.8s-6.8,3-6.8,6.8s3,6.8,6.8,6.8S17.3,17.3,17.3,13.5z M21,9c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1
	S21.6,9,21,9z M21,2c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1s1-0.4,1-1V3C22,2.4,21.6,2,21,2z"
      />
    </SvgIcon>
  );
};
export const UnmuteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="m3 7.098 6 5.062V17H3V7.098zM9 7v.418L8.505 7H9zM10 13.204l6.657 6.741L10 16.795v-3.591zM21 2v16.649L10 7.513v-.48L21 2z" />
      <path stroke="#538FFF" strokeWidth="2" d="m2.74 2.5 19.262 19.502" />
    </SvgIcon>
  );
};
export const UnmutePlayIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M3 7h6v10H3zM10 7.034 21 2v20l-11-5.205z" />
    </SvgIcon>
  );
};

export const AirplaneIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.7,20c-0.4,0-0.8-0.2-0.9-0.6l-3.4-7.7L0.6,8.2C0.2,8,0,7.7,0,7.3c0-0.4,0.3-0.8,0.7-0.9l18-6.3
	c0.1,0,0.2,0,0.2-0.1C19,0,19,0,19.1,0c0,0,0,0,0,0l0,0c0.2,0,0.5,0.1,0.6,0.3c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
	C19.9,0.5,20,0.7,20,0.9C20,1,20,1,20,1.1c0,0.1,0,0.2-0.1,0.2l-6.3,18C13.5,19.7,13.2,20,12.7,20C12.7,20,12.7,20,12.7,20z
	 M10.3,11.1l2.3,5.2l4-11.5L10.3,11.1z M3.7,7.4l5.2,2.3l6.3-6.3L3.7,7.4z"
      />
    </SvgIcon>
  );
};
export const SeeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.9,11.5c-0.6-1.1-4.2-6.7-10.1-6.5C6.2,5.1,3,10,2.1,11.5c-0.2,0.3-0.2,0.7,0,1c0.6,1.1,4,6.5,9.9,6.5l0.2,0
	c5.5-0.1,8.7-5,9.6-6.5C22,12.2,22,11.8,21.9,11.5z M12.2,17c-4.3,0.1-7.1-3.6-8-5c1-1.6,3.6-4.9,7.6-5c4.3-0.1,7.1,3.6,8,5
	C18.8,13.6,16.2,16.9,12.2,17z M12,8.5c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S13.9,8.5,12,8.5z M12,13.5
	c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S12.8,13.5,12,13.5z"
      />
    </SvgIcon>
  );
};

export const MaleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.3,7.5C3.7,7.5,0,11.2,0,15.7c0,0,0,0,0,0C0,20.3,3.7,24,8.2,24c0,0,0,0,0,0c4.6,0,8.2-3.7,8.3-8.2
c0-1.7-0.5-3.3-1.5-4.7l6-5.9V9h3V0h-9v3h3.9l-6,6C11.5,8,9.9,7.5,8.3,7.5 M8.3,10.5c2.9,0,5.2,2.4,5.2,5.2c0,2.9-2.4,5.2-5.2,5.2
C5.4,21,3,18.6,3,15.7C3,12.9,5.4,10.5,8.3,10.5"
      />
    </SvgIcon>
  );
};
export const NoticeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M13,16c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1h0C12.6,15,13,15.4,13,16z M22.6,19.3c-0.6,1-1.7,1.7-2.9,1.7H4.3
	c-1.2,0-2.4-0.6-2.9-1.7c-0.5-0.9-0.5-2.1,0-3L9.1,3.6C9.7,2.6,10.8,2,12,2s2.3,0.6,2.9,1.6l7.7,12.7C23.1,17.2,23.1,18.4,22.6,19.3
	z M20.8,17.3L13.2,4.6c-0.5-0.8-1.9-0.8-2.4,0L3.2,17.3c-0.2,0.3-0.2,0.7,0,1C3.4,18.8,3.8,19,4.3,19h15.3c0.5,0,1-0.2,1.2-0.6
	C21.1,18,21,17.6,20.8,17.3z M12,8c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1s1-0.4,1-1V9C13,8.4,12.6,8,12,8z"
      />
    </SvgIcon>
  );
};
export const AcceptIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,13.5l6.3-7.2c0.4-0.4,1-0.4,1.4-0.1c0.4,0.4,0.4,1,0.1,1.4l-7,8C12.6,15.9,12.3,16,12,16h0c-0.3,0-0.5-0.1-0.7-0.3l-3-3
	c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0L12,13.5z M21,11c-0.6,0-1,0.5-1,1c0,2.1-0.8,4.2-2.3,5.7C16.2,19.2,14.1,20,12,20h0
	c-2.1,0-4.1-0.8-5.6-2.3C4.8,16.2,4,14.1,4,12c0-2.1,0.8-4.2,2.3-5.7C7.8,4.9,9.9,4,12,4c0.6,0,1.3,0.1,1.9,0.2
	C14.4,4.4,15,4,15.1,3.5c0.1-0.5-0.2-1.1-0.7-1.2C13.6,2.1,12.8,2,12,2C9.3,2,6.8,3.1,4.9,5C3,6.8,2,9.4,2,12c0,2.7,1.1,5.2,2.9,7.1
	C6.8,21,9.4,22,12,22h0c2.7,0,5.2-1.1,7.1-2.9C21,17.2,22,14.6,22,12C22,11.4,21.5,11,21,11z"
      />
    </SvgIcon>
  );
};
export const HandIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.4,1.1c0.1,0,0.2,0.1,0.2,0.1c0.7,0.2,1.2,0.9,1.2,1.6c0,0.1,0,0.1,0,0.2c0.2-0.1,0.4-0.1,0.5-0.1
        c0.9-0.2,1.8,0.5,2,1.4c0,0.1,0,0.2,0,0.2c0,0.3,0,0.7,0,1c0.2-0.1,0.3-0.1,0.5-0.1c0.9-0.2,1.8,0.4,2,1.3c0,0.1,0,0.2,0,0.3
        c0,0.2,0,0.4,0,0.7c0,2.9,0,4.8,0,7.7c0,3-1.9,5.5-4.6,6.5c-4,1.3-8.2-1.3-8.8-5.5c-0.1-0.4-0.1-0.7-0.1-1.1c0-1.7,0-2.5,0-4.3
        c0-0.9,0.7-1.7,1.8-1.4c0.2,0.1,0.5,0.2,0.7,0.3V9.7c0-1.4,0-2.9,0-4.3c0-1,0.8-1.8,1.8-1.7c0.2,0,0.4,0.1,0.7,0.1V2.9
        c0-0.9,0.5-1.6,1.4-1.8c0,0,0,0,0.1,0C11.9,1.1,12.4,1.1,12.4,1.1z M8.8,10.4v4.8c0,0.1,0,0.2,0,0.2c0,0.3-0.2,0.4-0.4,0.4
        c-0.2,0-0.4-0.2-0.5-0.4c0-0.1,0-0.1,0-0.2c0-1.2,0-2.4,0-3.6c0-0.6-0.4-1.1-0.9-1.2c-0.5-0.1-0.7,0-0.7,0.5c0,1.7,0,2.5,0,4.2
        c0,0.4,0,0.7,0.1,1.1c0.6,3.4,3.8,5.5,7.1,4.7c2.5-0.6,4.4-2.8,4.5-5.3c0.1-3.2,0-5.5,0-8.7c0-0.1-0.1-0.3-0.1-0.4
        c-0.2-0.3-0.6-0.4-0.9-0.3c-0.3,0.1-0.6,0.4-0.6,0.8c0,1.5,0,3,0,4.4c0,0.4-0.2,0.6-0.4,0.6c-0.3,0-0.5-0.2-0.5-0.6V4.7
        c0-0.1,0-0.2,0-0.3C15.4,4,15,3.7,14.6,3.7c0,0,0,0-0.1,0c-0.4,0.1-0.6,0.4-0.6,0.9v6.9c0,0.4-0.2,0.6-0.4,0.6
        c-0.3,0-0.5-0.2-0.5-0.6V3c0-0.1,0-0.2,0-0.3c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.2-0.8,0.5c0,0.1-0.1,0.3-0.1,0.4
        c0,2.8,0,5.6,0,8.5c0,0.1,0,0.2,0,0.3c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.5-0.4c0-0.1,0-0.2,0-0.2V5.5c0-0.1,0-0.2,0-0.2
        c0-0.4-0.3-0.7-0.7-0.7C9.4,4.5,9,4.7,8.9,5.1c0,0.1-0.1,0.3-0.1,0.4C8.8,7.1,8.8,8.8,8.8,10.4C8.8,10.4,8.8,10.4,8.8,10.4z"
      />
    </SvgIcon>
  );
};

export const ZoomInIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M11.5,10h4.2v1.5h-4.2v4.2H10v-4.2H5.8V10H10V5.8h1.5V10z M22.1,23.2l-4.8-4.8c-1.8,1.5-4,2.4-6.5,2.4
        c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10c0,2.5-0.9,4.8-2.4,6.5l4.8,4.8L22.1,23.2z M19.3,10.8
        c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5C15.5,19.3,19.3,15.5,19.3,10.8z"
      />
    </SvgIcon>
  );
};

export const ZoomOutIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M5.8,10h10v1.5h-10V10z M22.1,23.2l-4.8-4.8c-1.8,1.5-4,2.4-6.5,2.4c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10
        c5.5,0,10,4.5,10,10c0,2.5-0.9,4.8-2.4,6.5l4.8,4.8L22.1,23.2z M19.3,10.8c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5
        c0,4.7,3.8,8.5,8.5,8.5C15.5,19.3,19.3,15.5,19.3,10.8z"
      />
    </SvgIcon>
  );
};

export const UnMuteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M5,9h5.4V17H5V9z M11.7,9V17l9.3,4V5L11.7,9z" />
    </SvgIcon>
  );
};

export const MuteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21,5v16l-3-1.5L16,16l-4.3-7L21,5z M7.4,3.5C7.1,3,6.5,2.9,6,3.1C5.5,3.4,5.4,4,5.6,4.5L8.2,9H5V17h5.4v-4.2
	l1.3,2.2v2l1.5,0.6l3.4,5.8c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1c0.5-0.3,0.6-0.9,0.4-1.4L7.4,3.5z"
      />
    </SvgIcon>
  );
};

export const FullScreenIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.3,16.9v5.4c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.3,0.4-0.5,0.5c-0.1,0.1-0.3,0.1-0.4,0.1h-5.4c-0.6,0-1-0.4-1-1
        s0.4-1,1-1h3L15,16.4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4.9,4.9v-3c0-0.6,0.4-1,1-1S23.3,16.4,23.3,16.9z M6.4,5h3c0.6,0,1-0.4,1-1
        s-0.4-1-1-1H4C3.9,3,3.7,3,3.6,3.1C3.4,3.2,3.2,3.4,3.1,3.6C3,3.7,3,3.9,3,4v5.4c0,0.6,0.4,1,1,1s1-0.4,1-1v-3l4.9,4.9
        c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L6.4,5z M23.3,3.6c-0.1-0.2-0.3-0.4-0.5-0.5C22.6,3,22.5,3,22.3,3
        h-5.4c-0.6,0-1,0.4-1,1s0.4,1,1,1h3L15,9.9c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l4.9-4.9v3
        c0,0.6,0.4,1,1,1s1-0.4,1-1V4C23.3,3.9,23.3,3.7,23.3,3.6z M9.9,15L5,19.9v-3c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.4c0,0.1,0,0.3,0.1,0.4
        c0.1,0.2,0.3,0.4,0.5,0.5c0.1,0.1,0.3,0.1,0.4,0.1h5.4c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3l4.9-4.9c0.4-0.4,0.4-1,0-1.4S10.3,14.6,9.9,15
        z"
      />
    </SvgIcon>
  );
};

export const FullScreenOffIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.7,22.3c0.4,0.4,0.4,1,0,1.4C23.5,23.9,23.3,24,23,24s-0.5-0.1-0.7-0.3l-4.5-4.5v3c0,0.6-0.4,1-1,1
        s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1h5.4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-3L23.7,22.3z M9.2,15.8H3.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h3
        l-4.5,4.5c-0.4,0.4-0.4,1,0,1.4C2.5,23.9,2.7,24,3,24s0.5-0.1,0.7-0.3l4.5-4.5v3c0,0.6,0.4,1,1,1s1-0.4,1-1v-5.4
        C10.2,16.3,9.7,15.8,9.2,15.8z M9.2,2.8c-0.6,0-1,0.4-1,1v3L3.7,2.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4.5,4.5h-3c-0.6,0-1,0.4-1,1
        s0.4,1,1,1h5.4c0.6,0,1-0.4,1-1V3.8C10.2,3.2,9.7,2.8,9.2,2.8z M16.8,10.2h5.4c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3l4.5-4.5
        c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-4.5,4.5v-3c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.4C15.8,9.7,16.3,10.2,16.8,10.2z"
      />
    </SvgIcon>
  );
};

export const LayerIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.5,16.7v4.2c0,0.3-0.2,0.5-0.5,0.5h-4.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.7v-3.7
        c0-0.3,0.2-0.5,0.5-0.5S21.5,16.4,21.5,16.7z M4.1,8.8c0.3,0,0.5-0.2,0.5-0.5V4.6h3.7c0.3,0,0.5-0.2,0.5-0.5S8.6,3.6,8.3,3.6H4.1
        c-0.3,0-0.5,0.2-0.5,0.5v4.2C3.6,8.5,3.8,8.8,4.1,8.8z M8.3,20.4H4.6v-3.7c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v4.2
        c0,0.3,0.2,0.5,0.5,0.5h4.2c0.3,0,0.5-0.2,0.5-0.5S8.6,20.4,8.3,20.4z M16.7,4.5h3.7v3.7c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V4
        c0-0.3-0.2-0.5-0.5-0.5h-4.2c-0.3,0-0.5,0.2-0.5,0.5S16.5,4.5,16.7,4.5z M16.5,16.9c0,0.7-0.5,1.2-1.2,1.2H9.8
        c-0.7,0-1.2-0.5-1.2-1.2V8.2C8.6,7.5,9.1,7,9.8,7h5.5c0.7,0,1.2,0.5,1.2,1.2V16.9z M9.6,8.2v2.1h0.7V9.5c0-0.7,0.5-1.2,1.2-1.2h2.1
        c0.7,0,1.2,0.5,1.2,1.2v0.7h0.7v-2C15.5,8,15.4,8,15.3,8H9.8C9.7,8,9.6,8,9.6,8.2z M13.8,10.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-2.1
        c-0.1,0-0.2,0.1-0.2,0.2v0.7H13.8z M15.5,16.9v-5.7h-1.2l0,0l0,0h-3.5l0,0l0,0H9.6v5.7c0,0.1,0.1,0.2,0.2,0.2h5.5
        C15.4,17.1,15.5,17.1,15.5,16.9z"
      />
    </SvgIcon>
  );
};

export const NewSettingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M3.21519 15.0594C2.92223 13.6751 2.9341 12.2743 3.21603 10.9407C4.32566 11.0714 5.29419 10.7039 5.6109 9.93934C5.9276 9.17475 5.50259 8.23003 4.62558 7.5378C5.36921 6.39545 6.35137 5.39652 7.53728 4.62491C8.22957 5.50238 9.17456 5.92769 9.93934 5.6109C10.7041 5.29411 11.0715 4.32517 10.9406 3.2152C12.3248 2.92223 13.7256 2.9341 15.0593 3.21602C14.9286 4.32565 15.296 5.29419 16.0606 5.6109C16.8252 5.92761 17.77 5.50259 18.4622 4.62558C19.6045 5.36921 20.6034 6.35136 21.375 7.53727C20.4976 8.22956 20.0723 9.17456 20.3891 9.93934C20.7059 10.7041 21.6749 11.0716 22.7848 10.9406C23.0778 12.3248 23.0659 13.7256 22.784 15.0593C21.6744 14.9286 20.7058 15.2961 20.3891 16.0606C20.0724 16.8252 20.4974 17.77 21.3744 18.4622C20.6308 19.6045 19.6486 20.6034 18.4627 21.3751C17.7705 20.4977 16.8254 20.0723 16.0606 20.3891C15.2958 20.7059 14.9284 21.6749 15.0594 22.7848C13.6752 23.0778 12.2743 23.0659 10.9407 22.784C11.0714 21.6744 10.7039 20.7058 9.93934 20.3891C9.17475 20.0724 8.23004 20.4974 7.5378 21.3744C6.39545 20.6308 5.39653 19.6487 4.62491 18.4627C5.50238 17.7705 5.92768 16.8254 5.6109 16.0606C5.29411 15.2959 4.32517 14.9284 3.21519 15.0594ZM5.00216 13.2102C6.10168 13.5145 7.00905 14.2112 7.45818 15.2955C7.90729 16.3797 7.75835 17.514 7.19605 18.5067C7.29258 18.6084 7.39176 18.7075 7.49348 18.8039C8.4861 18.2417 9.62032 18.0928 10.7045 18.5419C11.7887 18.991 12.4854 19.8982 12.7898 20.9976C12.9299 21.0014 13.07 21.0015 13.2102 20.9978C13.5145 19.8983 14.2112 18.991 15.2955 18.5419C16.3798 18.0927 17.5141 18.2417 18.5067 18.804C18.6084 18.7074 18.7074 18.6083 18.8038 18.5065C18.2417 17.5139 18.0927 16.3796 18.5418 15.2955C18.9909 14.2113 19.8982 13.5146 20.9976 13.2103C21.0014 13.0702 21.0015 12.9299 20.9978 12.7898C19.8983 12.4856 18.991 11.7887 18.5418 10.7045C18.0927 9.62024 18.2417 8.48595 18.8039 7.49331C18.7074 7.3916 18.6083 7.29252 18.5065 7.19613C17.514 7.75837 16.3797 7.90726 15.2955 7.45818C14.2113 7.00909 13.5146 6.10179 13.2103 5.00236C13.0702 4.99858 12.93 4.99851 12.7898 5.00216C12.4855 6.10168 11.7888 7.00906 10.7045 7.45818C9.62024 7.90729 8.48595 7.75835 7.4933 7.19604C7.39159 7.29258 7.29252 7.39176 7.19614 7.49349C7.75837 8.4861 7.90726 9.62032 7.45818 10.7045C7.00909 11.7886 6.10179 12.4855 5.00235 12.7898C4.99858 12.9298 4.99851 13.07 5.00216 13.2102ZM13 15.9992C11.3436 15.9992 10.0008 14.6564 10.0008 13C10.0008 11.3436 11.3436 10.0008 13 10.0008C14.6564 10.0008 15.9993 11.3436 15.9993 13C15.9993 14.6564 14.6564 15.9992 13 15.9992ZM13 13.9998C13.5521 13.9998 13.9998 13.5522 13.9998 13C13.9998 12.4479 13.5521 12.0003 13 12.0003C12.4479 12.0003 12.0003 12.4479 12.0003 13C12.0003 13.5522 12.4479 13.9998 13 13.9998Z" />
    </SvgIcon>
  );
};

export const PatientIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.7,19.6c-2,0-3.7-1.7-3.7-3.7c0-1.4,0.8-2.6,1.9-3.3c-0.8-0.4-1.6-0.6-2.5-0.6c-3.3,0-6.1,3-6.1,6.8h-1
        c0-3.5,2.1-6.5,5-7.5c-0.9-0.7-1.5-1.8-1.5-3c0-2,1.6-3.7,3.6-3.7c2,0,3.6,1.6,3.6,3.7c0,1.3-0.6,2.4-1.6,3c0.5,0.2,1,0.4,1.4,0.7
        l-0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.1c2,0,3.7,1.7,3.7,3.7S17.8,19.6,15.7,19.6z M15.7,13.1c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7
        s2.7-1.2,2.7-2.7S17.2,13.1,15.7,13.1z M11.5,5.6c-1.4,0-2.6,1.2-2.6,2.7c0,1.5,1.2,2.7,2.6,2.7h0c1.4,0,2.6-1.2,2.6-2.7
        C14.2,6.8,13,5.6,11.5,5.6z M15.8,16.6L15.8,16.6c-0.4,0-0.8-0.4-0.8-0.8c0-0.1,0-0.3,0.1-0.4l-0.3-0.8l0.9-0.4L16,15
        c0.1,0,0.2,0.1,0.3,0.2c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6S16,16.6,15.8,16.6L15.8,16.6z M15.7,15.6
        c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2L15.7,15.6z M15.7,15.6V16c0.1,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1
        C16,15.7,15.9,15.6,15.7,15.6z"
      />
    </SvgIcon>
  );
};

export const MouseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,14.4c0,0,0.1-0.1,0.3-0.2l5.2-0.2L5.6,3.3v15.9l3.6-3.5c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.2,0.2
        l2.3,5.4l2.5-1.1L12,14.7C12,14.5,12,14.4,12,14.4z M12.4,20.1l-2-4.6c-0.1-0.4-0.5-0.6-0.8-0.7c-0.1,0-0.2,0-0.2,0
        c-0.3,0-0.6,0.1-0.8,0.3l-2.1,2.1v-12l8.9,8.1l-3.1,0.1c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.2,0.7-0.1,1.1l2.1,4.7L12.4,20.1z"
      />
    </SvgIcon>
  );
};

export const BsLinkIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.5,10.1L16,14.6c-0.8,0.8-1.8,1.1-2.8,1.1s-2-0.4-2.8-1.1l-0.8-0.8l1.4-1.4l0.8,0.8c0.7,0.7,2,0.7,2.7,0L19,8.7
	c0.7-0.7,0.7-2,0-2.7l-0.8-0.8c-0.7-0.7-2-0.7-2.7,0l-2.9,2.9l-1.4-1.5l2.9-2.9c1.5-1.5,4-1.5,5.5,0l0.9,0.9
	C22,6.1,22,8.6,20.5,10.1z M8.3,19.5c-0.7,0.7-2,0.7-2.7,0l-0.8-0.9c-0.8-0.7-0.8-2,0-2.7l4.5-4.5c0.7-0.7,2-0.7,2.7,0l0.8,0.8
	l1.4-1.4L13.4,10c-1.5-1.5-4-1.5-5.5,0l-4.6,4.6c-1.5,1.5-1.5,4,0,5.5l0.9,0.8C5,21.7,6,22,7,22s2-0.4,2.8-1.1l2.9-2.9l-1.5-1.4
	L8.3,19.5z"
      />
    </SvgIcon>
  );
};

export const BsGenderIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M19.4,24c4.5-5,4.8-13.4,0.7-18.9C16-0.3,9-0.7,4.5,4.2s-4.8,13.4-0.7,18.9C4,23.4,4.2,23.7,4.5,24H19.4z" />
    </SvgIcon>
  );
};

export const AdmissionIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M13.4,21.6H3.2c-1.5,0-2.6-1.2-2.6-2.6V6.7c0-1.5,1.2-2.6,2.6-2.6h1.1V3.9c0-0.8,0.6-1.4,1.4-1.4h5.2
        c0.8,0,1.4,0.6,1.4,1.4v0.2h1.1c1.5,0,2.6,1.2,2.6,2.6v3c0,0.4-0.3,0.6-0.7,0.6s-0.7-0.3-0.7-0.6v-3c0-0.7-0.6-1.3-1.3-1.3h-1.1v0.2
        c0,0.8-0.6,1.4-1.4,1.4H5.6C4.9,7,4.3,6.4,4.3,5.6V5.4H3.2C2.5,5.4,1.9,6,1.9,6.7V19c0,0.7,0.6,1.3,1.3,1.3h10.2
        c0.7,0,1.3-0.6,1.3-1.3v-1.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7V19C16,20.4,14.8,21.6,13.4,21.6z M5.6,3.8L5.6,5.6l5.3,0.1
        l0.1-1.8l-0.1-0.1H5.6z M18.7,18.3c-0.2,0-0.3-0.1-0.5-0.2l-3.8-3.9c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0.1-0.5,0.3-0.6l3.8-3.8
        c0.3-0.3,0.7-0.3,0.9,0s0.3,0.7,0,0.9L16.2,13h6.4c0.4,0,0.7,0.3,0.7,0.6s-0.3,0.7-0.7,0.7h-6.3l2.9,2.9c0.3,0.3,0.3,0.7,0,0.9
        C19,18.2,18.8,18.3,18.7,18.3z M11.8,17.3h-7c-0.4,0-0.6-0.3-0.6-0.7S4.5,16,4.8,16h7c0.4,0,0.7,0.3,0.7,0.7S12.2,17.3,11.8,17.3z
         M10.5,14.1H4.8c-0.4,0-0.6-0.3-0.6-0.7c0-0.4,0.3-0.6,0.6-0.6h5.7c0.4,0,0.6,0.3,0.6,0.6C11.2,13.8,10.9,14.1,10.5,14.1z
         M11.8,10.9h-7c-0.4,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h7c0.4,0,0.7,0.3,0.7,0.6S12.2,10.9,11.8,10.9z"
      />
    </SvgIcon>
  );
};

export const DecisionIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M22.3,8.9l-2-1.7c-0.3-0.2-0.7-0.2-1,0.1c-0.2,0.3-0.2,0.7,0.1,1l0.7,0.6c-4,0.6-6.3,2.6-7.6,4.8l0-9.9l0.7,0.7
        c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-1l-1.9-1.9c-0.3-0.3-0.7-0.3-1,0L9.4,3.6c-0.3,0.3-0.3,0.7,0,1
        c0.3,0.3,0.7,0.3,1,0l0.7-0.7l0,9.9C9.8,11.6,7.5,9.6,3.7,9l0.8-0.6c0.3-0.2,0.3-0.7,0.1-1C4.3,7,3.8,7,3.5,7.2l-2,1.7c0,0,0,0,0,0
        C1.4,9,1.4,9,1.3,9.1c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.2c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1
        c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1l1.7,2c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0.1-1l-0.6-0.7
        c5.2,1,7,4.8,7.4,7.3c-1.1,0.3-1.9,1.3-1.9,2.4c0,1.4,1.2,2.5,2.6,2.5s2.6-1.1,2.6-2.5c0-1.1-0.7-2-1.7-2.4c0.3-2.5,2.2-6.5,7.7-7.4
        L19.6,11c-0.2,0.3-0.2,0.7,0.1,1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l1.7-2c0.1-0.1,0.2-0.3,0.2-0.5S22.4,9.1,22.3,8.9z
         M11.7,21.2c-0.6,0-1.2-0.5-1.2-1.1S11,19,11.7,19s1.2,0.5,1.2,1.1S12.3,21.2,11.7,21.2z"
      />
    </SvgIcon>
  );
};

export const AdmissionTickIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M4.1,16.9c0.2,0.3,0.1,0.8-0.2,1c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.5-0.1-0.6-0.3c-0.3-0.4-0.6-0.9-0.8-1.4
        c-0.2-0.4,0-0.8,0.4-1c0.4-0.2,0.8,0,1,0.4C3.7,16.2,3.9,16.6,4.1,16.9z M2.7,12.6c0-0.2,0-0.5,0-0.7c0-0.2,0-0.4,0-0.6
        c0-0.4-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.7c0,0.2,0,0.5,0,0.8c0,0.3,0,0.6,0,0.9c0,0.4,0.4,0.7,0.7,0.7c0,0,0,0,0.1,0
        C2.4,13.4,2.7,13,2.7,12.6z M2.4,8.5c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.6-0.2,0.7-0.4c0.2-0.4,0.4-0.8,0.7-1.2c0.2-0.3,0.1-0.8-0.2-1
        c-0.3-0.2-0.8-0.1-1,0.2C2.5,6.5,2.3,7,2.1,7.5C1.9,7.9,2.1,8.3,2.4,8.5z M7.5,20c-0.4-0.2-0.8-0.5-1.2-0.7c-0.3-0.2-0.8-0.2-1,0.2
        c-0.2,0.3-0.2,0.8,0.2,1c0.4,0.3,0.9,0.6,1.4,0.9c0.1,0.1,0.2,0.1,0.4,0.1c0.3,0,0.5-0.1,0.7-0.4C8,20.7,7.9,20.2,7.5,20z M5.8,4.7
        c0.2,0,0.3-0.1,0.5-0.2C6.6,4.2,7,4,7.4,3.8c0.4-0.2,0.5-0.7,0.3-1c-0.2-0.4-0.7-0.5-1-0.3C6.2,2.7,5.8,3,5.4,3.3C5,3.6,5,4,5.2,4.4
        C5.4,4.6,5.6,4.7,5.8,4.7z M19.5,4.3c-2-2-4.7-3.1-7.6-3.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.5,0-1.1,0-1.6,0.1C9.9,1.3,9.6,1.7,9.6,2.1
        c0.1,0.4,0.4,0.6,0.7,0.6c0,0,0.1,0,0.1,0c0.5-0.1,0.9-0.1,1.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0c2.5,0,4.8,1,6.5,2.7s2.7,4.1,2.7,6.5
        s-1,4.8-2.7,6.5s-4.1,2.7-6.5,2.7c0,0,0,0,0,0c0,0,0,0,0,0c-0.4,0-0.9,0-1.3-0.1c-0.4-0.1-0.8,0.2-0.8,0.6c-0.1,0.4,0.2,0.8,0.6,0.8
        c0.5,0.1,1,0.1,1.5,0.1c0,0,0,0,0,0c0,0,0,0,0,0c2.9,0,5.6-1.1,7.6-3.1s3.1-4.7,3.1-7.6S21.5,6.3,19.5,4.3z M10.8,16.5l7.1-7.1
        c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1.1,0l-6.5,6.5l-3-3c-0.3-0.3-0.8-0.3-1.1,0c-0.3,0.3-0.3,0.8,0,1.1l3.5,3.5
        c0.1,0.1,0.3,0.2,0.5,0.2S10.7,16.6,10.8,16.5z"
      />
    </SvgIcon>
  );
};

export const TriangleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M10.2,3.8c0.8-1.3,2.7-1.3,3.5,0l8.5,14.8c0.8,1.3-0.2,3-1.7,3H3.3c-1.5,0-2.5-1.7-1.7-3
	L10.2,3.8z"
      />
    </SvgIcon>
  );
};

export const HandIcon2 = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.2,7.2c-0.1,0-0.3,0-0.4,0V6.9c0-1-0.9-1.9-1.9-1.9c-0.1,0-0.3,0-0.4,0c-0.2-0.9-0.9-1.5-1.9-1.5
        c-0.7,0-1.3,0.3-1.6,0.9c-0.2-0.1-0.4-0.1-0.7-0.1c-1,0-1.9,0.8-1.9,1.9v6.6l-0.1,0.1l-0.5-0.6c-0.7-0.7-1.9-0.7-2.7,0
        C4.5,12.9,4.4,14,5,14.7l3,4c0,0,0.1,0.1,0.1,0.1c1.2,1.2,2.8,1.8,4.6,1.8c3.6,0,6.5-2.8,6.5-6.3V9.1C19.1,8.1,18.3,7.2,17.2,7.2z
         M17.6,14.3c0,2.7-2.2,4.8-5,4.8c-1.3,0-2.6-0.5-3.5-1.4l-3-4c-0.1-0.1-0.1-0.3,0-0.5c0.2-0.1,0.4-0.2,0.5,0l0.5,0.6
        c0.5,0.4,1.1,0.6,1.7,0.3c0.6-0.2,1-0.8,1-1.4V6.1c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v5.2c0,0.4,0.3,0.8,0.8,0.8
        s0.8-0.3,0.8-0.8V5.4c0-0.2,0.2-0.4,0.4-0.4S13,5.2,13,5.4v5.9c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V6.9c0-0.2,0.2-0.4,0.4-0.4
        c0.2,0,0.4,0.2,0.4,0.4v5.2c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-3c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V14.3z"
      />
    </SvgIcon>
  );
};

export const Covid19 = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.6,11.3c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7S12.6,12.8,12.6,11.3z M9.9,13.1
        c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8C11.7,12.3,10.9,13.1,9.9,13.1z M14.8,10.5c-0.7,0-1.3,0.6-1.3,1.3
        s0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3S15.5,10.5,14.8,10.5z M14.8,12.2L14.8,12.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4
        c0.2,0,0.4,0.2,0.4,0.4C15.2,12,15.1,12.2,14.8,12.2z M12.4,14.1c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8
        S13.4,14.1,12.4,14.1z M12.4,16.8c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9S12.9,16.8,12.4,16.8z M21.4,10.4
        c-0.2,0-0.5,0.2-0.5,0.4v0.8h-1.5c-0.1-1.7-0.8-3.3-1.9-4.6L18.7,6l0.5,0.5c0.2,0.2,0.5,0.2,0.6,0s0.2-0.5,0-0.6c0,0,0,0,0,0L19,5
        l-0.9-0.9c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L18,5.3l-1.1,1.1c-1.3-1.1-2.9-1.8-4.6-1.9V3h0.8c0.2,0,0.5-0.2,0.5-0.5
        s-0.2-0.5-0.5-0.5h-2.4c-0.2,0-0.5,0.2-0.5,0.5S10.4,3,10.7,3h0.8v1.5C9.8,4.6,8.1,5.3,6.9,6.4L5.8,5.3l0.5-0.5
        c0.2-0.2,0.2-0.5,0-0.6C6.2,4,5.9,4,5.7,4.1c0,0,0,0,0,0L4.8,5L4,5.9C3.8,6,3.8,6.3,4,6.5s0.5,0.2,0.6,0L5.2,6l1.1,1.1
        c-1.1,1.3-1.8,2.9-1.9,4.6H2.8v-0.8c0-0.2-0.2-0.4-0.4-0.4s-0.5,0.2-0.5,0.4v2.4c0,0.2,0.2,0.5,0.5,0.5c0.3,0,0.4-0.2,0.4-0.5v-0.8
        h1.5c0.1,1.7,0.8,3.3,1.9,4.6l-1.1,1.1l-0.5-0.5c-0.2-0.2-0.5-0.2-0.6,0c-0.2,0.2-0.2,0.5,0,0.6l0.9,0.9L5.7,20
        c0.2,0.2,0.5,0.1,0.6,0c0.2-0.2,0.2-0.4,0-0.6l-0.5-0.5l1.1-1.1c1.3,1.1,2.9,1.8,4.6,1.9v1.5h-0.8c-0.2,0-0.5,0.2-0.5,0.5
        s0.2,0.5,0.5,0.5h2.4c0.2,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-0.8v-1.5c1.7-0.1,3.3-0.8,4.6-1.9l1.1,1.1l-0.5,0.5
        c-0.2,0.2-0.2,0.5,0,0.6c0.2,0.2,0.5,0.2,0.6,0c0,0,0,0,0,0l0.9-0.9l0.9-0.9c0.2-0.2,0.2-0.5,0-0.6c-0.2-0.2-0.5-0.2-0.6,0l-0.5,0.5
        l-1.1-1.1c1.1-1.3,1.8-2.9,1.9-4.6H21v0.8c0,0.2,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-2.4C21.9,10.6,21.7,10.4,21.4,10.4z M11.9,18.7
        c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7s6.7,3,6.7,6.7S15.6,18.7,11.9,18.7z"
      />
    </SvgIcon>
  );
};

export const Reset2 = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.9,13.1c-0.3,0.4-0.9,0.4-1.3,0.1c-0.4,3.3-2.7,6.2-6.1,7.1c-0.8,0.2-1.5,0.3-2.3,0.3c-1.4,0-2.7-0.3-3.9-1
c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4c1.4,0.8,3.1,1,4.7,0.5c2.7-0.7,4.5-3,4.7-5.6l-0.4,0.4c-0.2,0.2-0.5,0.3-0.7,0.3
c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l1.8-1.8c0.1-0.1,0.3-0.2,0.4-0.2c0,0,0.1,0,0.1-0.1c0.5-0.1,0.9,0.1,1.1,0.6l1.5,1.4
C21.2,12,21.3,12.7,20.9,13.1z M8,10.9c-0.4-0.4-1-0.4-1.4,0l-0.4,0.4c0.2-2.5,2-4.8,4.7-5.6c1.6-0.5,3.3-0.3,4.7,0.5
c0.5,0.3,1.1,0.1,1.4-0.4c0.3-0.5,0.1-1.1-0.4-1.4c-1.9-1-4.1-1.3-6.2-0.7c-3.4,1-5.8,3.9-6.1,7.1c-0.4-0.3-1-0.3-1.3,0.1
c-0.4,0.4-0.4,1,0,1.4l1.5,1.4c0.2,0.4,0.5,0.6,0.9,0.6c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1-0.1c0.2,0,0.3-0.1,0.4-0.2L8,12.3
C8.4,12,8.4,11.3,8,10.9z"
      />
    </SvgIcon>
  );
};

export const CircleCloseIcon2 = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.2,14.1c0.4,0.4,0.4,0.9,0,1.3c-0.2,0.2-0.4,0.3-0.6,0.3s-0.5-0.1-0.6-0.3l-2.2-2.2l-2.2,2.2
        c-0.2,0.2-0.4,0.3-0.6,0.3s-0.5-0.1-0.6-0.3c-0.4-0.4-0.4-0.9,0-1.3l2.2-2.2L8.2,9.7c-0.4-0.4-0.4-0.9,0-1.3c0.4-0.4,0.9-0.4,1.3,0
        l2.2,2.2l2.2-2.2c0.4-0.4,0.9-0.4,1.3,0s0.4,0.9,0,1.3L13,11.9L15.2,14.1z M22.9,12.1c0,6.1-4.9,11-11,11s-11-4.9-11-11
        s4.9-11,11-11S22.9,6,22.9,12.1z M21.1,12.1c0-5.1-4.1-9.2-9.2-9.2c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2
        C17,21.3,21.1,17.1,21.1,12.1z"
      />
    </SvgIcon>
  );
};

export const RefreshIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M23.2,12.1c0,5.5-4.5,10-10,10c-1.8,0-3.5-0.5-5-1.3c-0.5-0.3-0.6-0.9-0.4-1.4c0.3-0.5,0.9-0.6,1.4-0.4
c1.2,0.7,2.6,1.1,4,1.1c4.4,0,8-3.6,8-8s-3.6-8-8-8c-3.9,0-7.1,2.8-7.8,6.4l0.8-0.9c0.4-0.4,1-0.5,1.4-0.1c0.4,0.4,0.5,1,0.1,1.4
l-1.4,1.5c-0.5,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.6-0.3-2.1-0.9l-1.4-1.5c-0.4-0.4-0.3-1,0.1-1.4c0.4-0.4,1-0.3,1.4,0.1l1,1.2
C4,5.9,8.2,2.1,13.2,2.1C18.7,2.1,23.2,6.6,23.2,12.1z M13.2,6.6c-0.6,0-1,0.4-1,1v4.5c0,0.4,0.3,0.8,0.7,0.9l2.7,0.9
c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5-0.1-1.1-0.6-1.3l-2-0.7V7.6C14.2,7,13.8,6.6,13.2,6.6z"
      />
    </SvgIcon>
  );
};

export const EqualIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M3.9,8.1h16c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-16c-0.6,0-1-0.4-1-1l0,0
C2.9,8.5,3.3,8.1,3.9,8.1z M3.9,14.1h16c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-16c-0.6,0-1-0.4-1-1l0,0C2.9,14.5,3.3,14.1,3.9,14.1z
"
      />
    </SvgIcon>
  );
};

export const XmaleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M10.6,11.9L6.8,5.1h2l2.8,5.3l2.8-5.3h2l-3.8,6.8l4,7.2h-2l-3-5.6l-3,5.6h-2L10.6,11.9z" />
    </SvgIcon>
  );
};

export const InProgressIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.3,12.1c0,4.6-3.7,8.4-8.3,8.4c-4.4,0-8-3.4-8.3-7.7l-1,1C3.5,13.9,3.2,14,2.9,14s-0.5-0.1-0.7-0.3
	c-0.4-0.4-0.4-1,0-1.4l3-3C5.4,9.1,5.7,9,5.9,9c0,0,0,0,0,0c0.3,0,0.5,0.1,0.7,0.3l3,3c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0l-1.6-1.6
	c0,3.5,2.9,6.3,6.3,6.3c3.5,0,6.3-2.8,6.3-6.4c0-0.6,0.4-1,1-1S21.3,11.5,21.3,12.1z M18.9,9.8c0.1,0.4,0.5,0.7,0.9,0.7
	c0.1,0,0.2,0,0.3-0.1c0.5-0.2,0.8-0.8,0.6-1.3c-0.3-0.9-0.9-1.8-1.5-2.5c-0.4-0.4-1-0.5-1.4-0.1c-0.4,0.4-0.5,1-0.1,1.4
	C18.3,8.5,18.7,9.1,18.9,9.8z M13,5.7c1,0,2,0.2,2.9,0.7c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.2,0.9-0.5c0.3-0.5,0.1-1.1-0.4-1.4
	C15.6,4,14.3,3.7,13,3.7c-0.6,0-1,0.4-1,1S12.4,5.7,13,5.7z M7.8,7.9c0.3,0,0.5-0.1,0.7-0.3c0.6-0.6,1.3-1.1,2-1.4
	C11,6,11.2,5.4,11,4.9s-0.8-0.7-1.3-0.5c-1,0.4-1.9,1-2.7,1.8c-0.4,0.4-0.4,1,0,1.4C7.2,7.8,7.5,7.9,7.8,7.9z"
      />
    </SvgIcon>
  );
};

export const HoldIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0c6.6,0,12,5.4,12,12S18.6,24,12,24z M12,2.6c-5.2,0-9.4,4.2-9.4,9.4
c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4C21.4,6.8,17.2,2.6,12,2.6z M16.1,16.1V7.9c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3v8.1
c0,0.7,0.6,1.3,1.3,1.3S16.1,16.8,16.1,16.1z M10.4,16.1V7.9c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v8.1
c0,0.7,0.6,1.3,1.3,1.3C9.9,17.4,10.4,16.8,10.4,16.1z"
      />
    </SvgIcon>
  );
};

export const WithdrawIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.6,5.1h-12c-0.6,0-1,0.4-1,1v15c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1v-15C18.6,5.6,18.2,5.1,17.6,5.1z
M16.6,20.1h-10v-13h10V20.1z M21.7,5v4.8c0,0.6-0.4,1-1,1s-1-0.4-1-1V5c0-0.6-0.4-1-1-1H4.5c-0.6,0-1,0.4-1,1v4.8c0,0.6-0.4,1-1,1
s-1-0.4-1-1V5c0-1.7,1.3-3,3-3h14.2C20.4,2,21.7,3.4,21.7,5z M8.3,15.2c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l0.9,1V9.6
c0-0.6,0.4-1,1-1s1,0.4,1,1v5.2l0.9-1c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-2.7,2.7c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3
L8.3,15.2z"
      />
    </SvgIcon>
  );
};

export const EyeHideIcon2 = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.1,15.5c0.7,0.4,1.4,0.7,2.3,0.7c0.8,0,1.6-0.1,2.3-0.5c0.7-0.4,1.3-0.9,1.7-1.5
c0.4-0.6,0.6-1.4,0.6-2.1c0-0.8-0.3-1.6-0.8-2.3l-1.2,1.1c0.2,0.4,0.3,0.8,0.3,1.3c0,0.4-0.2,0.9-0.4,1.2c-0.2,0.4-0.6,0.7-1,0.9
c-0.4,0.2-0.9,0.3-1.4,0.3c-0.4,0-0.9-0.1-1.3-0.3L9.1,15.5z M18.9,6.3c1.7,1.5,3.1,3.4,4,5.4c0,0.1,0.1,0.2,0.1,0.3
c0,0.1,0,0.2-0.1,0.3c-2.4,5.2-6.6,8.2-11.3,8.2h0c-2.2,0-4.3-0.7-6-1.8l-2.2,2c-0.1,0.1-0.2,0.1-0.3,0.2C3.1,21,3,21,2.9,21
c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0-0.4,0.1-0.5l0,0L18.6,4.4c0,0,0,0,0.1-0.1
c0,0,0,0,0.1-0.1l1-1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5L18.9,6.3z
 M7.2,12.1c0,0.3,0,0.5,0.1,0.8l-4.1,3.8C2,15.4,1,13.9,0.3,12.4c0-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3c2.4-5.2,6.6-8.2,11.3-8.2h0
c1.6,0,3.1,0.4,4.5,1L12.5,8c-0.3,0-0.6-0.1-0.8-0.1C11,7.9,10.5,8,9.9,8.2c-0.5,0.2-1,0.5-1.4,0.9c-0.4,0.4-0.7,0.8-1,1.3
C7.3,11,7.2,11.5,7.2,12.1z"
      />
    </SvgIcon>
  );
};
export const EyeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.1,12.1c0,0.7,0.2,1.3,0.6,1.9c0.4,0.6,0.9,1,1.6,1.3c0.6,0.3,1.3,0.3,2,0.2
c0.7-0.1,1.3-0.5,1.8-0.9c0.5-0.5,0.8-1.1,1-1.7s0.1-1.3-0.2-2c-0.3-0.6-0.7-1.2-1.3-1.5c-0.6-0.4-1.3-0.6-1.9-0.6
c-0.5,0-0.9,0.1-1.3,0.3C9.9,9.1,9.5,9.3,9.2,9.7c-0.3,0.3-0.6,0.7-0.8,1.1C8.2,11.2,8.1,11.6,8.1,12.1z M16.8,6.8
c1.7,1.3,3,3,3.8,5c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3c-1.9,4.2-5.2,6.8-8.9,6.8h0c-3.7,0-7.1-2.5-8.9-6.8c0-0.1-0.1-0.2-0.1-0.3
s0-0.2,0.1-0.3c1.9-4.2,5.2-6.7,8.9-6.7h0C13.5,5.1,15.3,5.7,16.8,6.8z M11.6,14.2c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.5-0.3,0.7-0.5
c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.5,0.2-0.8s-0.1-0.6-0.2-0.8c-0.1-0.3-0.3-0.5-0.5-0.7c-0.2-0.2-0.5-0.4-0.7-0.5
c-0.3-0.1-0.6-0.1-0.9-0.1c-0.1,0-0.2,0-0.3,0c0,0.5-0.2,0.9-0.6,1.2c-0.3,0.3-0.8,0.5-1.2,0.5h0c0,0.1,0,0.3,0,0.4
c0,0.6,0.2,1.1,0.6,1.5C10.5,13.9,11.1,14.2,11.6,14.2z"
      />
    </SvgIcon>
  );
};
export const UploadIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.3,10.7c-0.4-0.4-0.4-1,0-1.4l5-5C11.5,4.1,11.8,4,12,4c0,0,0,0,0,0c0.3,0,0.5,0.1,0.7,0.3l5,5
        c0.4,0.4,0.4,1,0,1.4C17.5,10.9,17.3,11,17,11c-0.3,0-0.5-0.1-0.7-0.3L13,7.4V16c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1V7.4l-3.3,3.3
        C7.3,11.1,6.7,11.1,6.3,10.7z M18,16c-0.6,0-1,0.4-1,1v2H7v-2c0-0.6-0.4-1-1-1s-1,0.4-1,1v3c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1v-3
        C19,16.4,18.6,16,18,16z"
      />
    </SvgIcon>
  );
};
export const HourglassIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M19.5,21.2L19.5,21.2c-0.1-1.5-0.9-5.4-3.8-8.3l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.2-0.6
        s0.1-0.5,0.2-0.6c0,0,0,0,0.1-0.1l0.1-0.1c0,0,0.1,0,0.1-0.1c3.1-3.1,3.8-7.4,3.9-8.6c0.4,0,0.7-0.4,0.7-0.8c0-0.5-0.4-0.8-0.7-0.8
        h-7c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0H3.7C3.4,1.1,3,1.4,3,1.9c0,0.4,0.3,0.7,0.7,0.8c0.1,1.2,0.7,5.5,3.9,8.6
        c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.2C7.8,11.6,8,11.8,8,12.1c0,0.2-0.1,0.5-0.1,0.6c0,0-0.1,0.1-0.1,0.2
        c-0.1,0-0.1,0.1-0.1,0.1c-2.9,2.8-3.6,6.8-3.8,8.3c-0.4,0-0.7,0.4-0.7,0.8c0,0.4,0.4,0.8,0.7,0.8h1c1,0.2,3,0.3,6.8,0.3
        s5.8-0.1,6.8-0.3h1c0.4,0,0.7-0.4,0.7-0.8C20.2,21.5,19.9,21.2,19.5,21.2z M5.2,21.2c0.2-1.4,0.9-4.7,3.3-7.1l0,0
        c0.1-0.1,0.2-0.2,0.4-0.3c0.4-0.5,0.7-1,0.7-1.7c0-0.6-0.3-1.2-0.7-1.7c0,0-0.1-0.2-0.3-0.2C6,7.8,5.3,4.4,5.1,3
        c0.7-0.1,2.3-0.2,5.6-0.2h1.7c3.4,0,5,0.2,5.6,0.2c-0.2,1.4-0.9,4.7-3.3,7.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.4,0.5-0.7,1.1-0.7,1.7
        c0,0.7,0.2,1.3,0.7,1.7c0.1,0.1,0.2,0.2,0.3,0.2c2.4,2.4,3.1,5.7,3.3,7.1H5.2z M9,8C7.6,6.7,7.2,5.4,7,4.7C6.9,4.4,7.2,4.3,7.3,4.3
        c1.6,0.4,4.3,0.3,4.3,0.3s2.7,0.1,4.3-0.3c0.1-0.1,0.4,0.2,0.3,0.3c-0.1,0.7-0.6,2-2,3.3c-1.9,1.7-1.8,2.8-1.8,2.8s-0.1,0.6-0.7,0.6
        S11,10.8,11,10.8S11,9.6,9,8z M15.7,19.4c0.1,0.3-0.1,0.6-0.4,0.6H7.9c-0.3,0-0.5-0.3-0.4-0.6c0.4-1.4,1.7-4.6,4.2-4.6
        C14.1,14.8,15.4,18,15.7,19.4z M11.6,13.1c-0.4,0-0.6-0.3-0.6-0.6c0-0.4,0.3-0.7,0.6-0.7c0.4,0,0.7,0.3,0.7,0.7
        C12.3,12.8,12,13.1,11.6,13.1z M11.6,13.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.1,0.5-0.4,0.5c-0.2,0-0.4-0.2-0.4-0.5
        C11.2,13.6,11.4,13.4,11.6,13.4z"
      />
    </SvgIcon>
  );
};
export const InfoIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.3,17.3H8c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h7.3c0.6,0,1,0.4,1,1C16.3,16.9,15.8,17.3,15.3,17.3z M16.3,12.1
        c0-0.6-0.4-1-1-1H8c-0.6,0-1,0.4-1,1s0.4,1,1,1h7.3C15.8,13.1,16.3,12.6,16.3,12.1z M11.8,8c0-0.6-0.4-1-1-1H8C7.4,7,7,7.4,7,8
        c0,0.6,0.4,1,1,1h2.8C11.3,9,11.8,8.5,11.8,8z M21,16.7V7.5c0-3.3-2.2-5.6-5.5-5.6H7.8c-3.3,0-5.5,2.2-5.5,5.6v9.2
        c0,3.4,2.2,5.6,5.5,5.6h7.7C18.8,22.3,21,20.1,21,16.7z M15.5,3.9c2.2,0,3.5,1.4,3.5,3.6v9.2c0,2.3-1.3,3.6-3.5,3.6H7.8
        c-2.2,0-3.5-1.3-3.5-3.6V7.5c0-2.3,1.3-3.6,3.5-3.6H15.5z"
      />
    </SvgIcon>
  );
};

export const PatientSurveyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.8,6h-12C9.4,6,9,6.4,9,6.8V10C8.5,9.8,8.1,9.8,8.1,9.8c-0.2,0-0.5,0.1-0.6,0.2c-0.2,0.2-0.3,0.4-0.3,0.6
c0,0.4-0.1,1.6-0.6,2.1C6.1,13.2,5.4,13.7,5,14c-0.3-0.2-0.6-0.4-1-0.4H2.2c-0.9,0-1.6,0.7-1.6,1.6v5c0,0.9,0.7,1.6,1.6,1.6h1.7
c0.4,0,0.8-0.2,1.1-0.4c0.3,0.1,0.7,0.3,1.2,0.4c0.5,0.1,1.2,0.2,2.2,0.2c0.4,0,0.9,0,1.4,0c1.5,0,2.8-1.1,3.2-2.6l0.7-2.6
c0.2-0.7,0-1.4-0.4-1.9c-0.4-0.5-1-0.9-1.7-0.9h-0.9c0.1-0.4,0.1-0.8,0.2-1.4c0.1-0.5,0-1-0.2-1.4V7.7H21V16l-2.3-1.5
c-0.1-0.1-0.3-0.1-0.5-0.1h-2.4c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h2.1l3.4,2.2c0.1,0.1,0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4-0.1
c0.3-0.1,0.4-0.4,0.4-0.7V6.8C22.7,6.4,22.3,6,21.8,6z M3.8,20.3H2.3v-4.9h1.6V20.3z M11.6,15.8c0.2,0,0.3,0.1,0.4,0.2
c0.1,0.1,0.1,0.2,0.1,0.4L11.4,19c-0.2,0.7-0.9,1.3-1.6,1.3c-2.1,0.1-2.9,0-3.2-0.1c-0.5-0.1-0.8-0.2-1-0.3v-4.3
c0.6-0.4,1.5-1,2.2-1.6c0.7-0.6,0.9-1.6,1-2.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.1,0.6c-0.2,1.7-0.3,2.2-0.3,2.2
c-0.1,0.3,0,0.5,0.1,0.7c0.2,0.2,0.4,0.3,0.7,0.3H11.6z M2.1,8.6C1.1,7.1,0.7,5.4,1.2,4C1.6,2.8,2.6,1.9,4,1.4
c1.7-0.6,3,0.2,3.8,0.8c0.7-0.6,2.1-1.4,3.8-0.8c1.6,0.6,2.7,1.7,3,3.2c0.1,0.5-0.2,0.9-0.7,1c0,0-0.1,0-0.1,0
c-0.4,0-0.8-0.3-0.8-0.7C12.7,4,12.1,3.3,11,3C9.6,2.5,8.5,3.8,8.5,3.9c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0
c0,0-0.1,0-0.1,0.1C8,4.2,8,4.2,7.9,4.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0,0
c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1C7.1,3.8,6,2.5,4.6,3C3.7,3.3,3,3.9,2.8,4.6c-0.3,0.9-0.1,2,0.7,3.1C4,8.6,5,9.4,6.2,10.3
c0.4,0.2,0.5,0.8,0.3,1.2c-0.2,0.3-0.4,0.4-0.7,0.4c-0.2,0-0.3,0-0.4-0.1C3.9,10.7,2.8,9.7,2.1,8.6z M13.2,10.3
c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7C12.5,10.6,12.8,10.3,13.2,10.3z M15.1,11
c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7C15.4,11.7,15.1,11.4,15.1,11z M18.4,11.7
c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C19.1,11.4,18.8,11.7,18.4,11.7z"
      />
    </SvgIcon>
  );
};
export const ViewContactIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.2,19.2c0.9-1.2,1.4-2.6,1.4-4.2c0-3.9-3.1-7-7-7c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7c1.6,0,3-0.5,4.2-1.4
l1.1,1.1c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L20.2,19.2z M14.6,20.1c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5
s5,2.2,5,5C19.6,17.8,17.4,20.1,14.6,20.1z M21.6,7.1v1.1c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.1c0-1.7-1.3-3-3-3h-10c-1.7,0-3,1.3-3,3v10
c0,1.7,1.3,3,3,3h1.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H6.6c-2.8,0-5-2.2-5-5v-10c0-2.8,2.2-5,5-5h10C19.4,2.1,21.6,4.3,21.6,7.1z"
      />
    </SvgIcon>
  );
};
export const SendIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M21.1,4.4c0.3-1.4-1-2.7-2.4-2.3L3,6.7L2.9,6.7c-1.5,0.6-1.7,2.6-0.3,3.4l6.5,4l3.9,6.5
l0.1,0.1c0.9,1.3,2.9,1,3.4-0.6L21,4.5L21.1,4.4z M19.2,3.6c0.3,0,0.5,0.2,0.4,0.6L15,19.8l0,0.1c-0.1,0.3-0.6,0.3-0.7,0l-3.7-6.1
l5.3-5.3l0.1-0.1c0.2-0.3,0.2-0.7-0.1-1l-0.1-0.1c-0.3-0.2-0.7-0.2-1,0.1l-5.2,5.3L3.3,8.9l-0.1,0C3,8.6,3.1,8.2,3.4,8.1L19.2,3.6
L19.2,3.6z M18.7,2.1l-0.1-0.2l0,0L18.7,2.1z M21.1,4.4l0.2,0.1l0,0L21.1,4.4z M3,6.7L2.9,6.5l0,0L3,6.7z M2.9,6.7L2.8,6.5l0,0
L2.9,6.7z M2.5,10.2l-0.1,0.2h0L2.5,10.2z M9,14.2L9.2,14l0-0.1l-0.1,0L9,14.2z M12.9,20.6l-0.2,0.1l0,0L12.9,20.6z M13,20.8
l-0.2,0.1l0,0L13,20.8z M16.4,20.2l0.2,0.1l0,0L16.4,20.2z M21,4.5l0.2,0.1l0,0L21,4.5z M19.6,4.1L19.4,4l0,0L19.6,4.1z M19.2,3.6
l0-0.2l0,0l0,0L19.2,3.6z M15,19.8l0.2,0.1l0,0l0,0L15,19.8z M14.9,19.8l0.2,0.1l0,0l0,0L14.9,19.8z M14.2,19.9l0.2-0.1l0,0
L14.2,19.9z M10.5,13.7l-0.2-0.2l-0.1,0.1l0.1,0.2L10.5,13.7z M15.8,8.5l0.2,0.2l0,0l0,0L15.8,8.5z M15.8,8.4L16,8.5l0,0l0,0
L15.8,8.4z M15.8,7.4l0.2-0.2l0,0l0,0L15.8,7.4z M15.7,7.3l0.2-0.2l0,0l0,0L15.7,7.3z M14.7,7.4l0.2,0.2v0L14.7,7.4z M9.5,12.7
l-0.1,0.2L9.5,13l0.1-0.1L9.5,12.7z M3.3,8.9L3.2,9.1l0,0l0,0L3.3,8.9z M3.3,8.9L3.1,9l0,0l0,0L3.3,8.9z M3.4,8.1l0.1,0.2l0,0
L3.4,8.1z M19.1,3.6l0-0.2l0,0l0,0L19.1,3.6z M18.7,2.4c1.2-0.4,2.4,0.7,2.1,2l0.5,0.1c0.4-1.6-1.1-3-2.7-2.6L18.7,2.4z M3.1,6.9
l15.7-4.6l-0.1-0.5L2.9,6.5L3.1,6.9z M2.9,7l0.2-0.1L2.9,6.5L2.8,6.5L2.9,7z M2.7,10C1.5,9.2,1.7,7.5,3,7L2.8,6.5
c-1.7,0.6-1.9,2.9-0.4,3.9L2.7,10z M9.2,14l-6.5-4l-0.3,0.4l6.5,4L9.2,14z M13.1,20.5L9.2,14l-0.4,0.3l3.9,6.5L13.1,20.5z
 M13.2,20.6l-0.1-0.1l-0.4,0.3l0.1,0.1L13.2,20.6z M16.2,20.1c-0.4,1.3-2.2,1.6-3,0.5l-0.4,0.3c1,1.4,3.3,1.1,3.8-0.7L16.2,20.1z
 M20.8,4.5l-4.6,15.6l0.5,0.1l4.6-15.6L20.8,4.5z M20.8,4.3l0,0.1l0.5,0.1l0-0.1L20.8,4.3z M19.9,4.2c0.1-0.5-0.2-0.9-0.7-0.9
l0.1,0.5c0.1,0,0.2,0.1,0.2,0.2L19.9,4.2z M15.2,19.8l4.6-15.6L19.4,4l-4.6,15.6L15.2,19.8z M15.2,19.9L15.2,19.9l-0.4-0.3l0,0.1
L15.2,19.9z M14,20c0.3,0.5,0.9,0.4,1.2,0l-0.4-0.2c-0.1,0.1-0.2,0.1-0.3,0L14,20z M10.3,13.9L14,20l0.4-0.3l-3.7-6.1L10.3,13.9z
 M15.6,8.3l-5.3,5.3l0.4,0.4l5.3-5.3L15.6,8.3z M15.7,8.2L15.7,8.2L16,8.6L16,8.5L15.7,8.2z M15.6,7.6c0.2,0.2,0.2,0.5,0.1,0.7
L16,8.5c0.3-0.4,0.3-0.9-0.1-1.3L15.6,7.6z M15.5,7.5L15.5,7.5l0.4-0.3l-0.1-0.1L15.5,7.5z M14.9,7.6c0.2-0.2,0.5-0.2,0.7-0.1
l0.3-0.4c-0.4-0.3-0.9-0.3-1.3,0.1L14.9,7.6z M9.6,12.9l5.2-5.3l-0.4-0.4l-5.2,5.3L9.6,12.9z M3.2,9.1l6.1,3.8l0.3-0.4L3.5,8.7
L3.2,9.1z M3.1,9.1L3.1,9.1l0.4-0.4l-0.1,0L3.1,9.1z M3.4,7.9C2.8,8,2.7,8.7,3.1,9l0.3-0.4C3.3,8.6,3.4,8.4,3.5,8.4L3.4,7.9z
 M19,3.3L3.4,7.9l0.1,0.5l15.7-4.6L19,3.3z M19.1,3.3L19.1,3.3l0,0.5l0.1,0L19.1,3.3z"
      />
    </SvgIcon>
  );
};
export const AckDetailIcon = (props) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path d="M12.5593 6.48195L5.24904 14.0276L2.72122 11.4184C2.09867 10.7758 1.08947 10.7758 0.466914 11.4184C-0.155638 12.061 -0.155638 13.103 0.466914 13.7452L4.12219 17.5182C4.74474 18.1608 5.75394 18.1608 6.37649 17.5182L14.8136 8.80884C15.4361 8.16624 15.4361 7.12454 14.8136 6.48195C14.191 5.83935 13.1818 5.83935 12.5593 6.48195Z" />
      <path d="M13.9688 14.0273L12.891 12.9147L10.6367 15.2416L12.842 17.5179C13.4645 18.1605 14.4737 18.1605 15.0963 17.5179L23.5334 8.80884C24.1559 8.16624 24.1559 7.12454 23.5334 6.48195C22.9108 5.83935 21.9016 5.83935 21.2791 6.48195L13.9688 14.0276V14.0273Z" />
    </SvgIcon>
  );
};

export const SaveDraftIcon = (props) => {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_8892_243777" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <path d="M24 0H0V23.9994H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_8892_243777)">
        <path
          d="M7.25 13C7.25 12.5862 7.58625 12.25 8 12.25H16C16.4137 12.25 16.75 12.5862 16.75 13C16.75 13.4137 16.4137 13.75 16 13.75H8C7.58625 13.75 7.25 13.4137 7.25 13Z"
          fill="#538fff"
        />
        <path
          d="M8 15.75C7.58625 15.75 7.25 16.0862 7.25 16.5C7.25 16.9137 7.58625 17.25 8 17.25H12C12.4138 17.25 12.75 16.9137 12.75 16.5C12.75 16.0862 12.4138 15.75 12 15.75H8Z"
          fill="#538fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.75 18.4996C20.75 20.847 18.8475 22.7495 16.5 22.7495H7.5C5.1525 22.7495 3.25 20.847 3.25 18.4996V5.4999C3.25 3.15245 5.1525 1.25 7.5 1.25H12.465C13.3263 1.25 14.1525 1.59249 14.7625 2.20248L19.7975 7.23736C20.4075 7.84734 20.75 8.67357 20.75 9.5348V18.4996ZM4.75 5.4999C4.75 3.98119 5.98125 2.74996 7.5 2.74996H11.5C12.19 2.74996 12.75 3.30995 12.75 3.99993V6.49988C12.75 8.01859 13.9812 9.24981 15.5 9.24981H18C18.69 9.24981 19.25 9.8098 19.25 10.4998V18.4996C19.25 20.0183 18.0188 21.2495 16.5 21.2495H7.5C5.98125 21.2495 4.75 20.0183 4.75 18.4996V5.4999ZM18.1963 7.75735L14.2425 3.80369C14.2475 3.86869 14.25 3.93369 14.25 3.99993V6.49988C14.25 7.18986 14.81 7.74985 15.5 7.74985H18C18.0662 7.74985 18.1313 7.75235 18.1963 7.75735Z"
          fill="#538fff"
        />
      </g>
    </SvgIcon>
  );
};

export const BarcodeIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 28">
      <circle cx="14" cy="14" r="14" fill="#F5FAFF" />
      <path
        d="M11.2299 12.8689V8.44733C11.2299 7.92512 10.8168 7.50003 10.3068 7.50003C9.79678 7.50003 9.38371 7.92512 9.38371 8.44733V12.8689C9.38371 13.3911 9.79678 13.8162 10.3068 13.8162C10.8168 13.8162 11.2299 13.3911 11.2299 12.8689Z"
        fill="#538FFF"
      />
      <path
        d="M9.38371 16.0258C9.39063 15.506 9.80027 15.0856 10.3068 15.0785C10.8133 15.0856 11.2229 15.506 11.2299 16.0258V18.5527C11.2299 19.0749 10.8168 19.5 10.3068 19.5C9.79678 19.5 9.38371 19.0749 9.38371 18.5527V16.0258Z"
        fill="#538FFF"
      />
      <path
        d="M5.69141 18.5527V8.44733C5.69141 7.92512 6.10447 7.50003 6.61448 7.50003C7.12449 7.50003 7.53756 7.92512 7.53756 8.44733V18.5527C7.53756 19.0749 7.12449 19.5 6.61448 19.5C6.10447 19.5 5.69141 19.0749 5.69141 18.5527Z"
        fill="#538FFF"
      />
      <path
        d="M13.076 8.44733C13.0829 7.92751 13.4926 7.50713 13.9991 7.50003C14.5056 7.50712 14.9153 7.92751 14.9222 8.44733V18.5527C14.9222 19.0749 14.5091 19.5 13.9991 19.5C13.4891 19.5 13.076 19.0749 13.076 18.5527V8.44733Z"
        fill="#538FFF"
      />
      <path
        d="M22.3068 12.8689C22.2999 13.3887 21.8902 13.8091 21.3837 13.8162C20.8772 13.8091 20.4676 13.3887 20.4606 12.8689V8.4473C20.4606 7.92509 20.8737 7.5 21.3837 7.5C21.8937 7.5 22.3068 7.92509 22.3068 8.4473V12.8689Z"
        fill="#538FFF"
      />
      <path
        d="M21.3837 19.5C20.8737 19.5 20.4606 19.0749 20.4606 18.5527V16.0258C20.4606 15.5036 20.8737 15.0785 21.3837 15.0785C21.8937 15.0785 22.3068 15.5036 22.3068 16.0258V18.5527C22.3068 19.0749 21.8937 19.5 21.3837 19.5Z"
        fill="#538FFF"
      />
      <path
        d="M18.6145 8.44733V18.5527C18.6145 19.0749 18.2014 19.5 17.6914 19.5C17.1814 19.5 16.7683 19.0749 16.7683 18.5527V8.44733C16.7683 7.92512 17.1814 7.50003 17.6914 7.50003C18.2014 7.50003 18.6145 7.92512 18.6145 8.44733Z"
        fill="#538FFF"
      />
    </SvgIcon>
  );
};

export const HiddenBarcodeIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="14" fill="#F5FAFF" />
      <path
        d="M11.2299 12.8689V8.44733C11.2299 7.92512 10.8168 7.50003 10.3068 7.50003C9.79678 7.50003 9.38371 7.92512 9.38371 8.44733V12.8689C9.38371 13.3911 9.79678 13.8162 10.3068 13.8162C10.8168 13.8162 11.2299 13.3911 11.2299 12.8689Z"
        fill="#538FFF"
      />
      <path
        d="M9.38371 16.0258C9.39063 15.506 9.80027 15.0856 10.3068 15.0785C10.8133 15.0856 11.2229 15.506 11.2299 16.0258V18.5527C11.2299 19.0749 10.8168 19.5 10.3068 19.5C9.79678 19.5 9.38371 19.0749 9.38371 18.5527V16.0258Z"
        fill="#538FFF"
      />
      <path
        d="M5.69141 18.5527V8.44733C5.69141 7.92512 6.10447 7.50003 6.61448 7.50003C7.12449 7.50003 7.53756 7.92512 7.53756 8.44733V18.5527C7.53756 19.0749 7.12449 19.5 6.61448 19.5C6.10447 19.5 5.69141 19.0749 5.69141 18.5527Z"
        fill="#538FFF"
      />
      <path
        d="M13.076 8.44733C13.0829 7.92751 13.4926 7.50713 13.9991 7.50003C14.5056 7.50712 14.9153 7.92751 14.9222 8.44733V18.5527C14.9222 19.0749 14.5091 19.5 13.9991 19.5C13.4891 19.5 13.076 19.0749 13.076 18.5527V8.44733Z"
        fill="#538FFF"
      />
      <path
        d="M22.3068 12.8689C22.2999 13.3887 21.8902 13.8091 21.3837 13.8162C20.8772 13.8091 20.4676 13.3887 20.4606 12.8689V8.4473C20.4606 7.92509 20.8737 7.5 21.3837 7.5C21.8937 7.5 22.3068 7.92509 22.3068 8.4473V12.8689Z"
        fill="#538FFF"
      />
      <path
        d="M21.3837 19.5C20.8737 19.5 20.4606 19.0749 20.4606 18.5527V16.0258C20.4606 15.5036 20.8737 15.0785 21.3837 15.0785C21.8937 15.0785 22.3068 15.5036 22.3068 16.0258V18.5527C22.3068 19.0749 21.8937 19.5 21.3837 19.5Z"
        fill="#538FFF"
      />
      <path
        d="M18.6145 8.44733V18.5527C18.6145 19.0749 18.2014 19.5 17.6914 19.5C17.1814 19.5 16.7683 19.0749 16.7683 18.5527V8.44733C16.7683 7.92512 17.1814 7.50003 17.6914 7.50003C18.2014 7.50003 18.6145 7.92512 18.6145 8.44733Z"
        fill="#538FFF"
      />
      <path d="M23 6L5 21.5" stroke="#538FFF" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const ScanBarcodeIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.69231 5.81988V9.38576C7.69231 9.80691 7.34809 10.1497 6.92308 10.1497C6.49807 10.1497 6.15385 9.80691 6.15385 9.38576V5.81988C6.15385 5.39873 6.49807 5.05591 6.92308 5.05591C7.34809 5.05591 7.69231 5.39873 7.69231 5.81988ZM5.89711 16.2615H1.53846V11.9317C1.53846 11.5105 1.19424 11.1677 0.769231 11.1677C0.344222 11.1677 0 11.5105 0 11.9317V16.5156C0 16.8536 0.134617 17.1773 0.375951 17.4161C0.616335 17.6548 0.942301 17.7895 1.28172 17.7895H5.89711C6.32212 17.7895 6.66634 17.4466 6.66634 17.0255C6.66634 16.6034 6.32212 16.2615 5.89711 16.2615ZM6.92308 11.1677C6.50097 11.1735 6.15961 11.5125 6.15385 11.9317V13.9696C6.15385 14.3908 6.49807 14.7336 6.92308 14.7336C7.34809 14.7336 7.69231 14.3908 7.69231 13.9696V11.9317C7.68654 11.5125 7.34518 11.1735 6.92308 11.1677ZM0.769231 8.62178C1.19134 8.61605 1.5327 8.27702 1.53846 7.8578V3.52795H5.89711C6.32212 3.52795 6.66634 3.18608 6.66634 2.76398C6.66634 2.34282 6.32212 2 5.89711 2H1.28172C0.574031 2 0 2.57011 0 3.27392V7.85778C0.00576935 8.277 0.347126 8.61606 0.769231 8.62178ZM3.07692 5.81988V13.9696C3.07692 14.3908 3.42114 14.7336 3.84615 14.7336C4.27116 14.7336 4.61538 14.3908 4.61538 13.9696V5.81988C4.61538 5.39873 4.27116 5.05591 3.84615 5.05591C3.42114 5.05591 3.07692 5.39873 3.07692 5.81988ZM10 5.05591C9.5779 5.06164 9.23653 5.40066 9.23077 5.81988V13.9696C9.23077 14.3908 9.57499 14.7336 10 14.7336C10.425 14.7336 10.7692 14.3908 10.7692 13.9696V5.81988C10.7635 5.40066 10.4221 5.06163 10 5.05591ZM16.1538 10.1497C16.576 10.144 16.9173 9.80496 16.9231 9.38573V5.81986C16.9231 5.39871 16.5789 5.05588 16.1538 5.05588C15.7288 5.05588 15.3846 5.39871 15.3846 5.81986V9.38573C15.3904 9.80496 15.7317 10.144 16.1538 10.1497ZM18.7183 2H14.1029C13.6779 2 13.3337 2.34282 13.3337 2.76398C13.3337 3.18608 13.6779 3.52795 14.1029 3.52795H18.4615V7.8578C18.4615 8.27896 18.8058 8.62178 19.2308 8.62178C19.6558 8.62178 20 8.27896 20 7.8578V3.27395C20 2.93589 19.8654 2.61216 19.6241 2.37341C19.3837 2.13466 19.0577 2 18.7183 2ZM15.3846 13.9696C15.3846 14.3908 15.7288 14.7336 16.1538 14.7336C16.5789 14.7336 16.9231 14.3908 16.9231 13.9696V11.9317C16.9231 11.5106 16.5789 11.1677 16.1538 11.1677C15.7288 11.1677 15.3846 11.5106 15.3846 11.9317V13.9696ZM13.8462 13.9696V5.81988C13.8462 5.39873 13.5019 5.05591 13.0769 5.05591C12.6519 5.05591 12.3077 5.39873 12.3077 5.81988V13.9696C12.3077 14.3908 12.6519 14.7336 13.0769 14.7336C13.5019 14.7336 13.8462 14.3908 13.8462 13.9696ZM19.2308 11.1677C18.8087 11.1734 18.4673 11.5125 18.4615 11.9317V16.2606L14.1029 16.2615C13.6779 16.2615 13.3337 16.6034 13.3337 17.0255C13.3337 17.4466 13.6779 17.7895 14.1029 17.7895H18.7183C19.0577 17.7895 19.3837 17.6548 19.6241 17.4161C19.8654 17.1773 20 16.8536 20 16.5156V11.9317C19.9942 11.5125 19.6529 11.1734 19.2308 11.1677Z"
        fill="#538FFF"
      />
    </SvgIcon>
  );
};

export const TrolleyIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 52 30" fill="none">
    <path
      d="M9.6377 12.4203C9.58266 12.6159 9.5582 12.8239 9.5582 13.0379C9.5582 14.3588 10.6345 15.4351 11.9554 15.4351C12.8421 15.4351 13.6126 14.952 14.0285 14.2365H16.6275L29.3045 19.5323L18.6027 24.0026C17.979 23.1526 16.9699 22.5961 15.8325 22.5961C13.9429 22.5961 12.4018 24.1372 12.4018 26.0268C12.4018 27.9164 13.9429 29.4575 15.8325 29.4575C17.7221 29.4575 19.2632 27.9164 19.2632 26.0268C19.2632 25.8372 19.2448 25.6537 19.2204 25.4764L31.3776 20.3946L43.5348 25.4764C43.5042 25.6537 43.492 25.8372 43.492 26.0268C43.492 27.9164 45.033 29.4575 46.9226 29.4575C48.8123 29.4575 50.3533 27.9164 50.3533 26.0268C50.3533 24.1372 48.8123 22.5961 46.9226 22.5961C45.7852 22.5961 44.7823 23.1526 44.1524 24.0026L33.4506 19.5323L46.1276 14.2365H50.7997C51.4602 14.2365 51.9983 13.6984 51.9983 13.0379C51.9983 12.3775 51.4602 11.8393 50.7997 11.8393H14.0224C13.6065 11.1238 12.836 10.6407 11.9493 10.6407C11.7352 10.6407 11.5273 10.6713 11.3316 10.7202L2.04251 1.43719C1.57775 0.972433 0.819449 0.972433 0.348572 1.43719C-0.116191 1.90196 -0.116191 2.66025 0.348572 3.13113L9.6377 12.4203ZM41.9692 14.2365L31.3653 18.664L20.7614 14.2365H41.9692Z"
      fill="#e7efff"
    />
    <path
      d="M10.8271 9.12401C10.9738 9.27078 11.1817 9.35639 11.3897 9.35639C11.5976 9.35639 11.8055 9.27078 11.9523 9.12401L12.0807 8.99559C13.634 7.44231 13.634 4.90446 12.0807 3.35118L9.89754 1.16802C9.14536 0.41584 8.14245 0 7.07839 0C6.01433 0 5.01142 0.41584 4.25924 1.16802L4.13082 1.29644C3.98405 1.44321 3.89844 1.65113 3.89844 1.85905C3.89844 2.06697 3.98405 2.27489 4.13082 2.42165L10.8271 9.12401Z"
      fill="#e7efff"
    />
    <path
      d="M15.1992 9.60681V10.2428C15.1992 10.6831 15.5539 11.0439 16.0003 11.0439H48.4603C48.9006 11.0439 49.2614 10.6892 49.2614 10.2428V9.60681C49.2614 7.40531 47.4696 5.61353 45.2681 5.61353H19.1925C16.991 5.61353 15.1992 7.40531 15.1992 9.60681Z"
      fill="#e7efff"
    />
  </SvgIcon>
);

export const WarningIcon = ({ warningColor = '#951B07', ...props }) => (
  <SvgIcon {...props} viewBox="0 0 23 20" fill="none" aria-hidden="true">
    <path
      d="M10.466 1.28c.395-.604 1.28-.604 1.675 0l9.69 14.826c.435.665-.042 1.547-.837 1.547H1.613c-.795 0-1.272-.882-.837-1.547L10.466 1.28z"
      fill={warningColor}
    />
    <path
      d="M10.84 12.64l-.243-3.078-.045-1.34h1.494l-.045 1.34-.243 3.078h-.918zM11.3 15.034a.76.76 0 0 1-.567-.225.756.756 0 0 1-.225-.567c0-.234.075-.426.225-.576a.774.774 0 0 1 .567-.225c.228 0 .417.075.567.225.15.15.225.342.225.576 0 .228-.075.417-.225.567a.76.76 0 0 1-.567.225z"
      fill="#ffffff"
    />
  </SvgIcon>
);

export const ClickIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 22" fill="none">
    <path
      d="M9.17287 16.4601C9.17287 16.2102 8.96233 16.0316 8.7176 16.0665C6.1268 16.2088 3.71226 15.0293 2.20691 12.8852C-0.173364 9.45397 0.631914 4.70099 3.95691 2.27062C5.56746 1.09105 7.56225 0.626206 9.52259 0.983562C11.4831 1.30462 13.1976 2.41299 14.3529 4.0574C15.8582 6.20153 16.1726 8.95425 15.1582 11.3846C15.0529 11.5996 15.1582 11.8495 15.4029 11.957C15.6135 12.0645 15.8582 11.957 15.9635 11.7071C17.0832 8.99062 16.7332 5.95295 15.0529 3.55759C13.7582 1.69963 11.8674 0.483757 9.66225 0.126401C7.45697 -0.267263 5.28586 0.268786 3.46621 1.59213C-0.244477 4.23739 -1.11948 9.52651 1.54122 13.3513C3.08202 15.6029 5.63726 16.9249 8.29795 16.9249H8.75323C8.99796 16.8886 9.17287 16.71 9.17287 16.4601ZM13.3386 11.0272C13.5491 11.1347 13.7938 11.0272 13.8991 10.7774C14.7044 8.8119 14.4597 6.59522 13.2347 4.87956C11.3097 2.12681 7.52935 1.44837 4.8333 3.45013C2.13723 5.41559 1.47275 9.27539 3.39775 12.0281C4.51747 13.6725 6.37274 14.6371 8.33344 14.6371H8.68344C8.92816 14.6371 9.10315 14.4221 9.06899 14.1722C9.06899 13.9224 8.85845 13.7437 8.61372 13.7786C6.794 13.8861 5.11372 13.0639 4.09803 11.5633C2.45331 9.16926 3.01247 5.88058 5.32302 4.16492C7.63358 2.48563 10.8887 3.02166 12.5691 5.41566C13.6191 6.91627 13.8296 8.81055 13.1296 10.4912C12.9888 10.6699 13.0925 10.9197 13.3386 11.0272ZM6.61753 5.9878C7.94781 5.02322 9.76752 5.34427 10.7136 6.6662C10.9938 7.09474 11.1688 7.52328 11.2386 7.98813C11.2741 8.238 11.4833 8.41667 11.728 8.34549C11.9727 8.3092 12.1136 8.09562 12.078 7.84576C12.0083 7.23854 11.7636 6.6662 11.4136 6.13017C10.1886 4.3783 7.84253 3.98603 6.12788 5.23678C5.28844 5.844 4.76208 6.73739 4.58708 7.73827C4.41208 8.77542 4.65681 9.77491 5.21736 10.6334C5.60292 11.1695 6.0568 11.5631 6.58316 11.8493C6.65289 11.8856 6.72261 11.8856 6.79371 11.8856C6.93316 11.8856 7.10816 11.8144 7.17926 11.6357C7.28454 11.4207 7.21481 11.1708 7.00426 11.0633C6.58455 10.8484 6.23455 10.5273 5.91871 10.1336C4.97126 8.84659 5.28725 6.95255 6.61753 5.9878Z"
      fill="#2E4469"
    />
    <path
      d="M19.1039 13.9406L17.9386 13.4827L17.1513 13.1773L10.4984 10.566C10.404 10.5258 10.3095 10.5098 10.215 10.5098C9.70324 10.5098 9.28596 11.0481 9.49067 11.5945L12.0967 18.5125L12.3959 19.316L12.7974 20.3766C12.9628 20.8105 13.3407 21.0194 13.7186 21.0194C14.1201 21.0194 14.5295 20.7783 14.6634 20.2962L14.9468 19.316L15.1751 18.5125L15.6554 16.8573L17.1434 16.4073L17.9308 16.1743L19.0251 15.8449C19.9306 15.5717 19.9778 14.2861 19.1039 13.9406Z"
      fill="#2E4469"
    />
  </SvgIcon>
);

export const WheelchairIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 29 29" fill="none">
      <circle cx="14.5" cy="14.5" r="14" fill="white" stroke="#0554D4" />
      <path
        d="M17.6223 14.9212C18.2166 14.9302 18.6278 15.2095 18.9544 15.6386L21.8554 19.4418C22.2756 19.9927 22.0975 20.7215 21.598 21.102C21.0985 21.4824 20.3518 21.412 19.9316 20.8663L17.6454 17.8893L12.2429 17.8739C11.1542 17.8713 10.4061 16.8799 10.4369 15.8461L10.0757 10.7683C10.0065 9.79731 10.6098 8.9493 11.5486 8.74306C12.435 8.54963 13.4225 9.08508 13.703 10.0253C13.8029 10.3584 13.8029 10.7286 13.8413 11.1103L16.745 11.1218C17.2662 11.1244 17.6518 11.6227 17.6479 12.0903C17.6441 12.5578 17.2624 13.0497 16.7373 13.051L13.9694 13.0625L14.1013 14.9174L17.6223 14.92V14.9212Z"
        fill="#0554D4"
      />
      <path
        d="M17.6201 18.6012L18.696 19.9424C17.3524 22.1816 14.8049 23.3383 12.2432 22.913C9.81478 22.5108 7.80004 20.6431 7.20318 18.2835C6.55124 15.7049 7.49136 13.093 9.69054 11.5212L9.83655 13.4914C7.86408 15.6268 8.28676 19.0047 10.655 20.5983C13.0361 22.2008 16.3367 21.3925 17.6201 18.6025V18.6012Z"
        fill="#0554D4"
      />
      <path
        d="M11.4425 5.01265C12.4364 4.8948 13.2382 5.616 13.3356 6.51525C13.4329 7.4145 12.7758 8.28301 11.8268 8.39573C10.9379 8.50077 10.09 7.84107 9.96187 6.92644C9.83379 6.01182 10.4601 5.12922 11.4425 5.01265Z"
        fill="#0554D4"
      />
    </SvgIcon>
  );
};

export const StretcherIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 29 29" fill="none">
      <circle cx="14.5" cy="14.5" r="14" fill="white" stroke="#0554D4" />
      <path
        d="M10.7293 20.9473C10.5797 21.607 10.1003 22.0479 9.43507 22.1634C8.96666 22.2447 8.45646 22.0479 8.13209 21.7137C7.79013 21.3618 7.6109 20.8725 7.70216 20.3854C7.80552 19.8378 8.19037 19.3914 8.64009 19.21C9.19427 18.9868 9.80233 19.0912 10.218 19.4717C10.3356 19.5794 10.4115 19.6102 10.5577 19.5398L13.808 17.962C13.8608 17.9367 13.9257 17.9169 13.9356 17.885C13.9477 17.8454 13.8817 17.7893 13.8223 17.7596L8.94687 15.3956L6.75104 15.3824C6.54652 15.3813 6.46626 15.1273 6.49375 14.9998C6.53993 14.7799 6.68507 14.6897 6.91378 14.6886L13.1076 14.6721L6.54872 11.3877C6.00334 11.115 5.89229 10.4311 6.09351 9.9396C6.3508 9.39972 6.90608 9.13913 7.51304 9.30626L15.1451 13.1085L23.0784 13.1107C23.6447 13.2361 24.0339 13.7309 23.9977 14.2971C23.9977 14.8216 23.538 15.3758 22.9619 15.3791L20.7331 15.3912L15.663 17.8553L19.2827 19.6168C19.7929 19.0989 20.4945 18.9384 21.141 19.2583C21.715 19.542 22.0734 20.1919 21.9635 20.8923C21.8645 21.5201 21.3521 22.0633 20.6517 22.1634C19.8655 22.2744 19.1266 21.7367 18.9353 20.9484H10.7293V20.9473ZM18.7648 15.5583C18.866 15.533 18.9375 15.4726 18.9716 15.3879L10.6402 15.4033L14.8383 17.4595L18.7648 15.5583ZM18.4988 20.2216C18.6175 20.2534 18.6967 20.2589 18.8275 20.1908L14.8383 18.2522L10.8788 20.1721C10.925 20.3007 11.0162 20.2238 11.1174 20.2238L18.4999 20.2216H18.4988ZM9.41198 21.2287C9.73745 21.154 9.90129 20.7977 9.84191 20.5217C9.77704 20.215 9.55053 20.0126 9.23825 20.0038C8.94907 19.995 8.68627 20.2007 8.6027 20.5063C8.54443 20.7164 8.63679 20.9451 8.77314 21.0803C8.93147 21.2375 9.15578 21.287 9.41198 21.2287ZM20.2811 20.0269C19.9183 20.138 19.749 20.4811 19.8479 20.8296C19.9403 21.1562 20.2954 21.3266 20.6528 21.2244C20.9563 21.1364 21.1542 20.7636 21.0475 20.4393C20.9464 20.1336 20.6121 19.9258 20.28 20.028L20.2811 20.0269Z"
        fill="#0554D4"
      />
      <path
        d="M22.3657 10.4716C22.921 10.4727 23.3124 10.9466 23.3355 11.4326C23.3575 11.8812 23.0045 12.4629 22.4757 12.4629L15.5517 12.4662C15.0646 12.4662 14.6149 12.2342 14.1993 12.0264L11.3712 10.6134C10.6224 10.2396 10.4113 9.26978 10.8016 8.57596C11.192 7.88214 12.087 7.62265 12.8358 7.9965L16.6568 9.90203C16.9504 10.0483 17.1923 10.189 17.4012 10.4584L22.3646 10.4716H22.3657Z"
        fill="#0554D4"
      />
      <path
        d="M9.51374 6.04043C10.2944 6.24275 10.7562 6.95087 10.6639 7.69417C10.5715 8.43747 9.93817 9.00374 9.19487 9.01144C8.45156 9.01913 7.79952 8.47045 7.68847 7.72935C7.57741 6.98825 8.03263 6.27354 8.79133 6.04813C8.99035 5.98875 9.28943 5.98216 9.51484 6.04043H9.51374Z"
        fill="#0554D4"
      />
    </SvgIcon>
  );
};

export const CarrierIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 29 29" fill="none">
      <circle cx="14.5" cy="14.5" r="14" fill="white" stroke="#0554D4" />
      <path
        d="M23.9886 17.4059L24 19.8776L22.6294 19.8696C22.3007 18.7083 21.2827 17.9644 20.1327 17.9655C18.9873 17.9655 17.9659 18.7265 17.6485 19.8764H12.124C11.81 18.7253 10.7818 17.9667 9.63754 17.9655C8.48872 17.9655 7.4764 18.714 7.14427 19.8696L6 19.8753V12.1123C6 11.7039 6.32417 11.3877 6.73251 11.3877H18.091C18.4936 11.3877 18.7985 11.7358 18.7996 12.1009L18.803 13.095L20.3056 13.0927L22.4474 16.0057C23.2334 16.0649 23.9829 16.6507 23.9863 17.4071L23.9886 17.4059ZM14.317 13.1678C12.9475 13.3714 12.0796 14.6533 12.3082 15.9568C12.5369 17.2603 13.746 18.1157 15.0472 17.9109C16.3382 17.7085 17.2447 16.4914 17.0491 15.1879C16.8535 13.8844 15.6751 12.9653 14.3158 13.1678H14.317ZM21.4408 15.9773L19.8847 13.8799L18.8201 13.8867V15.9909L21.4408 15.9773Z"
        fill="#0554D4"
      />
      <path
        d="M19.9862 18.5376C21.1327 18.4512 22.0495 19.3168 22.1394 20.3689C22.236 21.4995 21.4 22.4573 20.2967 22.5449C19.1934 22.6324 18.2402 21.8271 18.1344 20.7329C18.0286 19.6387 18.8237 18.6252 19.9862 18.5376ZM19.8213 19.5818C19.2389 19.7684 18.9932 20.3837 19.1957 20.9195C19.3799 21.4074 19.9407 21.6736 20.4525 21.5052C20.9644 21.3369 21.2658 20.7659 21.1088 20.2518C20.9439 19.7126 20.4013 19.3964 19.8213 19.5807V19.5818Z"
        fill="#0554D4"
      />
      <path
        d="M9.49221 18.5364C10.6365 18.4523 11.551 19.3224 11.6397 20.3745C11.7341 21.5006 10.8867 22.4583 9.80045 22.5436C8.69145 22.6312 7.74282 21.8282 7.63477 20.7431C7.52671 19.658 8.32633 18.6218 9.49221 18.5364ZM9.325 19.5783C8.74377 19.7546 8.50604 20.3734 8.6687 20.8602C8.84955 21.4005 9.416 21.6519 9.88576 21.5245C10.4863 21.3618 10.7548 20.7874 10.6046 20.2551C10.4545 19.7228 9.90055 19.4032 9.32614 19.5783H9.325Z"
        fill="#0554D4"
      />
      <path
        d="M15.8731 10.9896H14.25L14.2625 9.95791C14.2682 9.54161 14.6947 9.35848 15.0496 9.35279C15.5046 9.34483 15.8538 9.60189 15.8731 10.0671V10.9896Z"
        fill="#0554D4"
      />
      <path
        d="M13.4686 10.4584L12.1014 10.455C11.9979 10.455 11.8535 10.2491 11.8682 10.1524C11.8864 10.0387 12.0286 9.90105 12.1503 9.90105H13.4163C13.5721 9.90105 13.7063 10.0102 13.7223 10.1513C13.7371 10.2787 13.6119 10.4584 13.4686 10.4584Z"
        fill="#0554D4"
      />
      <path
        d="M17.9522 10.4584H16.6919C16.544 10.4607 16.4007 10.3344 16.3916 10.2116C16.3779 10.0307 16.511 9.90105 16.6941 9.90105H17.9556C18.0898 9.90105 18.224 10.0341 18.2331 10.1536C18.2445 10.3037 18.1125 10.4584 17.9522 10.4584Z"
        fill="#0554D4"
      />
      <path
        d="M15.341 8.51678C15.341 8.69194 15.2216 8.83298 15.084 8.84095C14.9213 8.85118 14.7734 8.71355 14.7734 8.53952V7.27697C14.7734 7.15412 14.9202 7.00853 15.0271 7.00057C15.1806 6.99033 15.3376 7.12 15.3376 7.27924L15.341 8.51678Z"
        fill="#0554D4"
      />
      <path
        d="M16.4086 9.22078C16.3051 9.32429 16.1185 9.33908 16.0161 9.24922C15.891 9.14002 15.891 8.94438 16.0127 8.82268L16.9329 7.90818C17.016 7.82514 17.2537 7.85472 17.3208 7.94002"
        fill="#0554D4"
      />
      <path
        d="M14.1162 8.83977C14.214 8.93872 14.2049 9.13323 14.1299 9.21967C14.0457 9.31749 13.8364 9.34707 13.7363 9.24697L12.7843 8.29607C12.7206 8.23237 12.7331 8.01171 12.7956 7.94688C12.8844 7.85361 13.0675 7.83882 13.1824 7.90252L14.1162 8.83977Z"
        fill="#0554D4"
      />
      <path
        d="M15.3047 17.1579L14.0512 17.1613L14.0444 16.1626L13.048 16.1615L13.0469 14.9114L14.0455 14.9046L14.0467 13.9105L15.3047 13.9082L15.307 14.9046L16.3068 14.9137L16.3079 16.1581L15.307 16.1626L15.3047 17.1579Z"
        fill="#0554D4"
      />
    </SvgIcon>
  );
};

export const AmbulantIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 29 29" fill="none">
      <circle cx="14.5" cy="14.5" r="14" fill="white" stroke="#0554D4" />
      <path
        d="M14.6173 22.2752L14.6148 15.657C14.5179 15.5638 14.4431 15.4878 14.3499 15.4878C14.2567 15.4878 14.1819 15.5638 14.0838 15.657L14.0789 22.1722C14.0789 22.6406 13.7307 22.9717 13.2904 22.9974C12.8993 23.0207 12.4394 22.6982 12.4394 22.2286L12.4296 10.5926C12.4296 10.4773 12.2923 10.4221 12.215 10.4013C12.1378 10.3804 11.9808 10.4307 11.9293 10.5288L10.9103 12.481C10.8244 12.6466 10.7717 12.7962 10.7312 12.9752L10.6564 13.3038L10.5277 13.8998L10.4247 14.3621L10.2689 15.0586C10.2199 15.2793 10.2027 15.5136 10.0776 15.7024C9.86673 16.0212 9.41669 16.0556 9.16776 15.787C9.05494 15.6656 8.98014 15.5332 9.00466 15.3664L9.0623 14.9691L9.19596 14.3731L9.32104 13.8029L9.47432 13.0991C9.50375 12.9654 9.54545 12.8281 9.56384 12.6932C9.59695 12.432 9.6975 12.2235 9.81522 11.993L11.0084 9.66675C11.2181 9.25718 11.597 8.91014 12.0899 8.91014H16.5989C17.0477 8.91137 17.4462 9.19709 17.6437 9.58091L18.8834 11.9819C18.9509 12.1119 19.0379 12.2566 19.0686 12.3915L19.1348 12.6907L19.2672 13.2928L19.4083 13.9378L19.5223 14.459L19.6817 15.1862C19.7639 15.5602 19.5983 15.868 19.2145 15.955C18.9092 16.0249 18.5977 15.8066 18.5303 15.5001L18.3561 14.7177L18.2642 14.3032L18.0986 13.5503L18.0214 13.1959C17.9686 12.958 17.9269 12.7496 17.8178 12.5399L17.1029 11.1689L16.9508 10.8758L16.8221 10.6269C16.7632 10.5129 16.7068 10.4307 16.583 10.4001C16.4518 10.3669 16.3586 10.4454 16.2617 10.5754L16.258 22.1991C16.258 22.6492 15.8828 22.9766 15.4842 22.9987C15.0477 23.022 14.7141 22.7387 14.6124 22.2764L14.6173 22.2752Z"
        fill="#0554D4"
      />
      <path
        d="M13.8433 8.19284C13.1652 7.96598 12.6931 7.28786 12.7115 6.58889C12.7151 6.46504 12.7446 6.35099 12.7752 6.23573C12.931 5.6557 13.354 5.23877 13.9267 5.06342C14.2541 4.96409 14.568 4.98371 14.8991 5.10634C15.7244 5.41045 16.1904 6.32524 15.8985 7.16646C15.6067 8.00767 14.6919 8.47611 13.8421 8.19161L13.8433 8.19284Z"
        fill="#0554D4"
      />
      <rect
        width="0.751654"
        height="12.0894"
        rx="0.375827"
        transform="matrix(0.97454 0.224214 -0.205473 0.978663 11.7188 11)"
        fill="#0554D4"
      />
      <rect
        width="0.751654"
        height="12.0894"
        rx="0.375827"
        transform="matrix(-0.97454 0.224214 0.205473 0.978663 16.9297 11)"
        fill="#0554D4"
      />
    </SvgIcon>
  );
};

export const CmsAlertWideIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 84 38" fill="none">
      <g clipPath="url(#clip0_10281_62976)">
        <path
          d="M38.7775 32.83L36.0075 36.32L33.7875 33.47C33.2975 32.85 32.5075 31.97 31.6175 31.96L5.7975 31.85C3.1875 31.8 0.9375 29.77 0.9375 27.04V9.87004C0.9375 7.24004 3.1275 5.04004 5.7875 5.04004H66.2675C68.9175 5.04004 71.1275 7.23004 71.1275 9.83004V27.06C71.1275 29.75 68.8375 31.8 66.2675 31.84L40.5875 31.92C40.0675 31.92 39.1275 32.39 38.7775 32.83ZM40.6875 30.07L66.1375 29.99C67.9075 29.96 69.3575 28.67 69.3575 26.77L69.3975 10.29C69.3975 8.32004 67.9975 6.80004 66.0075 6.80004H6.0375C4.6075 6.80004 2.8475 7.89004 2.8375 9.42004L2.7775 26.86C2.7775 28.55 4.0175 29.95 5.7375 29.97L30.9975 30.02C34.4475 30.05 35.6575 33.44 36.0775 33.17C36.8075 32.71 37.9475 30.1 40.6875 30.07Z"
          fill="#80A5DD"
          stroke="#80A5DD"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M75.0821 22.7899C68.4421 25.0199 61.2521 20.1199 60.5721 13.2299C60.1821 9.35994 61.5921 5.80994 64.0921 3.35994C66.5921 0.909941 70.2221 -0.470059 73.8721 0.129941C80.2121 1.16994 84.2321 6.74994 83.4021 13.2199C82.8221 17.7099 79.6721 21.2499 75.0821 22.7899Z"
          fill="#BE1E2D"
        />
        <path
          d="M75.0821 22.6999C68.4421 24.9199 61.2521 20.0399 60.5721 13.1799C60.1821 9.32993 61.5921 5.78993 64.0921 3.34993C66.5921 0.909933 70.2221 -0.460067 73.8721 0.129933C80.2121 1.16993 84.2321 6.72993 83.4021 13.1699C82.8221 17.6399 79.6721 21.1599 75.0821 22.6999Z"
          fill="#EF0117"
        />
        <path
          d="M72.6124 14.9299H71.3224L71.2524 14.3299L70.7324 9.69988L70.6524 8.98988L70.5724 8.31988L70.3024 5.75988C70.2224 4.97988 71.0124 3.99988 72.1224 4.08988C73.1524 4.16988 73.8124 5.15988 73.6224 6.15988C73.5624 6.44988 73.5524 6.74988 73.5224 7.03988L73.4624 7.57988L73.3924 8.24988L73.3224 8.88988L72.6324 14.8999V14.9199L72.6124 14.9299Z"
          fill="white"
        />
        <path
          d="M72.3402 19.1899C72.0902 19.2499 71.8802 19.2399 71.6502 19.1899C70.9502 19.0199 70.4902 18.3799 70.5002 17.6699C70.5202 16.9599 71.0102 16.3599 71.7202 16.2399C72.6402 16.0799 73.4302 16.7499 73.4802 17.6399C73.5202 18.3599 73.0502 19.0199 72.3302 19.1799L72.3402 19.1899Z"
          fill="white"
        />
        <path
          d="M23.6163 16C25.3363 15.59 26.9063 16.94 27.1463 18.29C27.4763 20.18 26.5663 21.73 24.7263 22.02C23.1063 22.27 21.6863 21.53 21.1763 19.7C20.7963 18.3 21.6163 16.48 23.6163 16.01V16Z"
          fill="#2558A0"
        />
        <path
          d="M35.4991 16C37.2191 15.59 38.7891 16.94 39.0291 18.29C39.3591 20.18 38.4491 21.73 36.6091 22.02C34.9891 22.27 33.5691 21.53 33.0591 19.7C32.6791 18.3 33.4991 16.48 35.4991 16.01V16Z"
          fill="#2558A0"
        />
        <path
          d="M47.3741 16C49.0941 15.59 50.6641 16.94 50.9041 18.29C51.2341 20.18 50.3241 21.73 48.4841 22.02C46.8641 22.27 45.4441 21.53 44.9341 19.7C44.5541 18.3 45.3741 16.48 47.3741 16.01V16Z"
          fill="#2558A0"
        />
      </g>
      <defs>
        <clipPath id="clip0_10281_62976">
          <rect width="83.5" height="38" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const CmsAlertStandardIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 43 36" fill="none">
      <path
        d="M18.2213 32.5133L15.4554 36L13.2343 33.1499C12.7482 32.5259 11.952 31.6532 11.0635 31.6363L4.85706 31.5225C2.25042 31.4719 0 29.4397 0 26.7161V13.7389C0 11.108 2.19175 8.91144 4.84868 8.91144H26.0706C28.7191 8.91144 30.9318 11.0996 30.9318 13.7009V26.7456C30.9318 29.4355 28.6395 31.4888 26.0706 31.5267L20.0317 31.6068C19.5121 31.6152 18.5733 32.0748 18.2255 32.5133H18.2213ZM20.1323 29.7517L25.9406 29.6758C27.7133 29.6505 29.1591 28.352 29.1633 26.4589L29.201 14.1689C29.2052 12.1958 27.8013 10.678 25.8149 10.678H5.09174C3.6627 10.678 1.90259 11.7658 1.89421 13.2962L1.83135 26.5475C1.82297 28.2381 3.06762 29.6379 4.7942 29.6547L10.4433 29.7096C13.8923 29.7433 15.0992 33.1246 15.5267 32.8548C16.2601 32.3952 17.3957 29.7897 20.1323 29.7559V29.7517Z"
        fill="#80A5DD"
      />
      <path
        d="M20.1291 29.7517C17.3926 29.7854 16.2569 32.391 15.5235 32.8506C15.096 33.1204 13.8891 29.7348 10.4401 29.7053L4.79102 29.6505C3.06443 29.6337 1.81979 28.2381 1.82817 26.5432L1.89103 13.292C1.89941 11.7615 3.65952 10.678 5.08856 10.6738H25.8117C27.7982 10.6738 29.2062 12.1916 29.1979 14.1647L29.1601 26.4547C29.156 28.3477 27.706 29.6505 25.9375 29.6716L20.1291 29.7475V29.7517ZM8.56687 18.2164C7.28869 18.5579 6.71875 19.7637 7.12107 20.8894C7.45632 21.8212 8.42438 22.4157 9.63132 22.1037C10.4946 21.8844 11.2992 20.784 10.9598 19.6457C10.7041 18.7898 9.68999 17.9128 8.56687 18.2122V18.2164ZM15.0541 18.2206C13.7592 18.541 13.2521 19.7384 13.6125 20.8979C13.8975 21.8085 14.8907 22.4367 16.1018 22.0995C16.9525 21.8591 17.753 20.8262 17.4219 19.6752C17.1788 18.8235 16.1814 17.9381 15.0541 18.2206ZM21.5581 18.2164C20.2464 18.5326 19.7058 19.7258 19.9615 20.6365C20.2925 21.8381 21.2271 22.3229 22.2831 22.1585C23.4901 21.973 24.0852 20.9569 23.8672 19.7173C23.7122 18.832 22.6855 17.9466 21.5623 18.2164H21.5581Z"
        fill="white"
      />
      <path
        d="M5.5731 18.2164C6.69622 17.9171 7.71457 18.794 7.96601 19.6499C8.30546 20.7883 7.50084 21.8845 6.63755 22.1079C5.43062 22.4157 4.46256 21.8254 4.1273 20.8937C3.72499 19.768 4.29493 18.5622 5.5731 18.2206V18.2164Z"
        fill="#2558A0"
      />
      <path
        d="M11.1015 18.2145C12.2288 17.932 13.2262 18.8174 13.4693 19.669C13.7962 20.82 12.9999 21.853 12.1492 22.0933C10.9423 22.4306 9.94487 21.8024 9.6599 20.8917C9.2995 19.7281 9.80657 18.5349 11.1015 18.2145Z"
        fill="#2558A0"
      />
      <path
        d="M16.708 18.2114C17.8311 17.9415 18.8578 18.8269 19.0129 19.7123C19.2308 20.9518 18.6357 21.9679 17.4288 22.1534C16.3727 22.3179 15.4424 21.833 15.1071 20.6314C14.8557 19.7165 15.3921 18.5234 16.7038 18.2114H16.708Z"
        fill="#2558A0"
      />
      <path
        d="M34.575 27.7946C27.9383 30.0202 20.7467 25.1238 20.0643 18.2357C19.6744 14.3654 21.0842 10.8195 23.5814 8.36756C26.0785 5.91561 29.7156 4.54251 33.3601 5.13853C39.6968 6.17966 43.7238 11.7626 42.8914 18.2282C42.314 22.7171 39.1644 26.2555 34.575 27.7946Z"
        fill="#BE1E2D"
      />
      <path
        d="M34.575 27.7C27.9383 29.9164 20.7467 25.0403 20.0643 18.1808C19.6744 14.3266 21.0842 10.7954 23.5814 8.35359C26.0785 5.91181 29.7156 4.54441 33.3601 5.13795C39.6968 6.17477 43.7238 11.7345 42.8914 18.1733C42.314 22.6436 39.1644 26.1673 34.575 27.7Z"
        fill="#EF0117"
      />
      <path
        d="M32.1125 19.9332H30.8226L30.7551 19.3372L30.2302 14.7049L30.1477 13.9957L30.0727 13.3242L29.8028 10.7667C29.7203 9.98959 30.5152 9.00881 31.625 9.09934C32.6524 9.18233 33.3198 10.1707 33.1248 11.1741C33.0648 11.4683 33.0498 11.7625 33.0198 12.0568L32.9598 12.6L32.8849 13.2714L32.8099 13.9127L32.12 19.9181L32.1125 19.9332Z"
        fill="white"
      />
      <path
        d="M31.8376 24.1884C31.5902 24.2488 31.3727 24.2412 31.1477 24.1884C30.4428 24.0224 29.9854 23.3812 30.0004 22.672C30.0154 21.9628 30.5103 21.3592 31.2227 21.2385C32.1451 21.0801 32.9325 21.744 32.985 22.6418C33.0225 23.3585 32.5575 24.0224 31.8376 24.1809V24.1884Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ElderlyHomeIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 25 24" fill="none">
      <g clipPath="url(#clip0_10212_344625)">
        <path
          d="M22.5739 14.436L22.5429 22.936C22.5429 23.6413 21.8638 23.9784 21.2932 23.9815L4.04875 24.0001C3.36964 24.0001 2.47656 23.8887 2.47656 22.9422V14.0771C2.47656 13.2977 3.49368 13.0069 4.01154 13.1306C4.89842 13.3441 4.88601 14.0926 4.8364 14.8937C4.69996 17.0899 4.76818 19.283 4.81779 21.575H20.087C20.2265 20.5636 20.1738 19.5706 20.1893 18.519L20.2544 13.7864C20.2637 13.177 21.2312 13.0224 21.625 13.1368C22.1522 13.2915 22.5739 13.7214 22.5708 14.4391L22.5739 14.436Z"
          fill="#D81E06"
        />
        <path
          d="M15.4053 5.39454L12.4966 2.89525L1.87267 12.0573C1.33 12.5243 0.449328 12.0047 0.204352 11.6273C-0.198774 11.0056 0.0213945 10.4055 0.629184 9.87965L11.6159 0.399047C12.1431 -0.0556503 12.7354 -0.170098 13.3028 0.321718L24.457 9.95698C25.0183 10.4426 25.1578 11.0148 24.8198 11.6675C24.609 12.0758 23.657 12.5058 23.1236 12.048L15.4053 5.39763V5.39454Z"
          fill="#D81E06"
        />
        <path
          d="M17.519 13.8482C16.6538 15.4009 14.2444 17.3713 12.7156 18.5034C12.5171 18.6519 12.1791 18.4137 12.0334 18.2992C10.5263 17.0991 8.29673 15.3329 7.46567 13.7275C6.9416 12.7161 6.95401 11.5685 7.54009 10.5663C8.05795 9.67855 9.01615 9.03517 10.1542 8.98258C11.0566 8.93928 11.8566 9.37542 12.5326 9.92291C13.2025 9.35686 14.0428 8.92072 14.9886 8.99186C16.0895 9.07538 17.0291 9.7466 17.5128 10.5879C18.1268 11.6551 18.0834 12.8305 17.519 13.8513V13.8482Z"
          fill="#D81E06"
        />
      </g>
      <defs>
        <clipPath id="clip0_10212_344625">
          <rect width="25" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const TickIcon = (props) => {
  return (
    <SvgIcon {...props} width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" fill="white" />
      <path
        d="M20 10L11.75 19L8 14.9091"
        stroke="#34C759"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
